import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import ShiftTaskModal from "../../pages/ShiftTaskModal";
import AlertBox from "../../Components/AlertBox";
import { EyeIcon, EyeOffIcon } from "lucide-react"; // You can also use any icon library


const AddEmployee = () => {
  const emptyFormData = {
    company: "",
    teamMemberName: "",
    mobileNumber: "",
    emergencyMobileNumber: "",
    email: "",
    password: "",
    salary: "",
    pfEnabled: false,
    pfPercentage: 12,
    esicEnabled: false,
    esicPercentage: 3.25,
    dateOfJoining: "",
    shift: "",
    departments: [],
    designation: [],
    role: "",
    aadharNumber: "",
    adharImage: null,
    adharImagePreview: null,
    panNumber: "",
    userUpi: "",
    profileImage: null,
    profileImagePreview: null,
    panImage: null,
    panImagePreview: null,
    weeklyHoliday: [],
    address: "",
    isActive: true,
    locationTracking: false,
    isFieldWork: false,
    paidLeaves: [],
    documents: [],
  };

  const [employees, setEmployees] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [formData, setFormData] = useState(emptyFormData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [departmentFilter, setDepartmentFilter] = useState('');
  const [viewingEmployee, setViewingEmployee] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isPanImageModalOpen, setIsPanImageModalOpen] = useState(false);
  const [isAadharImageModalOpen, setIsAadharImageModalOpen] = useState(false);
  const [shifts, setShifts] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loadingLeaveTypes, setLoadingLeaveTypes] = useState(false);
  const [newPaidLeave, setNewPaidLeave] = useState({ type: '', count: 0 });
  const [newDocument, setNewDocument] = useState({ type: '', file: null });
  const [editingPaidLeaveIndex, setEditingPaidLeaveIndex] = useState(null);
  const [editingPaidLeave, setEditingPaidLeave] = useState({ type: '', count: 0 });
  const [documentsToRemove, setDocumentsToRemove] = useState([]);
  const [updatingEmployeeStatus, setUpdatingEmployeeStatus] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState(null);
  const [employeeCount, setEmployeeCount] = useState(0);
  const [skipEmployeeCountUpdate, setSkipEmployeeCountUpdate] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [branchCount, setBranchCount] = useState(0);
  const [totalBranchUserLimit, setTotalBranchUserLimit] = useState(0);
  const [allocationDetails, setAllocationDetails] = useState({
    totalLimit: 0,
    branchesUsed: 0,
    branchUserLimit: 0,
    employeesUsed: 0,
    remaining: 0,
    branchLimit: 0,
    branchesAvailable: 0
  });
  const [branchModuleAllocations, setBranchModuleAllocations] = useState({
    taskManagement: 0,
    leadManagement: 0,
    hrms: 0,
    support: 0,
    projectManagement: 0
  });
  const [companyAccessPermissions, setCompanyAccessPermissions] = useState({});


  // Validation Error State
  const [validationErrors, setValidationErrors] = useState({
    mobileNumber: '',
    emergencyMobileNumber: '',
    aadharNumber: '',
    panNumber: '',
    userUpi: '',
    salary: '',
    teamMemberName: ''
  });

  const [userAccess, setUserAccess] = useState({
    dashboard: false,
    lead_management: false,
    add_leads: false,
    link_generator: false,
    edit_lead: false,
    assign_lead: false,

    list_task: false,
    create_task: false,
    update_task: false,
    delete_task: false,
    shifted_task_history: false,
    shift_task: false,
    create_credit_points: false,
    task_performance: false,
    credit_points: false,

    settings: false,
    settings_category: false,
    settings_shift: false,
    settings_customer_group: false,
    settings_leave_type: false,
    reports: false,
    followup_report: false,
    task_report: false,
    leads_report: false,
    attendance_report: false,
    leave_report: false,
    payment_report: false,
    accounts: false,

    list_customer: false,
    create_customer: false,
    update_customer: false,
    delete_customer: false,

    list_teammember: false,
    create_teammember: false,
    update_teammember: false,
    delete_teammember: false,
    employee_report: false,

    daily_attendace: false,


    list_leave: false,
    create_leave: false,
    update_leave: false,
    delete_leave: false,
    leave_request: false,
    leave_approval: false,
    leave_type: false,

    list_franchise: false,
    create_franchise: false,
    update_franchise: false,
    delete_franchise: false,

    list_business: false,
    create_business: false,
    update_business: false,
    delete_business: false,

    // chat: false,
    //departments: false,
    create_department: false,
    // update_department: false,
    // delete_department: false,
    salary_generation: false,
    todo_list: false,
    user_profile: false,
    business_profile: false,

    project_dashboard: false,
    projects: false,
    project_employee_lists: false,
    project_tracker: false,
    project_tasks: false,
    project_reports: false,

    customer_support: false,
    com_tickets: false,
    sup_tickets: false,
    employee_performance: false
  });

  // State for menu usage tracking
  const [menuUsage, setMenuUsage] = useState({
    taskManagement: 0,
    leadManagement: 0,
    hrms: 0,
    support: 0,
    projectManagement: 0
  });

  // Permission mapping for module limits
  const permissionModuleMapping = {
    // HRMS Module
    'create_teammember': 'hrms', 'update_teammember': 'hrms', 'delete_teammember': 'hrms',
    'list_teammember': 'hrms', 'employee_report': 'hrms', 'daily_attendace': 'hrms',
    'attendance_report': 'hrms', 'settings_shift': 'hrms', 'leave_request': 'hrms',
    'leave_approval': 'hrms', 'leave_type': 'hrms', 'leave_report': 'hrms',
    'salary_generation': 'hrms', 'create_department': 'hrms', 'update_department': 'hrms',
    'update_leave': 'hrms',

    // Support Module
    'customer_support': 'support', 'com_tickets': 'support',
    'sup_tickets': 'support', 'employee_performance': 'support',

    // Task Management Module
    'list_task': 'taskManagement', 'create_task': 'taskManagement',
    'update_task': 'taskManagement', 'delete_task': 'taskManagement',
    'shifted_task_history': 'taskManagement', 'shift_task': 'taskManagement',
    'credit_points': 'taskManagement', 'create_credit_points': 'taskManagement',
    'task_performance': 'taskManagement',

    // Lead Management Module
    'lead_management': 'leadManagement', 'add_leads': 'leadManagement',
    'link_generator': 'leadManagement', 'edit_lead': 'leadManagement',
    'assign_lead': 'leadManagement',

    // Project Management Module
    'project_dashboard': 'projectManagement', 'projects': 'projectManagement',
    'project_employee_lists': 'projectManagement', 'project_tracker': 'projectManagement',
    'project_tasks': 'projectManagement', 'project_reports': 'projectManagement'
  };

  // Calculate menu usage when employees change
  useEffect(() => {
    if (!employees || employees.length === 0) {
      setMenuUsage({
        taskManagement: 0,
        leadManagement: 0,
        hrms: 0,
        support: 0,
        projectManagement: 0
      });
      return;
    }

    const newUsage = {
      taskManagement: 0,
      leadManagement: 0,
      hrms: 0,
      support: 0,
      projectManagement: 0
    };

    employees.forEach(employee => {
      // Skip inactive employees if that's the business rule
      if (employee.isActive === false) return;

      // ONLY count employees that belong directly to the selected company
      // This ensures that when viewing as Company Admin, we don't count branch employees
      // towards the Main Company's direct module usage.
      const employeeCompanyId = employee.company?._id || employee.company;
      if (selectedCompanyId && employeeCompanyId !== selectedCompanyId) return;

      // Access permissions can be array (from DB) or object (local state structure)
      // Usually from DB it comes as an array of strings
      const employeePermissions = Array.isArray(employee.accessPermissions)
        ? employee.accessPermissions
        : [];

      const usedModules = new Set();

      employeePermissions.forEach(permission => {
        const module = permissionModuleMapping[permission];
        if (module) {
          usedModules.add(module);
        }
      });

      usedModules.forEach(module => {
        if (newUsage[module] !== undefined) {
          newUsage[module]++;
        }
      });
    });

    setMenuUsage(newUsage);
    console.log('📊 Calculated Menu Usage:', newUsage);
  }, [employees, selectedCompanyId]);

  // Calculate total module limits allocated to all branches
  useEffect(() => {
    if (branches && branches.length > 0) {
      const allocations = {
        taskManagement: 0,
        leadManagement: 0,
        hrms: 0,
        support: 0,
        projectManagement: 0
      };

      branches.forEach(branch => {
        if (branch.businessSubscriptionPlan) {
          try {
            let planData = branch.businessSubscriptionPlan;
            if (typeof planData === 'string') {
              // Try to handle potential double-escaped JSON from backend
              try {
                planData = JSON.parse(planData.replace(/\\"/g, '"'));
              } catch (e) {
                planData = JSON.parse(planData);
              }
            }

            const data = planData.plan || planData;
            // Branch plans store their limits in 'userLimits' or 'moduleUserLimits'
            const limits = data.userLimits || data.moduleUserLimits || {};

            Object.keys(allocations).forEach(module => {
              allocations[module] += parseInt(limits[module]) || 0;
            });
          } catch (e) {
            console.error("❌ Error parsing branch subscription plan:", e);
          }
        }
      });

      console.log('Total Branch Module Allocations:', allocations);
      setBranchModuleAllocations(allocations);
    } else {
      setBranchModuleAllocations({
        taskManagement: 0,
        leadManagement: 0,
        hrms: 0,
        support: 0,
        projectManagement: 0
      });
    }
  }, [branches]);

  const [userRole, setUserRole] = useState(null);  // To store the user's role
  const [allCompanies, setAllCompanies] = useState([]);  // To store all companies for superadmins

  // Options for dropdowns
  const roles = ["Manager", "Employee"];
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const formRef = useRef(null);

  // Add after existing state declarations
  const [showInactiveModal, setShowInactiveModal] = useState(false);
  const [inactiveTasks, setInactiveTasks] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [employeeToToggle, setEmployeeToToggle] = useState(null);
  const [showShiftTaskModal, setShowShiftTaskModal] = useState(false);


  // Fetch incomplete tasks for an employee - FIXED VERSION
  const fetchEmployeeIncompleteTasks = async (employeeId) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setShowAlert("Authentication required. Please log in.");
      return [];
    }

    setLoadingTasks(true);
    try {

      // Fetch all tasks
      const response = await axios.get(
        'https://slateblue-mallard-430836.hostingersite.com/api/task/tasks',
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );


      // Handle different response structures
      let allTasks = [];

      if (Array.isArray(response.data)) {
        // If response.data is directly an array
        allTasks = response.data;
      } else if (response.data.tasks && Array.isArray(response.data.tasks)) {
        // If tasks are nested in a 'tasks' property
        allTasks = response.data.tasks;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        // If tasks are nested in a 'data' property
        allTasks = response.data.data;
      } else {
        console.error('❌ Unexpected response structure:', response.data);
        throw new Error('Unexpected API response structure');
      }

      // Filter incomplete tasks assigned to this employee
      const incompleteTasks = allTasks.filter(task => {
        if (!task) return false;

        // Check if task is assigned to this employee
        let isAssigned = false;

        if (Array.isArray(task.assignedTo)) {
          // assignedTo is an array
          isAssigned = task.assignedTo.some(assignee => {
            if (!assignee) return false;
            const assigneeId = typeof assignee === 'string' ? assignee : assignee._id;
            return assigneeId === employeeId;
          });
        } else if (task.assignedTo) {
          // assignedTo is a single value
          const assigneeId = typeof task.assignedTo === 'string'
            ? task.assignedTo
            : task.assignedTo?._id;
          isAssigned = assigneeId === employeeId;
        }

        // Check if task is incomplete
        const status = task.status?.toLowerCase() || '';
        const isIncomplete = status !== 'completed' && status !== 'cancelled';

        const shouldInclude = isAssigned && isIncomplete;



        return shouldInclude;
      });



      return incompleteTasks;

    } catch (err) {
      console.error('❌ Error fetching tasks:', err);
      console.error('Error details:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status
      });

      setShowAlert(`Failed to fetch tasks: ${err.response?.data?.message || err.message}`);
      return [];
    } finally {
      setLoadingTasks(false);
    }
  };

  const fetchSubscriptionPlan = async (companyId) => {
    const token = localStorage.getItem('authToken');
    if (!token || !companyId) return;

    try {
      // Get the company details which now includes subscription plan data directly
      const companyResponse = await axios.get(
        `https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const companyData = companyResponse.data;
      const businessSubscriptionPlan = companyData.businessSubscriptionPlan;
      const companyAssignedLimit = parseInt(companyData.userLimit) || 0;

      console.log('Company data fetched:', companyData);
      console.log('📦 Business Subscription Plan (raw):', businessSubscriptionPlan);
      console.log('Company Assigned Limit:', companyAssignedLimit);

      if (businessSubscriptionPlan) {
        try {
          let planDetails = null;
          let planId = null;

          // 1. Try to extract plan details and ID
          if (typeof businessSubscriptionPlan === 'string') {
            try {
              planDetails = JSON.parse(businessSubscriptionPlan);
              planId = planDetails._id || planDetails.id;
            } catch (e) {
              // If not JSON, it might be the ID itself
              if (/^[0-9a-fA-F]{24}$/.test(businessSubscriptionPlan)) {
                planId = businessSubscriptionPlan;
              }
            }
          } else if (typeof businessSubscriptionPlan === 'object') {
            planDetails = businessSubscriptionPlan;
            planId = planDetails._id || planDetails.id;
          }

          // 2. If we have an ID, ALWAYS try to fetch fresh plan data from backend
          // This ensures that if the plan was updated in Superadmin, we get the latest limits
          if (planId && /^[0-9a-fA-F]{24}$/.test(planId)) {
            console.log('„ Fetching latest plan data for ID:', planId);
            try {
              const planResponse = await axios.get(
                `https://slateblue-mallard-430836.hostingersite.com/api/subscription-plans/${planId}`,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              if (planResponse.data && planResponse.data.plan) {
                console.log('✅ Latest plan data fetched:', planResponse.data.plan);
                planDetails = planResponse.data.plan;
              }
            } catch (fetchErr) {
              console.warn('⚠️ Failed to fetch latest plan, falling back to stored details:', fetchErr.message);
            }
          }

          if (planDetails) {
            // Use company's own userLimit field if it's set and greater than 0, 
            // otherwise use plan's userLimit, or find max from module limits
            let calculatedUserLimit = companyAssignedLimit || parseInt(planDetails.userLimit) || 0;

            if (calculatedUserLimit === 0 && planDetails.userLimits && typeof planDetails.userLimits === 'object') {
              const limits = Object.values(planDetails.userLimits)
                .map(v => parseInt(v))
                .filter(v => !isNaN(v));
              if (limits.length > 0) {
                calculatedUserLimit = Math.max(...limits);
              }
            }

            const planData = {
              plan: {
                planName: planDetails.title || planDetails.planName,
                userLimit: calculatedUserLimit,
                branchLimit: parseInt(planDetails.branchLimit) || 0,
                price: parseFloat(planDetails.price) || 0,
                startDate: planDetails.startDate,
                endDate: planDetails.endDate,
                isBranch: planDetails.isBranch === true || planDetails.title === "Branch Plan",
                accessPermissions: planDetails.accessPermissions || {},
                userLimits: planDetails.userLimits || {}
              }
            };

            // If companyAssignedLimit is set, ensure module limits are at least that much if they were 0
            if (companyAssignedLimit > 0) {
              Object.keys(planData.plan.userLimits).forEach(module => {
                if (!planData.plan.userLimits[module]) {
                  planData.plan.userLimits[module] = companyAssignedLimit;
                }
              });
            }

            console.log('✅ Final subscription plan set:', planData);
            setSubscriptionPlan(planData);
            localStorage.setItem(`company_${companyId}_subscription`, JSON.stringify(planData));

            const branchData = await fetchBranchCount(companyId);
            setTotalBranchUserLimit(branchData.totalBranchUserLimit);
            return;
          }
        } catch (err) {
          console.error('❌ Error processing subscription plan:', err);
        }
      }

      // Fallback if no plan found or processing failed
      if (companyAssignedLimit > 0) {
        console.log('ℹ️ No valid subscription plan found, using company userLimit:', companyAssignedLimit);
        const fallbackPlan = {
          plan: {
            planName: "Assigned Plan",
            userLimit: companyAssignedLimit,
            branchLimit: 0,
            accessPermissions: { taskManagement: true, leadManagement: true, hrms: true, support: true, projectManagement: true },
            userLimits: {
              taskManagement: companyAssignedLimit,
              leadManagement: companyAssignedLimit,
              hrms: companyAssignedLimit,
              support: companyAssignedLimit,
              projectManagement: companyAssignedLimit
            }
          }
        };
        setSubscriptionPlan(fallbackPlan);
      } else {
        console.error('No subscription plan or user limit found for company');
        setSubscriptionPlan(null);
      }
    } catch (err) {
      console.error('Error fetching company details:', err);
      setSubscriptionPlan(null);
    }
  };

  // Fetch branches and calculate their total user limits
  const fetchBranchCount = async (companyId) => {
    const token = localStorage.getItem('authToken');
    if (!token || !companyId) return { count: 0, totalBranchUserLimit: 0, companyData: null };

    try {
      const response = await axios.get(
        `https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/branches`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log('Branches API response structure:', {
        hasCompany: !!response.data.company,
        hasBranches: !!response.data.branches,
        branchesCount: response.data.branches?.length || response.data?.length
      });

      const branchesData = response.data.branches || response.data || [];
      const branches = Array.isArray(branchesData) ? branchesData : [];
      const count = branches.length;

      // Try to extract parent company data from response
      let parentCompanyData = response.data.company || null;

      // If not in top level, check if branches have parent company reference
      if (!parentCompanyData && branches.length > 0) {
        for (const branch of branches) {
          if (branch.company && typeof branch.company === 'object' && branch.company.businessSubscriptionPlan) {
            parentCompanyData = branch.company;
            console.log('✅ Found parent company data in branch object!');
            break;
          }
        }
      }

      // Calculate total user limit and module allocations to branches
      let totalBranchUserLimit = 0;
      const allocations = {
        taskManagement: 0,
        leadManagement: 0,
        hrms: 0,
        support: 0,
        projectManagement: 0
      };

      branches.forEach(branch => {
        if (branch.businessSubscriptionPlan) {
          try {
            let branchPlan = branch.businessSubscriptionPlan;
            if (typeof branchPlan === 'string') {
              try {
                branchPlan = JSON.parse(branchPlan.replace(/\\"/g, '"'));
              } catch (e) {
                branchPlan = JSON.parse(branchPlan);
              }
            }

            const data = branchPlan.plan || branchPlan;
            // 1. Total user limit
            let branchLimit = parseInt(data.userLimit) || 0;

            // If userLimit is missing or looks like a sum of modules, use Math.max
            if (branchLimit === 0 && data.userLimits && typeof data.userLimits === 'object') {
              const limits = Object.values(data.userLimits)
                .map(v => parseInt(v))
                .filter(v => !isNaN(v));

              if (limits.length > 0) {
                branchLimit = Math.max(...limits);
              }
            }

            totalBranchUserLimit += branchLimit;

            // 2. Module specific limits
            const moduleLimits = data.userLimits || data.moduleUserLimits || {};
            const accessPermissions = data.accessPermissions || {};

            Object.keys(allocations).forEach(module => {
              // If the module is enabled for the branch, it subtracts from the main pool.
              // We use the specific module limit if set, otherwise we use the branch's total user limit
              // because those seats are reserved for that branch.
              if (accessPermissions[module]) {
                const specificLimit = parseInt(moduleLimits[module]) || 0;
                // If specific limit is 0 but module is enabled, it means the branch can use up to its full userLimit
                const allocation = specificLimit > 0 ? specificLimit : branchLimit;
                allocations[module] += allocation;
              }
            });

            console.log(`Branch "${branch.businessName}" has userLimit: ${branchLimit}`, moduleLimits);
          } catch (parseError) {
            console.error(`Error parsing subscription plan for branch ${branch.businessName}:`, parseError);
          }
        }
      });

      console.log('Branch Count:', count);
      console.log('Total Branch User Limit:', totalBranchUserLimit);
      console.log('Total Branch Module Allocations:', allocations);
      console.log('Parent Company Data Found:', !!parentCompanyData);

      setBranchCount(count);
      setBranches(branches); // Update global branches state
      setBranchModuleAllocations(allocations); // Update global allocations state

      return { count, totalBranchUserLimit, companyData: parentCompanyData, allocations };
    } catch (err) {
      console.error('Error fetching branch count:', err.response?.data || err.message);
      setBranchCount(0);
      return { count: 0, totalBranchUserLimit: 0, companyData: null };
    }
  };

  // Calculate allocation details with branch limit check
  const calculateAllocation = (userLimit, branches, employees, branchLimit = 0, branchUserLimit = 0) => {
    const totalLimit = parseInt(userLimit) || 0;
    const branchesUsed = parseInt(branches) || 0;
    const branchUserLimitTotal = parseInt(branchUserLimit) || 0;
    const employeesUsed = parseInt(employees) || 0;
    const maxBranches = parseInt(branchLimit) || 0;
    const remaining = totalLimit - branchUserLimitTotal - employeesUsed;

    const details = {
      totalLimit,
      branchesUsed,
      branchUserLimit: branchUserLimitTotal,
      employeesUsed,
      remaining: Math.max(0, remaining),
      branchLimit: maxBranches,
      branchesAvailable: maxBranches > 0 ? Math.max(0, maxBranches - branchesUsed) : 0
    };

    console.log('Allocation Details:', details);
    setAllocationDetails(details);
    return details;
  };



  const fetchEmployeeRecurringTasks = async (employeeId) => {
    const token = localStorage.getItem("authToken");
    if (!token) return [];

    try {
      const response = await axios.get(
        'https://slateblue-mallard-430836.hostingersite.com/api/task/tasks',
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const allTasks = response.data.tasks || response.data.data || response.data || [];

      // Filter recurring tasks assigned to this employee
      const recurringTasks = allTasks.filter(task => {
        const isAssigned = Array.isArray(task.assignedTo)
          ? task.assignedTo.some(a => (a._id || a) === employeeId)
          : (task.assignedTo?._id || task.assignedTo) === employeeId;

        return isAssigned && task.isRecurring === true && task.status !== 'cancelled';
      });

      return recurringTasks;
    } catch (err) {
      console.error('Error fetching recurring tasks:', err);
      return [];
    }
  };



  // Add this useEffect to check the user's role and set full access if needed
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const role = decoded.role ? decoded.role.toLowerCase() : "";  // Make case-insensitive
        setUserRole(role);
        if (role === "superadmin" || role === "company") {
          // Grant full access
          const fullAccess = {};
          for (const key in userAccess) {
            fullAccess[key] = true;
          }
          setUserAccess(fullAccess);
        } else {
          // For other roles (e.g., "employee"), apply permissions from token
          const permissionsFromToken = decoded.accessPermissions || [];  // Fallback to empty array if not present
          const updatedAccess = { ...userAccess };  // Start with default (all false)

          permissionsFromToken.forEach(permission => {
            const permissionKey = permission.toLowerCase();  // Normalize to lowercase for matching
            if (updatedAccess.hasOwnProperty(permissionKey)) {
              updatedAccess[permissionKey] = true;  // Set to true if it matches a key in userAccess
            } else {
              console.warn(`⚠️ Permission "${permissionKey}" from token does not match any key in userAccess`);
            }
          });

          setUserAccess(updatedAccess);  // Update state with the processed permissions
        }
      } catch (error) {
        console.error("Error decoding token for role check:", error);
        // Optionally handle error, e.g., redirect to login
      }
    }
  }, []);

  // Helper functions for new fields
  const addPaidLeave = async () => {
    console.log('ž• addPaidLeave called', { newPaidLeave, editingId });

    if (newPaidLeave.type && newPaidLeave.count > 0) {
      // Normalize values
      const normalizedType = newPaidLeave.type.toString().trim();
      const normalizedCount = parseInt(newPaidLeave.count);

      // Check if this leave type already exists
      const existingLeave = formData.paidLeaves.find(leave =>
        leave.type.toString().trim().toLowerCase() === normalizedType.toLowerCase()
      );

      if (existingLeave) {
        setMessage('❌ This leave type is already added. Please remove it first or choose a different type.');
        setShowAlert(true);
        return;
      }

      // Create the new leave object
      const newLeave = {
        type: normalizedType,
        count: normalizedCount
      };

      // If we're editing an existing employee, update the database
      if (editingId) {
        const token = localStorage.getItem("authToken");
        if (!token) {
          setMessage("❌ Authentication required to update database. Please log in.");
          setShowAlert(true);
          return;
        }

        try {
          // Create updated paidLeaves array with the new leave
          const updatedPaidLeaves = [...(formData.paidLeaves || []), newLeave];

          // Use simple JSON payload with required fields to satisfy backend validation
          const finalCompanyId = formData.company || selectedCompanyId;
          const updatePayload = {
            paidLeaves: updatedPaidLeaves,
            company: finalCompanyId,
            departments: formData.departments || [],
            designation: formData.designation || []
          };

          console.log('ž• Adding new leave - Payload:', updatePayload);

          const response = await axios.put(
            `https://slateblue-mallard-430836.hostingersite.com/api/employees/${editingId}`,
            updatePayload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
          );

          console.log('✅ Add leave API Response:', response.data);

          // Update local state after successful database update
          setFormData(prev => ({
            ...prev,
            paidLeaves: updatedPaidLeaves
          }));

          // Refresh employee list to show updated data
          fetchEmployees();

          // Reset form
          setNewPaidLeave({ type: '', count: 0 });

          // Show success message
          setMessage(`✅ "${normalizedType}" leave added successfully!`);
          setShowAlert(true);

        } catch (err) {
          console.error('❌ Error adding paid leave to database:', err);
          console.error('✅Error response:', err.response?.data);
          console.error('✅Error status:', err.response?.status);

          if (err.response?.status === 401 || err.response?.status === 403) {
            setMessage("❌ Authentication failed. Please log in again.");
            setShowAlert(true);
            localStorage.removeItem("authToken");
            window.location.href = '/login';
          } else {
            setMessage(`❌ Failed to add leave to database: ${err.response?.data?.message || err.message}`);
            setShowAlert(true);
          }
        }
      } else {
        // For new employees (not yet saved), just update local state
        setFormData(prev => ({
          ...prev,
          paidLeaves: [...(prev.paidLeaves || []), newLeave]
        }));
        setNewPaidLeave({ type: '', count: 0 });
        setMessage(`✅ "${normalizedType}" leave added successfully!`);
        setShowAlert(true);
      }
    } else {
      setMessage('❌ Please select a leave type and enter a count greater than 0.');
      setShowAlert(true);
    }
  };

  const removePaidLeave = async (index) => {
    const leaveToRemove = formData.paidLeaves[index];

    // Show confirmation dialog
    const confirmRemoval = window.confirm(
      `Are you sure you want to remove "${leaveToRemove.type}" leave (${leaveToRemove.count} days)?`
    );

    if (!confirmRemoval) {
      return;
    }

    // If we're editing an existing employee, update the database
    if (editingId) {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setMessage("❌ Authentication required to update database. Please log in.");
        setShowAlert(true);
        return;
      }

      try {

        // Update the paidLeaves array by removing the item
        const updatedPaidLeaves = formData.paidLeaves.filter((_, i) => i !== index);

        // Include company, departments and designation to satisfy backend validation
        const finalCompanyId = formData.company || selectedCompanyId;
        const updatePayload = {
          paidLeaves: updatedPaidLeaves,
          company: finalCompanyId,
          departments: formData.departments || [],
          designation: formData.designation || []
        };


        const response = await axios.put(
          `https://slateblue-mallard-430836.hostingersite.com/api/employees/${editingId}`,
          updatePayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        // Update local state after successful database update
        setFormData(prev => ({
          ...prev,
          paidLeaves: updatedPaidLeaves
        }));

        // Refresh employee list to show updated data
        fetchEmployees();

        // Show success message
        setMessage(`✅ "${leaveToRemove.type}" leave removed successfully!`);
        setShowAlert(true);

      } catch (err) {
        console.error('❌ Error removing paid leave from database:', err);
        console.error('✅Error response:', err.response?.data);
        console.error('✅Error status:', err.response?.status);

        if (err.response?.status === 401 || err.response?.status === 403) {
          setMessage("❌ Authentication failed. Please log in again.");
          setShowAlert(true);
          localStorage.removeItem("authToken");
          window.location.href = '/login';
        } else {
          setMessage(`❌ Failed to remove leave from database: ${err.response?.data?.message || err.message}`);
          setShowAlert(true);
        }
      }
    } else {
      // For new employees (not yet saved), just update local state
      setFormData(prev => ({
        ...prev,
        paidLeaves: (prev.paidLeaves || []).filter((_, i) => i !== index)
      }));

    }
  };

  const startEditPaidLeave = (index) => {
    const leaveToEdit = formData.paidLeaves[index];
    setEditingPaidLeaveIndex(index);
    setEditingPaidLeave({ type: leaveToEdit.type, count: leaveToEdit.count });
  };

  const saveEditPaidLeave = async () => {
    console.log(' saveEditPaidLeave called', { editingPaidLeaveIndex, editingPaidLeave });

    // Validation
    if (!editingPaidLeave.type || editingPaidLeave.count <= 0) {
      setMessage('❌ Please select a leave type and enter a count greater than 0.');
      setShowAlert(true);
      return;
    }

    // Normalize values
    const normalizedType = editingPaidLeave.type.toString().trim();
    const normalizedCount = parseInt(editingPaidLeave.count);

    // Check for duplicates (excluding current index)
    const existingLeave = formData.paidLeaves.find((leave, idx) =>
      idx !== editingPaidLeaveIndex &&
      leave.type.toString().trim().toLowerCase() === normalizedType.toLowerCase()
    );

    if (existingLeave) {
      setMessage('❌ This leave type is already added. Please choose a different type.');
      setShowAlert(true);
      return;
    }

    // Update paidLeaves array with _id preservation
    const updatedPaidLeaves = formData.paidLeaves.map((leave, index) =>
      index === editingPaidLeaveIndex
        ? {
          ...leave, // Preserve existing properties including _id
          type: normalizedType,
          count: normalizedCount
        }
        : leave
    );

    console.log(' Updated paid leaves:', updatedPaidLeaves);

    // If editing existing employee, update database
    if (editingId) {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setMessage("❌ Authentication required to update database. Please log in.");
        setShowAlert(true);
        return;
      }

      try {
        // Use simple JSON payload with required fields to satisfy backend validation
        const finalCompanyId = formData.company || selectedCompanyId;
        const updatePayload = {
          paidLeaves: updatedPaidLeaves,
          company: finalCompanyId,
          departments: formData.departments || [],
          designation: formData.designation || []
        };

        const response = await axios.put(
          `https://slateblue-mallard-430836.hostingersite.com/api/employees/${editingId}`,
          updatePayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('✅ Paid leave updated successfully:', response.data);

        // Refresh employee list after successful update
        fetchEmployees();
      } catch (err) {
        console.error('❌ Error updating paid leave:', err);
        console.error('✅Error response:', err.response?.data);
        console.error('✅Error status:', err.response?.status);

        if (err.response?.status === 401 || err.response?.status === 403) {
          setMessage("❌ Authentication failed. Please log in again.");
          setShowAlert(true);
          localStorage.removeItem("authToken");
          window.location.href = '/login';
          return;
        } else {
          setMessage(`❌ Failed to update leave: ${err.response?.data?.message || err.message}`);
          setShowAlert(true);
          return;
        }
      }
    }

    // Update local state (for both new and existing employees)
    setFormData(prev => ({
      ...prev,
      paidLeaves: updatedPaidLeaves
    }));

    // Reset editing state
    setEditingPaidLeaveIndex(null);
    setEditingPaidLeave({ type: '', count: 0 });

    // Show success message
    setMessage(`✅ "${normalizedType}" leave updated to ${normalizedCount} days successfully!`);
    setShowAlert(true);
  };

  const cancelEditPaidLeave = () => {
    setEditingPaidLeaveIndex(null);
    setEditingPaidLeave({ type: '', count: 0 });
  };

  // Add ref for file input reset (add this state near other states)
  const fileInputRef = useRef(null);

  // Updated addDocument function
  const addDocument = () => {
    if (newDocument.type && newDocument.file) {
      // Validate file is actual File object
      if (!(newDocument.file instanceof File)) {
        setShowAlert('Invalid file selected. Please choose a valid file.');
        return;
      }

      // Check if this document type already exists (case-insensitive)
      const existingDoc = formData.documents.find(doc =>
        doc.type && doc.type.toLowerCase() === newDocument.type.toLowerCase()
      );
      if (existingDoc) {
        setShowAlert('This document type is already added. Please remove it first or choose a different type.');
        return;
      }

      const documentEntry = {
        type: newDocument.type.trim(),
        file: newDocument.file,  // Ensure File object is preserved
        uploadedAt: new Date().toLocaleDateString('en-US', {
          year: 'numeric', month: '2-digit', day: '2-digit'
        })  // Local date string (fixes future date issue)
      };

      setFormData(prev => ({
        ...prev,
        documents: [...(prev.documents || []), documentEntry]
      }));

      // Reset form and file input
      setNewDocument({ type: '', file: null });
      if (fileInputRef.current) {
        fileInputRef.current.value = '';  // Clear file input visually
      }

    } else {
      console.warn('⚠️ addDocument failed: Missing type or file', { type: newDocument.type, hasFile: !!newDocument.file });
      setShowAlert('Please enter a document type and select a file.');
    }
  };


  const removeDocument = (index) => {
    const docToRemove = formData.documents[index];

    // For new employees (not saved), just remove locally
    if (!editingId) {
      setFormData(prev => ({
        ...prev,
        documents: (prev.documents || []).filter((_, i) => i !== index)
      }));
      return;
    }

    // For editing existing employee: Mark for backend removal (don't delete file yet)
    if (editingId && window.confirm(`Remove "${docToRemove.type}" document? This will delete the file from storage.`)) {
      setDocumentsToRemove(prev => [...prev, docToRemove.type]);  // Mark type for removal
      setFormData(prev => ({
        ...prev,
        documents: (prev.documents || []).filter((_, i) => i !== index)  // Remove from local preview
      }));
    }
  };


  // Function to convert 24-hour time to 12-hour format
  const convertTo12Hour = (time24) => {
    if (!time24) return 'N/A';

    let cleanTime = time24.toString().trim();
    let isPM = false;
    let hasAMPM = false;

    if (/\bPM\b/i.test(cleanTime)) {
      isPM = true;
      hasAMPM = true;
      cleanTime = cleanTime.replace(/\s*PM\s*/gi, '');
    } else if (/\bAM\b/i.test(cleanTime)) {
      hasAMPM = true;
      cleanTime = cleanTime.replace(/\s*AM\s*/gi, '');
    }

    try {
      const [hours, minutes] = cleanTime.split(':');
      let hour = parseInt(hours, 10);
      const minute = minutes || '00';

      if (isNaN(hour)) return time24;

      if (hasAMPM) {
        if (hour === 0) hour = 12;
        return `${hour}:${minute} ${isPM ? 'PM' : 'AM'}`;
      }

      if (hour === 0) {
        return `12:${minute} AM`;
      } else if (hour < 12) {
        return `${hour}:${minute} AM`;
      } else if (hour === 12) {
        return `12:${minute} PM`;
      } else {
        return `${hour - 12}:${minute} PM`;
      }
    } catch (error) {
      console.error('Error converting time:', error);
      return time24; // Return original time if conversion fails
    }
  };

  const getDepartmentNames = (deptIdsOrId) => {
    if (!deptIdsOrId) return ['N/A'];

    let ids = [];
    if (Array.isArray(deptIdsOrId)) {
      // Handle array - check for comma-separated strings within the array
      ids = deptIdsOrId.flatMap(item => {
        if (typeof item === 'string' && item.includes(',')) {
          return item.split(',').map(id => id.trim());
        }
        return item;
      });
    } else if (deptIdsOrId) {
      // Handle single value - check if it's comma-separated
      if (typeof deptIdsOrId === 'string' && deptIdsOrId.includes(',')) {
        ids = deptIdsOrId.split(',').map(id => id.trim());
      } else {
        ids = [deptIdsOrId];
      }
    }

    if (departments.length === 0) {
      if (ids.length > 0) {
        console.warn('Departments not loaded yet. Raw IDs:', ids);
        return ids.map(id => `ID: ${String(id)}`);
      }
      return ['Loading departments...'];
    }

    // Convert all IDs to strings for safe comparison
    const stringIds = ids.map(id => String(id).trim());

    const names = stringIds.map(idStr => {
      const trimmedId = idStr;

      // Try to find department by ID
      let dept = departments.find(d => String(d._id).trim() === trimmedId);

      if (dept) {
        return dept.name;
      } else {
        console.warn(`Department ID not found: ${trimmedId}`);
        return `Unknown (${trimmedId})`;
      }
    });

    // Remove duplicates and undefined values
    return [...new Set(names.filter(name => name !== undefined && name !== ''))];
  };
  // Add this helper function near your other helper functions
  const getEmployeeDepartmentNames = (employee) => {
    if (!employee) return ['N/A'];

    // Get department IDs from employee
    let deptIds = [];
    if (Array.isArray(employee.departments) && employee.departments.length > 0) {
      deptIds = employee.departments;
    } else if (employee.department) {
      deptIds = Array.isArray(employee.department) ? employee.department : [employee.department];
    }

    if (deptIds.length === 0) return ['N/A'];
    if (departments.length === 0) return ['Loading...'];

    // Map IDs to names
    const names = deptIds.map(id => {
      const dept = departments.find(d => String(d._id) === String(id));
      return dept ? dept.name : `Unknown (${id})`;
    });

    return names.filter(name => name && name !== '');
  };
  const debugEmployeeDepartments = (employee) => {
    console.log('Employee:', employee.teamMemberName);
    console.log('Raw departments data:', employee.departments);
    console.log('Raw department data:', employee.department);
    console.log('Available departments:', departments);

    if (Array.isArray(employee.departments)) {
      employee.departments.forEach((deptId, index) => {
        const dept = departments.find(d => String(d._id) === String(deptId));
        console.log(`Dept ${index + 1}: ID=${deptId}, Found=${!!dept}, Name=${dept?.name}`);
      });
    }
  };

  const getDesignationNames = (desigIdsOrId) => {
    if (!desigIdsOrId) return ['N/A'];

    let ids = [];
    if (Array.isArray(desigIdsOrId)) {
      ids = desigIdsOrId;
    } else if (desigIdsOrId) {
      ids = [desigIdsOrId];
    }

    if (designations.length === 0) {
      if (ids.length > 0) {
        console.warn('Designations not loaded yet. Raw IDs:', ids); // Debug log
        return ids.map(id => `ID: ${String(id)}`);
      }
      return ['Loading designations...'];
    }

    // Convert all IDs to strings for safe comparison
    const stringIds = ids.map(id => String(id).trim());

    const names = stringIds.slice(0, 2).map(idStr => {
      const trimmedId = idStr; // Already trimmed
      const desig = designations.find(d => String(d._id).trim() === trimmedId);
      if (desig) {
        return desig.name;
      } else {
        console.warn(`Designation ID not found: ${trimmedId}. Available desigs:`, designations.map(d => String(d._id))); // Debug log
        return `Unknown (${trimmedId})`;
      }
    });

    if (stringIds.length > 2) {
      names.push(`+${stringIds.length - 2} more`);
    }

    return names;
  };


  // Initial chained loading (async)
  useEffect(() => {
    const loadInitialData = async () => {
      setLoading(true);
      try {
        // Step 1: Fetch companies first (sets selectedCompanyId and localStorage)
        await fetchCompanies();

        // Step 2: Now that companyId is set, fetch departments and branches
        if (selectedCompanyId) {
          await fetchDepartments(selectedCompanyId);
          await fetchBranches(selectedCompanyId);
        }

        // Step 3: Fetch shifts (independent)
        await fetchShifts();

        // Step 3.5: Fetch leave types (independent) - only if companyId is available
        if (selectedCompanyId) {
          await fetchLeaveTypes();
        }

        // Step 4: Fetch employees (now departments are ready for name lookup)
        await fetchEmployees();

        // Step 5: Fetch designations after departments
        await fetchDesignations();

        // Mark initial load as complete
        setIsInitialLoad(false);
      } catch (err) {
        console.error('Error in initial data load:', err);
        setError('Failed to load initial data. Please refresh the page.');
        setIsInitialLoad(false);
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, []); // Empty dependency: runs once on mount


  useEffect(() => {
    if (selectedCompanyId) {
      fetchDepartments(selectedCompanyId);
      fetchDesignations();
      fetchLeaveTypes();
      fetchBranches(selectedCompanyId); // Add this to ensure branch allocations are loaded
      fetchSubscriptionPlan(selectedCompanyId);
    } else {
      setDepartments([]);
      setDesignations([]);
      setLeaveTypes([]);
      setSubscriptionPlan(null); // Reset subscription plan
      setBranchCount(0);
      setTotalBranchUserLimit(0);
      // Only reset employee count if this is not during initial load
      if (!isInitialLoad) {
        setEmployeeCount(0);
      }
      setAllocationDetails({
        totalLimit: 0,
        branchesUsed: 0,
        branchUserLimit: 0,
        employeesUsed: 0,
        remaining: 0,
        branchLimit: 0,
        branchesAvailable: 0
      });
    }
  }, [selectedCompanyId]);

  // Update allocation when employee count or branch count changes
  useEffect(() => {
    if (subscriptionPlan && subscriptionPlan.plan) {
      calculateAllocation(subscriptionPlan.plan.userLimit, branchCount, employeeCount, subscriptionPlan.plan.branchLimit, totalBranchUserLimit);
    }
  }, [employeeCount, branchCount, subscriptionPlan, totalBranchUserLimit]);


  useEffect(() => {
    if (formData.departments && formData.departments.length > 0) {
      fetchDesignations();
    } else {
      setDesignations([]);
    }
  }, [formData.departments]);

  // Fetch company subscription data for employees using accessible endpoint
  const fetchCompanyDataForEmployee = async (companyId, token) => {
    try {
      console.log('📊 [EMPLOYEE] Fetching company subscription data...', companyId);
      const decoded = jwtDecode(token);
      const employeeId = decoded.id;

      // **NEW: Method 0 - Try direct company API with employee token**
      try {
        console.log('[METHOD 0] Trying direct company API with employee token...');
        const companyResponse = await axios.get(
          `https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (companyResponse.data && companyResponse.data.businessSubscriptionPlan) {
          console.log('✅ [SUCCESS METHOD 0] Got company data directly!');
          const companyData = companyResponse.data;

          if (companyData.businessName) {
            localStorage.setItem("selectedCompanyName", companyData.businessName);
          }

          const businessPlan = companyData.businessSubscriptionPlan;
          const companyAssignedLimit = parseInt(companyData.userLimit) || 0;
          let planData = typeof businessPlan === 'string' ? JSON.parse(businessPlan) : businessPlan;
          let planId = planData?._id || planData?.id || (typeof businessPlan === 'string' && /^[0-9a-fA-F]{24}$/.test(businessPlan) ? businessPlan : null);

          // ALWAYS try to fetch fresh plan data from backend
          if (planId && /^[0-9a-fA-F]{24}$/.test(planId)) {
            try {
              const planResponse = await axios.get(
                `https://slateblue-mallard-430836.hostingersite.com/api/subscription-plans/${planId}`,
                { headers: { Authorization: `Bearer ${token}` } }
              );
              if (planResponse.data && planResponse.data.plan) {
                planData = planResponse.data.plan;
              }
            } catch (fetchErr) {
              console.warn('⚠️ Failed to fetch latest plan:', fetchErr.message);
            }
          }

          let calculatedUserLimit = companyAssignedLimit || parseInt(planData.userLimit) || 0;
          if (calculatedUserLimit === 0 && planData.userLimits) {
            const limits = Object.values(planData.userLimits).map(v => parseInt(v)).filter(v => !isNaN(v));
            if (limits.length > 0) calculatedUserLimit = Math.max(...limits);
          }

          const formattedPlan = {
            plan: {
              planName: planData.title || planData.planName,
              userLimit: calculatedUserLimit,
              branchLimit: parseInt(planData.branchLimit) || 0,
              price: parseFloat(planData.price) || 0,
              startDate: planData.startDate,
              endDate: planData.endDate,
              accessPermissions: planData.accessPermissions || {},
              userLimits: planData.userLimits || {}
            }
          };

          // If companyAssignedLimit is set, ensure module limits are at least that much if they were 0
          if (companyAssignedLimit > 0) {
            Object.keys(formattedPlan.plan.userLimits).forEach(module => {
              if (!formattedPlan.plan.userLimits[module]) {
                formattedPlan.plan.userLimits[module] = companyAssignedLimit;
              }
            });
          }

          setSubscriptionPlan(formattedPlan);
          setCompanyAccessPermissions(planData.accessPermissions || {
            hrms: true,
            support: true,
            taskManagement: true,
            leadManagement: true,
            projectManagement: true
          });

          // Fetch branch count
          const branchData = await fetchBranchCount(companyId);
          setTotalBranchUserLimit(branchData.totalBranchUserLimit);

          // Store in localStorage
          localStorage.setItem(`company_${companyId}_subscription`, JSON.stringify(formattedPlan));

          await fetchEmployees();
          return true;
        }
      } catch (directErr) {
        console.log('⚠️ [METHOD 0] Direct company API failed:', directErr.response?.status);
        // Continue to other methods
      }

      // Method 1: Try employee's own profile
      try {
        console.log('[METHOD 1] Fetching employee profile:', employeeId);
        const profileResponse = await axios.get(
          `https://slateblue-mallard-430836.hostingersite.com/api/employees/${employeeId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        console.log('Profile response - Company type:', typeof profileResponse.data.company);

        if (profileResponse.data && profileResponse.data.company && typeof profileResponse.data.company === 'object') {
          const companyData = profileResponse.data.company;
          console.log('📦 Company object found with subscription:', !!companyData.businessSubscriptionPlan);

          if (companyData.businessSubscriptionPlan) {
            console.log('✅ [SUCCESS METHOD 1] Got subscription from employee profile!');

            if (companyData.businessName) {
              localStorage.setItem("selectedCompanyName", companyData.businessName);
            }

            const businessPlan = companyData.businessSubscriptionPlan;
            const planData = typeof businessPlan === 'string' ? JSON.parse(businessPlan) : businessPlan;

            console.log('📋 Plan data:', planData);
            console.log('Branch Limit from planData:', planData.branchLimit);
            console.log('All planData keys:', Object.keys(planData));

            // Try multiple possible field names for branch limit
            const branchLimitValue = planData.branchLimit ||
              planData.branchLimits ||
              planData.maxBranches ||
              planData.branches ||
              10; // Default to 10 if not found

            const formattedPlan = {
              plan: {
                planName: planData.title || planData.planName,
                userLimit: parseInt(planData.userLimit) || 0,
                branchLimit: parseInt(branchLimitValue) || 10,
                price: parseFloat(planData.price) || 0,
                startDate: planData.startDate,
                endDate: planData.endDate,
                accessPermissions: planData.accessPermissions || {},
                userLimits: planData.userLimits || {}
              }
            };

            console.log('✅ Setting subscription plan:', formattedPlan);
            console.log('Formatted branchLimit:', formattedPlan.plan.branchLimit);
            setSubscriptionPlan(formattedPlan);
            setCompanyAccessPermissions(planData.accessPermissions || {
              hrms: true,
              support: true,
              taskManagement: true,
              leadManagement: true,
              projectManagement: true
            });

            // Fetch branch count for allocation
            const branchData = await fetchBranchCount(companyId);
            setTotalBranchUserLimit(branchData.totalBranchUserLimit);

            // Fetch employees to populate the employee list
            await fetchEmployees();

            return true; // Success
          }
        }
        console.log('⚠️ [METHOD 1] Company not populated in profile');
      } catch (profileErr) {
        console.log('❌ [METHOD 1 FAILED]:', profileErr.response?.status, profileErr.message);
      }

      // Method 2: Try localStorage (shared by company login)
      try {
        console.log('[METHOD 2] Checking localStorage for company subscription...');
        const storedPlan = localStorage.getItem(`company_${companyId}_subscription`);

        if (storedPlan) {
          const planData = JSON.parse(storedPlan);
          // Only use if it has real userLimits (non-empty object)
          const hasRealLimits = planData.plan?.userLimits &&
            Object.keys(planData.plan.userLimits).length > 0;

          if (hasRealLimits) {
            console.log('✅ [SUCCESS METHOD 2] Found subscription with userLimits in localStorage!');
            setSubscriptionPlan(planData);
            setCompanyAccessPermissions(planData.plan.accessPermissions || {
              hrms: true,
              support: true,
              taskManagement: true,
              leadManagement: true,
              projectManagement: true
            });

            // Fetch branch count for allocation
            const branchData = await fetchBranchCount(companyId);
            setTotalBranchUserLimit(branchData.totalBranchUserLimit);

            // Fetch employees to populate the employee list
            await fetchEmployees();

            return true; // Success
          } else {
            console.log('⚠️ [METHOD 2] localStorage plan has no userLimits - trying other methods');
          }
        } else {
          console.log('⚠️ [METHOD 2] No subscription data in localStorage');
        }
      } catch (storageErr) {
        console.log('❌ [METHOD 2 FAILED]:', storageErr.message);
      }

      // Method 2b: Try "companySubscriptionPlan" stored by login page (company admin's raw plan)
      try {
        console.log('[METHOD 2b] Checking login-stored companySubscriptionPlan...');
        const storedRawPlan = localStorage.getItem("companySubscriptionPlan");

        if (storedRawPlan) {
          let rawPlan = JSON.parse(storedRawPlan);
          // Handle double-encoding: login page stores JSON.stringify(businessSubscriptionPlan)
          // If businessSubscriptionPlan is itself a JSON string, it will be double-encoded
          if (typeof rawPlan === 'string') {
            rawPlan = JSON.parse(rawPlan);
          }

          if (rawPlan && typeof rawPlan === 'object' && rawPlan.userLimits && Object.keys(rawPlan.userLimits).length > 0) {
            console.log('✅ [SUCCESS METHOD 2b] Found subscription in login-stored companySubscriptionPlan!');

            const formattedPlan = {
              plan: {
                planName: rawPlan.title || rawPlan.planName,
                userLimit: parseInt(rawPlan.userLimit) || 0,
                branchLimit: parseInt(rawPlan.branchLimit) || 0,
                price: parseFloat(rawPlan.price) || 0,
                startDate: rawPlan.startDate,
                endDate: rawPlan.endDate,
                accessPermissions: rawPlan.accessPermissions || {},
                userLimits: rawPlan.userLimits
              }
            };

            setSubscriptionPlan(formattedPlan);
            setCompanyAccessPermissions(rawPlan.accessPermissions || {
              hrms: true,
              support: true,
              taskManagement: true,
              leadManagement: true,
              projectManagement: true
            });

            // Cache with companyId key so future visits skip this method
            localStorage.setItem(`company_${companyId}_subscription`, JSON.stringify(formattedPlan));

            const branchData = await fetchBranchCount(companyId);
            setTotalBranchUserLimit(branchData.totalBranchUserLimit);
            await fetchEmployees();
            return true;
          } else {
            console.log('⚠️ [METHOD 2b] Login-stored plan has no userLimits');
          }
        } else {
          console.log('⚠️ [METHOD 2b] No companySubscriptionPlan in localStorage');
        }
      } catch (rawPlanErr) {
        console.log('❌ [METHOD 2b FAILED]:', rawPlanErr.message);
      }

      // Method 3: Get branches and extract parent company data
      try {
        console.log('[METHOD 3] Fetching branches to get company data...');
        const branchData = await fetchBranchCount(companyId);

        if (branchData.companyData && branchData.companyData.businessSubscriptionPlan) {
          console.log('✅ [SUCCESS METHOD 3] Found company data from branches!');
          const companyData = branchData.companyData;

          if (companyData.businessName) {
            localStorage.setItem("selectedCompanyName", companyData.businessName);
          }

          const businessPlan = companyData.businessSubscriptionPlan;
          const planData = typeof businessPlan === 'string' ? JSON.parse(businessPlan) : businessPlan;

          // Try multiple possible field names for branch limit
          const branchLimitValue = planData.branchLimit ||
            planData.branchLimits ||
            planData.maxBranches ||
            planData.branches ||
            10; // Default to 10 if not found

          const formattedPlan = {
            plan: {
              planName: planData.title || planData.planName,
              userLimit: parseInt(planData.userLimit) || 0,
              branchLimit: parseInt(branchLimitValue) || 10,
              price: parseFloat(planData.price) || 0,
              startDate: planData.startDate,
              endDate: planData.endDate,
              accessPermissions: planData.accessPermissions || {},
              userLimits: planData.userLimits || {}
            }
          };

          console.log('✅ Setting subscription plan:', formattedPlan);
          setSubscriptionPlan(formattedPlan);
          setCompanyAccessPermissions(planData.accessPermissions || {
            hrms: true,
            support: true,
            taskManagement: true,
            leadManagement: true,
            projectManagement: true
          });

          setTotalBranchUserLimit(branchData.totalBranchUserLimit);

          // Store in localStorage for future use
          localStorage.setItem(`company_${companyId}_subscription`, JSON.stringify(formattedPlan));

          // Fetch employees to populate the employee list
          await fetchEmployees();

          return true; // Success
        } else {
          console.log('⚠️ [METHOD 3] Parent company data not in branches response');
        }
      } catch (branchErr) {
        console.log('❌ [METHOD 3 FAILED]:', branchErr.message);
      }

      // Method 4: Try employee list endpoint — check if any employee has company populated
      try {
        console.log('[METHOD 4] Fetching employee list to find company subscription data...');
        const empListResponse = await axios.get(
          `https://slateblue-mallard-430836.hostingersite.com/api/employees/company/${companyId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (empListResponse.data && Array.isArray(empListResponse.data)) {
          for (const emp of empListResponse.data) {
            if (emp.company && typeof emp.company === 'object' && emp.company.businessSubscriptionPlan) {
              console.log('✅ [SUCCESS METHOD 4] Found company subscription from employee list!');
              const companyData = emp.company;

              if (companyData.businessName) {
                localStorage.setItem("selectedCompanyName", companyData.businessName);
              }

              const businessPlan = companyData.businessSubscriptionPlan;
              const planData = typeof businessPlan === 'string' ? JSON.parse(businessPlan) : businessPlan;

              const formattedPlan = {
                plan: {
                  planName: planData.title || planData.planName,
                  userLimit: parseInt(planData.userLimit) || 0,
                  branchLimit: parseInt(planData.branchLimit) || 0,
                  price: parseFloat(planData.price) || 0,
                  startDate: planData.startDate,
                  endDate: planData.endDate,
                  accessPermissions: planData.accessPermissions || {},
                  userLimits: planData.userLimits || {}
                }
              };

              setSubscriptionPlan(formattedPlan);
              setCompanyAccessPermissions(planData.accessPermissions || {
                hrms: true,
                support: true,
                taskManagement: true,
                leadManagement: true,
                projectManagement: true
              });

              // Store in localStorage so future employee logins can use it
              localStorage.setItem(`company_${companyId}_subscription`, JSON.stringify(formattedPlan));

              const branchData = await fetchBranchCount(companyId);
              setTotalBranchUserLimit(branchData.totalBranchUserLimit);

              await fetchEmployees();
              return true;
            }
          }
          console.log('⚠️ [METHOD 4] Employee list fetched but company not populated in any employee');
        }
      } catch (empListErr) {
        console.log('❌ [METHOD 4 FAILED]:', empListErr.response?.status, empListErr.message);
      }

      // Second try: Get data from company's subscription endpoint with employee token
      try {
        const companyResponse = await axios.get(
          `https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/subscription`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        console.log(' Company subscription response:', companyResponse.data);

        if (companyResponse.data && companyResponse.data.businessSubscriptionPlan) {
          const companyData = companyResponse.data;

          if (companyData.businessName) {
            localStorage.setItem("selectedCompanyName", companyData.businessName);
          }

          const businessPlan = companyData.businessSubscriptionPlan;
          const planData = typeof businessPlan === 'string' ? JSON.parse(businessPlan) : businessPlan;

          const formattedPlan = {
            plan: {
              planName: planData.title || planData.planName,
              userLimit: parseInt(planData.userLimit) || 0,
              branchLimit: parseInt(planData.branchLimit) || 0,
              price: parseFloat(planData.price) || 0,
              startDate: planData.startDate,
              endDate: planData.endDate,
              accessPermissions: planData.accessPermissions || {},
              userLimits: planData.userLimits || {}
            }
          };

          setSubscriptionPlan(formattedPlan);
          setCompanyAccessPermissions(planData.accessPermissions || {
            hrms: true,
            support: true,
            taskManagement: true,
            leadManagement: true,
            projectManagement: true
          });

          // Calculate branch allocations
          const branchData = await fetchBranchCount(companyId);
          setTotalBranchUserLimit(branchData.totalBranchUserLimit);
          return;
        }
      } catch (subErr) {
        console.log('⚠️ Company subscription endpoint not accessible:', subErr.message);
      }

      // Third try: Get data from branches endpoint
      try {
        const branchResponse = await axios.get(
          `https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/branches`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        console.log('📦 Branches response:', branchResponse.data);

        // Extract company data if populated
        let companyData = branchResponse.data.company || null;

        if (!companyData && branchResponse.data.branches && branchResponse.data.branches.length > 0) {
          // Check if any branch has company data
          for (const branch of branchResponse.data.branches) {
            if (branch.company && typeof branch.company === 'object') {
              companyData = branch.company;
              break;
            }
          }
        }

        if (companyData && companyData.businessSubscriptionPlan) {
          console.log('✅ Got company data from branches:', companyData);

          if (companyData.businessName) {
            localStorage.setItem("selectedCompanyName", companyData.businessName);
          }

          const businessPlan = companyData.businessSubscriptionPlan;
          const planData = typeof businessPlan === 'string' ? JSON.parse(businessPlan) : businessPlan;

          const formattedPlan = {
            plan: {
              planName: planData.title || planData.planName,
              userLimit: parseInt(planData.userLimit) || 0,
              branchLimit: parseInt(planData.branchLimit) || 0,
              price: parseFloat(planData.price) || 0,
              startDate: planData.startDate,
              endDate: planData.endDate,
              accessPermissions: planData.accessPermissions || {},
              userLimits: planData.userLimits || {}
            }
          };

          setSubscriptionPlan(formattedPlan);
          setCompanyAccessPermissions(planData.accessPermissions || {
            hrms: true,
            support: true,
            taskManagement: true,
            leadManagement: true,
            projectManagement: true
          });

          // Calculate branch allocations
          const branchData = await fetchBranchCount(companyId);
          setTotalBranchUserLimit(branchData.totalBranchUserLimit);
          return;
        }
      } catch (branchErr) {
        console.log('⚠️ Could not fetch from branches endpoint:', branchErr.message);
      }

      // All methods failed
      console.log('❌ [ALL METHODS FAILED] Could not fetch company subscription data');
      console.log('⚠️ Backend needs to populate company field in employee responses');
      console.log('⚠️ Required: .populate("company") in /api/employees endpoints');

      // Set a default fallback plan so module cards still render for employees
      const fallbackPlan = {
        plan: {
          planName: 'Default',
          userLimit: 0,
          branchLimit: 0,
          price: 0,
          accessPermissions: {
            hrms: true,
            support: true,
            taskManagement: true,
            leadManagement: true,
            projectManagement: true
          },
          userLimits: {}
        }
      };
      setSubscriptionPlan(fallbackPlan);
      setCompanyAccessPermissions({
        hrms: true,
        support: true,
        taskManagement: true,
        leadManagement: true,
        projectManagement: true
      });

      return false; // Failed

    } catch (err) {
      console.error('❌ [FATAL ERROR] Exception in fetchCompanyDataForEmployee:', err);
      const fallbackPlan = {
        plan: {
          planName: 'Default',
          userLimit: 0,
          branchLimit: 0,
          price: 0,
          accessPermissions: {
            hrms: true,
            support: true,
            taskManagement: true,
            leadManagement: true,
            projectManagement: true
          },
          userLimits: {}
        }
      };
      setSubscriptionPlan(fallbackPlan);
      setCompanyAccessPermissions({
        hrms: true,
        support: true,
        taskManagement: true,
        leadManagement: true,
        projectManagement: true
      });
      return false;
    }
  };

  // Helper to check menu limits
  const checkMenuLimit = (moduleName) => {
    // If no plan, assume no access or strictly follow boolean permissions (fallback)
    if (!subscriptionPlan || !subscriptionPlan.plan) {
      return { hasLimit: false, isExceeded: false, remaining: Infinity, total: Infinity, used: 0, enabled: false, masterTotal: 0, branchAllocated: 0 };
    }

    // 1. Check if module is enabled in accessPermissions
    const isEnabled = subscriptionPlan.plan.accessPermissions?.[moduleName];
    if (!isEnabled) {
      return { hasLimit: false, isExceeded: true, remaining: 0, total: 0, used: 0, enabled: false, masterTotal: 0, branchAllocated: 0 };
    }

    // 2. Check specific user limit for this module
    const userLimits = subscriptionPlan.plan.userLimits || {};
    const limitVal = userLimits[moduleName];

    // Determine if this is a company plan (main company) or a branch plan
    const plan = subscriptionPlan.plan || {};
    const planName = (plan.planName || plan.title || "").toString();
    const isBranch = plan.isBranch === true || planName.includes("Branch Plan");

    // Company plans usually have a branchLimit > 0, whereas branches have 0
    const isCompanyPlan = (plan.branchLimit > 0) || !isBranch;

    const currentUsed = menuUsage[moduleName] || 0;

    // If limit is null, undefined, or empty string, treat as UNLIMITED (no specific limit)
    // The module is enabled via accessPermissions, so allow unlimited access
    if (limitVal === null || limitVal === '' || limitVal === undefined) {
      return {
        hasLimit: false,  // No specific limit set
        isExceeded: false,  // Cannot exceed unlimited
        remaining: Infinity,  // Unlimited remaining
        total: Infinity,  // Unlimited total
        used: currentUsed,
        enabled: true,  // Module is enabled
        masterTotal: Infinity,
        branchAllocated: 0
      };
    }

    // Parse the limit value
    let masterTotal = parseInt(limitVal);
    if (isNaN(masterTotal) || masterTotal <= 0) {
      // Invalid limit value, treat as unlimited
      return {
        hasLimit: false,
        isExceeded: false,
        remaining: Infinity,
        total: Infinity,
        used: currentUsed,
        enabled: true,
        masterTotal: Infinity,
        branchAllocated: 0
      };
    }

    let branchAllocated = 0;

    // IF we are in company view (Company Plan), get the branch allocations
    if (isCompanyPlan) {
      branchAllocated = branchModuleAllocations[moduleName] || 0;
    }

    // New logic: total is the Master Plan limit
    // Remaining is Master - Used - BranchAllocated
    const remaining = masterTotal - currentUsed - branchAllocated;
    const isExceeded = remaining <= 0;

    return {
      hasLimit: true,
      total: masterTotal, // Use master total as the main total display
      used: currentUsed,
      remaining: remaining,
      isExceeded: isExceeded,
      enabled: true,
      masterTotal: masterTotal,
      branchAllocated: branchAllocated,
      companyPool: masterTotal - branchAllocated // Still keep this for detail
    };
  };

  const fetchCompanies = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setError("No access token found. Please log in.");
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const role = decoded.role ? decoded.role.toLowerCase() : "";

      if (role === "superadmin") {
        // Fetch all companies for superadmin
        const response = await axios.get("https://slateblue-mallard-430836.hostingersite.com/api/companies", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAllCompanies(response.data);  // Store all companies
        // Do not set selectedCompanyId here; let the user select it
      } else {
        const companyId = decoded.companyId || decoded.id;
        if (companyId) {
          try {
            const response = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            setCompanies([response.data]);  // For non-superadmins, set as before
            setSelectedCompanyId(response.data._id);
            setFormData(prev => ({ ...prev, company: response.data._id }));
            localStorage.setItem("selectedCompanyId", response.data._id);
            localStorage.setItem("selectedCompanyName", response.data.businessName);

            // Extract company access permissions from subscription plan
            const businessPlan = response.data.businessSubscriptionPlan;
            if (businessPlan) {
              try {
                const planData = typeof businessPlan === 'string' ? JSON.parse(businessPlan) : businessPlan;
                setCompanyAccessPermissions(planData.accessPermissions || {});
                console.log('Company Access Permissions:', planData.accessPermissions);

                // **FIX: Store subscription plan in localStorage for employee access**
                const formattedPlan = {
                  plan: {
                    planName: planData.title || planData.planName,
                    userLimit: parseInt(planData.userLimit) || 0,
                    branchLimit: parseInt(planData.branchLimit) || 0,
                    price: parseFloat(planData.price) || 0,
                    startDate: planData.startDate,
                    endDate: planData.endDate,
                    accessPermissions: planData.accessPermissions || {},
                    userLimits: planData.userLimits || {}
                  }
                };

                // Store in localStorage so employees can access same data
                localStorage.setItem(`company_${response.data._id}_subscription`, JSON.stringify(formattedPlan));
                console.log('✅ Stored company subscription plan in localStorage for employee access');

              } catch (err) {
                console.error('Error parsing subscription plan:', err);
                setCompanyAccessPermissions({});
              }
            }
          } catch (fetchErr) {
            // If employee doesn't have access to company API (401/403), fetch via alternate method
            if (fetchErr.response?.status === 401 || fetchErr.response?.status === 403) {
              console.log('Employee detected - fetching company data via accessible endpoint');
              setSelectedCompanyId(companyId);
              setFormData(prev => ({ ...prev, company: companyId }));
              localStorage.setItem("selectedCompanyId", companyId);

              // Fetch company subscription data for employee
              const success = await fetchCompanyDataForEmployee(companyId, token);

              // If we got the subscription plan, also fetch branches for allocation calculation
              if (success) {
                console.log('✅ Successfully fetched company data for employee');
              } else {
                console.log('⚠️ Could not fetch company subscription - using employee view');
              }
            } else {
              throw fetchErr;
            }
          }
        } else {
          setError("No companyId found in token.");
        }
      }
    } catch (err) {
      console.error("Error fetching companies:", err);
      setError(`Failed to fetch companies: ${err.response?.data?.message || err.message}`);
    }
  };

  const fetchBranches = async (companyId) => {
    const token = localStorage.getItem("authToken");
    if (!token || !companyId) {
      setBranches([]);
      return;
    }

    try {
      const response = await axios.get(
        `https://slateblue-mallard-430836.hostingersite.com/api/companies/${companyId}/branches`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setBranches(response.data || []);
    } catch (err) {
      console.error("❌ Error fetching branches:", err.response?.data || err.message);
      if (err.response?.status === 401 || err.response?.status === 403) {
        setBranches([]);
      } else {
        setBranches([]);
      }
    }
  };

  // Re-render table when employees or departments change (ensures names update)
  useEffect(() => {
    if (employees.length > 0 && departments.length > 0) {
    }
  }, [employees, departments]);



  const fetchEmployees = async () => {
    const token = localStorage.getItem("authToken");
    const companyId = localStorage.getItem("selectedCompanyId");

    if (!token) {
      setError("No access token found. Please log in.");
      setLoading(false);
      return;
    }

    if (!companyId) {
      setError("No company selected. Please select a company first.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`https://slateblue-mallard-430836.hostingersite.com/api/employees/company/${companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const processedEmployees = response.data.map(employee => {
        let processedDepartments = [];

        if (Array.isArray(employee.departments)) {
          // Handle array case - flatten and split comma-separated strings
          processedDepartments = employee.departments
            .flat(Infinity)
            .map(item => {
              if (typeof item === 'string' && item.includes(',')) {
                // Split comma-separated string into individual IDs
                return item.split(',').map(id => id.trim());
              }
              return item;
            })
            .flat() // Flatten the array again after splitting
            .map(id => {
              if (typeof id === 'object' && id && id._id) {
                return String(id._id).trim();
              } else if (typeof id === 'string') {
                return id.trim();
              } else {
                return String(id).trim();
              }
            })
            .filter(id => id && id !== '');
        } else if (employee.department) {
          // Handle legacy single value
          if (typeof employee.department === 'string' && employee.department.includes(',')) {
            // Split comma-separated string
            processedDepartments = employee.department.split(',').map(id => id.trim());
          } else {
            const deptId = typeof employee.department === 'object' && employee.department._id
              ? String(employee.department._id).trim()
              : String(employee.department).trim();
            processedDepartments = deptId ? [deptId] : [];
          }
        }

        console.log('🔧 Normalized departments for', employee.teamMemberName, ':', processedDepartments);

        return {
          ...employee,
          isActive: Boolean(employee.isActive),
          // ADD: Ensure deduction fields are properly typed
          pfEnabled: employee.pfEnabled === true || employee.pfEnabled === 'true',
          pfPercentage: employee.pfPercentage !== null && employee.pfPercentage !== undefined ? parseFloat(employee.pfPercentage) : 12,
          esicEnabled: employee.esicEnabled === true || employee.esicEnabled === 'true',
          esicPercentage: employee.esicPercentage !== null && employee.esicPercentage !== undefined ? parseFloat(employee.esicPercentage) : 3.25,
          departments: processedDepartments,
          weeklyHoliday: (() => {
            console.log('—ï Raw weeklyHoliday from backend:', employee.weeklyHoliday, 'Type:', typeof employee.weeklyHoliday);
            if (Array.isArray(employee.weeklyHoliday)) {
              console.log('✅ weeklyHoliday is already array:', employee.weeklyHoliday);
              return employee.weeklyHoliday;
            } else if (typeof employee.weeklyHoliday === 'string') {
              try {
                const parsed = JSON.parse(employee.weeklyHoliday);
                console.log('✅ Parsed weeklyHoliday from string:', parsed);
                return Array.isArray(parsed) ? parsed : [];
              } catch (e) {
                console.log('❌ Failed to parse weeklyHoliday:', e);
                return [];
              }
            }
            console.log('⚠️ weeklyHoliday is neither array nor string, defaulting to []');
            return [];
          })(),

        };
      });

      setEmployees(processedEmployees);
      const fetchedEmployeeCount = processedEmployees.length;
      // Only update employee count if we're not skipping the update (prevents overriding immediate updates)
      if (!skipEmployeeCountUpdate) {
        setEmployeeCount(fetchedEmployeeCount);
        // Recalculate allocation if subscription plan is available
        if (subscriptionPlan && subscriptionPlan.plan) {
          calculateAllocation(subscriptionPlan.plan.userLimit, branchCount, fetchedEmployeeCount, subscriptionPlan.plan.branchLimit, totalBranchUserLimit);
        }
      } else {
        // Reset the skip flag after one cycle
        setSkipEmployeeCountUpdate(false);
      }

    } catch (err) {
      console.error("❌ Error fetching employees:", err.response?.data || err.message);
      setError(`Failed to fetch employees: ${err.response?.data?.message || err.message || "Unable to connect to server"}`);
    } finally {
      setLoading(false);
    }
  };


  const fetchDepartments = async (companyId) => {
    if (!companyId) return;

    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.get(
        `https://slateblue-mallard-430836.hostingersite.com/api/departments/company/${companyId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDepartments(response.data);
    } catch (err) {
      console.error("Error fetching departments:", err.response?.data || err.message);
      setDepartments([]);
    }
  };


  const fetchShifts = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.warn("⚠️ No access token found for fetching shifts. Using local fallback.");
      return;
    }

    try {
      const response = await axios.get(
        'https://slateblue-mallard-430836.hostingersite.com/api/shifts/',
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setShifts(response.data);
    } catch (err) {
      console.error("❌ Error fetching shifts:", err);
      if (err.response?.status === 401 || err.response?.status === 403) {
        console.warn(" Authentication error for shifts. Using local fallback.");
        setShifts([]);
      } else {
        setError("Failed to fetch shifts. Using default shifts.");
      }
    }
  };

  const fetchLeaveTypes = async (companyIdParam = null) => {
    setLoadingLeaveTypes(true);
    // Try all possible token keys used across app
    const token =
      localStorage.getItem("authToken") ||
      localStorage.getItem("accessToken") ||
      localStorage.getItem("token");

    let companyId = companyIdParam || localStorage.getItem("selectedCompanyId") || formData.company;

    // If no companyId yet, try decoding from token
    if (!companyId && token) {
      try {
        const decoded = jwtDecode(token);
        companyId =
          decoded.companyId ||
          decoded.company?._id ||
          decoded.company ||
          decoded.orgId ||
          decoded.organizationId ||
          decoded.id;
      } catch (e) {
        console.warn("⚠️ Error decoding token for companyId in fetchLeaveTypes:", e);
      }
    }

    if (!companyId) {
      console.warn("⚠️ No company ID available for fetching leave types. Using default list.");
      setLeaveTypes([
        { _id: 'casual', leaveType: 'Casual Leave' },
        { _id: 'sick', leaveType: 'Sick Leave' },
        { _id: 'annual', leaveType: 'Annual Leave' }
      ]);
      setLoadingLeaveTypes(false);
      return;
    }

    if (!token) {
      console.warn("⚠️ No token found for fetching leave types. Using default list.");
      setLeaveTypes([
        { _id: 'casual', leaveType: 'Casual Leave' },
        { _id: 'sick', leaveType: 'Sick Leave' },
        { _id: 'annual', leaveType: 'Annual Leave' }
      ]);
      setLoadingLeaveTypes(false);
      return;
    }

    try {
      const response = await axios.get(
        `https://slateblue-mallard-430836.hostingersite.com/api/leave-types/company/${companyId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      let data = [];
      if (Array.isArray(response.data)) {
        data = response.data;
      } else if (Array.isArray(response.data?.leaveTypes)) {
        data = response.data.leaveTypes;
      } else if (Array.isArray(response.data?.data)) {
        data = response.data.data;
      } else {
        console.warn("Unexpected leave types response format:", response.data);
        data = [];
      }

      setLeaveTypes(data);
    } catch (err) {
      console.error("❌ Error fetching leave types:", err);
      // Provide sensible defaults if API fails
      setLeaveTypes([
        { _id: 'casual', leaveType: 'Casual Leave' },
        { _id: 'sick', leaveType: 'Sick Leave' },
        { _id: 'annual', leaveType: 'Annual Leave' }
      ]);
    } finally {
      setLoadingLeaveTypes(false);
    }
  };

  const fetchDesignations = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      console.error("No access token found for fetching designations.");
      return;
    }

    let decoded;
    try {
      decoded = jwtDecode(token);
    } catch (err) {
      console.error("Invalid token:", err);
      localStorage.removeItem("authToken");
      setError("Invalid token. Please log in again.");
      return;
    }

    try {
      const response = await axios.get(
        `https://slateblue-mallard-430836.hostingersite.com/api/designations/`,
        { headers: { Authorization: `Bearer ${token}` } }
      );


      // Handle different response structures
      let designationsData = [];
      if (Array.isArray(response.data)) {
        designationsData = response.data;
      } else if (response.data && Array.isArray(response.data.designations)) {
        designationsData = response.data.designations;
      } else if (response.data && Array.isArray(response.data.data)) {
        designationsData = response.data.data;
      }

      // Filter designations by selected departments if departments are selected
      if (formData.departments && formData.departments.length > 0) {
        designationsData = designationsData.filter(designation =>
          formData.departments.includes(designation.department?._id) ||
          formData.departments.includes(designation.department)
        );
      }

      setDesignations(designationsData);
    } catch (err) {
      console.error("Error fetching designations:", err.response?.data || err.message);
      if (err.response?.status === 401) {
        localStorage.removeItem("authToken");
        setError("Session expired. Please log in again.");
        window.location.href = '/login';
        return;
      }
      setDesignations([]);
    }
  };


  // Validation Functions
  const validateMobileNumber = (value) => {
    // Remove all non-numeric characters
    const numericValue = value.replace(/\D/g, '');

    if (numericValue.length === 0) {
      return { isValid: true, message: '', cleanValue: '' };
    }

    if (numericValue.length > 10) {
      return { isValid: false, message: 'Mobile number cannot exceed 10 digits', cleanValue: numericValue.slice(0, 10) };
    }

    if (numericValue.length < 10 && numericValue.length > 0) {
      return { isValid: false, message: 'Please enter a valid 10-digit mobile number', cleanValue: numericValue };
    }

    if (numericValue.length === 10) {
      return { isValid: true, message: '', cleanValue: numericValue };
    }

    return { isValid: false, message: 'Please enter only numbers', cleanValue: numericValue };
  };

  const validateAadharNumber = (value) => {
    // Remove all non-numeric characters
    const numericValue = value.replace(/\D/g, '');

    if (numericValue.length === 0) {
      return { isValid: true, message: '', cleanValue: '' };
    }

    if (numericValue.length > 12) {
      return { isValid: false, message: 'Aadhar number cannot exceed 12 digits', cleanValue: numericValue.slice(0, 12) };
    }

    if (numericValue.length < 12 && numericValue.length > 0) {
      return { isValid: false, message: 'Please enter a valid 12-digit Aadhar number', cleanValue: numericValue };
    }

    if (numericValue.length === 12) {
      return { isValid: true, message: '', cleanValue: numericValue };
    }

    return { isValid: false, message: 'Please enter only numbers', cleanValue: numericValue };
  };

  const validatePANNumber = (value) => {
    // Convert to uppercase and remove spaces
    const cleanValue = value.toUpperCase().replace(/\s/g, '');

    if (cleanValue.length === 0) {
      return { isValid: true, message: '', cleanValue: '' };
    }

    // PAN format: 5 letters + 4 digits + 1 letter (e.g., ABCDE1234F)
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (cleanValue.length > 10) {
      return { isValid: false, message: 'PAN number cannot exceed 10 characters', cleanValue: cleanValue.slice(0, 10) };
    }

    if (cleanValue.length === 10) {
      if (panRegex.test(cleanValue)) {
        return { isValid: true, message: '', cleanValue: cleanValue };
      } else {
        return { isValid: false, message: 'Invalid PAN format. Format: ABCDE1234F', cleanValue: cleanValue };
      }
    }

    if (cleanValue.length < 10 && cleanValue.length > 0) {
      // Check partial format
      const partialPanRegex = /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/;
      if (partialPanRegex.test(cleanValue)) {
        return { isValid: false, message: 'Please enter complete PAN number (10 characters)', cleanValue: cleanValue };
      } else {
        return { isValid: false, message: 'Invalid PAN format. Use only letters and numbers', cleanValue: cleanValue };
      }
    }

    return { isValid: false, message: 'Invalid PAN format. Format: ABCDE1234F', cleanValue: cleanValue };
  };

  const validateUPI = (value) => {
    // Remove spaces
    const cleanValue = value.toLowerCase().replace(/\s/g, '');

    if (cleanValue.length === 0) {
      return { isValid: true, message: '', cleanValue: '' };
    }

    // UPI format: username@bankname (e.g., user@paytm, 9876543210@ybl)
    const upiRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+$/;

    if (cleanValue.includes('@')) {
      if (upiRegex.test(cleanValue)) {
        const parts = cleanValue.split('@');
        if (parts[0].length > 0 && parts[1].length > 0) {
          return { isValid: true, message: '', cleanValue: cleanValue };
        }
      }
      return { isValid: false, message: 'Invalid UPI format. Format: username@bankname', cleanValue: cleanValue };
    } else {
      if (cleanValue.length > 0) {
        return { isValid: false, message: 'UPI ID must contain @ symbol. Format: username@bankname', cleanValue: cleanValue };
      }
    }

    return { isValid: true, message: '', cleanValue: cleanValue };
  };

  const validateSalary = (value) => {
    // Remove all non-numeric characters except decimal point
    const numericValue = value.replace(/[^0-9.]/g, '');

    if (numericValue.length === 0) {
      return { isValid: true, message: '', cleanValue: '' };
    }

    // Check for multiple decimal points
    const decimalCount = (numericValue.match(/\./g) || []).length;
    if (decimalCount > 1) {
      return { isValid: false, message: 'Please enter a valid salary amount', cleanValue: numericValue.substring(0, numericValue.lastIndexOf('.')) };
    }

    // Validate numeric format
    const salaryRegex = /^[0-9]+(\.[0-9]{0,2})?$/;
    if (numericValue.length > 0 && !salaryRegex.test(numericValue)) {
      return { isValid: false, message: 'Please enter only numbers for salary', cleanValue: numericValue.replace(/[^0-9.]/g, '') };
    }

    // Check for reasonable salary range (optional)
    const salaryAmount = parseFloat(numericValue);
    if (salaryAmount > 10000000) { // 1 crore limit
      return { isValid: false, message: 'Salary amount seems too high', cleanValue: numericValue };
    }

    return { isValid: true, message: '', cleanValue: numericValue };
  };

  const validateTeamMemberName = (value) => {
    const cleanValue = value;

    if (cleanValue.length === 0) {
      return { isValid: true, message: '', cleanValue: '' };
    }

    // Check for numbers in the name
    const hasNumbers = /[0-9]/.test(cleanValue);
    if (hasNumbers) {
      // Remove numbers and return cleaned value
      const nameWithoutNumbers = cleanValue.replace(/[0-9]/g, '');
      return { isValid: false, message: 'Name should not contain numbers', cleanValue: nameWithoutNumbers };
    }

    // Check for special characters (allow only letters, spaces, dots, apostrophes, hyphens)
    const nameRegex = /^[a-zA-Z\s.'\-]+$/;
    if (!nameRegex.test(cleanValue)) {
      // Remove invalid characters
      const cleanedName = cleanValue.replace(/[^a-zA-Z\s.'\-]/g, '');
      return { isValid: false, message: 'Name should contain only letters, spaces, and basic punctuation', cleanValue: cleanedName };
    }

    // Check minimum length
    if (cleanValue.length < 2) {
      return { isValid: false, message: 'Name should be at least 2 characters long', cleanValue: cleanValue };
    }

    // Check maximum length
    if (cleanValue.length > 50) {
      return { isValid: false, message: 'Name should not exceed 50 characters', cleanValue: cleanValue.substring(0, 50) };
    }

    return { isValid: true, message: '', cleanValue: cleanValue };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    let newErrors = { ...validationErrors };

    // Apply validation based on field type
    if (name === 'mobileNumber' || name === 'emergencyMobileNumber') {
      const validation = validateMobileNumber(value);
      processedValue = validation.cleanValue;
      newErrors[name] = validation.message;
    } else if (name === 'aadharNumber') {
      const validation = validateAadharNumber(value);
      processedValue = validation.cleanValue;
      newErrors[name] = validation.message;
    } else if (name === 'panNumber') {
      const validation = validatePANNumber(value);
      processedValue = validation.cleanValue;
      newErrors[name] = validation.message;
    } else if (name === 'userUpi') {
      const validation = validateUPI(value);
      processedValue = validation.cleanValue;
      newErrors[name] = validation.message;
    } else if (name === 'salary') {
      const validation = validateSalary(value);
      processedValue = validation.cleanValue;
      newErrors[name] = validation.message;
    } else if (name === 'teamMemberName') {
      const validation = validateTeamMemberName(value);
      processedValue = validation.cleanValue;
      newErrors[name] = validation.message;
    }

    // Update validation errors
    setValidationErrors(newErrors);

    // If departments change, clear designation and fetch new designations
    if (name === 'departments') {
      setFormData({ ...formData, [name]: processedValue, designation: '' });
    } else {
      setFormData({ ...formData, [name]: processedValue });
    }
  };

  const handleDepartmentChange = (e) => {
    const { value, checked } = e.target;


    // Ensure we start with a valid array
    const currentDepartments = Array.isArray(formData.departments) ? formData.departments : [];

    let updatedDepartments;
    if (checked) {
      // Add to array, prevent duplicates and ensure valid values
      const validValue = value && value.trim() !== '' ? value.trim() : null;
      if (validValue && !currentDepartments.includes(validValue)) {
        updatedDepartments = [...currentDepartments, validValue];
      } else {
        updatedDepartments = currentDepartments;
      }
    } else {
      // Remove from array
      updatedDepartments = currentDepartments.filter((dept) => dept !== value);
    }


    // Find department names for better logging
    const departmentNames = updatedDepartments.map(deptId => {
      const dept = departments.find(d => d._id === deptId);
      return dept ? dept.name : 'Unknown';
    });

    setFormData({
      ...formData,
      departments: updatedDepartments, // Always set as array
      designation: [] // Clear designation when departments change (also ensure array)
    });
  };

  const handleDesignationChange = (e) => {
    const { value, checked } = e.target;


    let updatedDesignations;
    if (checked) {
      // Add to array, prevent duplicates using Set
      const uniqueDesigs = new Set([...formData.designation, value]);
      updatedDesignations = Array.from(uniqueDesigs);
    } else {
      // Remove from array
      updatedDesignations = formData.designation.filter((desig) => desig !== value);
    }


    // Find designation names for better logging
    const designationNames = updatedDesignations.map(desigId => {
      const desig = designations.find(d => d._id === desigId);
      return desig ? desig.name : 'Unknown';
    });


    setFormData({
      ...formData,
      designation: updatedDesignations, // Always set as array
    });
  };



  const handleDayChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFormData({
        ...formData,
        weeklyHoliday: [...formData.weeklyHoliday, value],
      });
    } else {
      setFormData({
        ...formData,
        weeklyHoliday: formData.weeklyHoliday.filter((day) => day !== value),
      });
    }
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setFormData(prev => ({
        ...prev,
        profileImage: file,
        profileImagePreview: URL.createObjectURL(file)
      }));
    }
  };

  const handlePanImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setFormData(prev => ({
        ...prev,
        panImage: file,
        panImagePreview: URL.createObjectURL(file)
      }));
    }
  };

  const handleAadharImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setFormData(prev => ({
        ...prev,
        adharImage: file,
        adharImagePreview: URL.createObjectURL(file)
      }));
    }
  };

  // Handle permission change
  const handlePermissionChange = (e) => {
    const { name, checked } = e.target;
    setUserAccess(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  // Handle section-wise select all/deselect all
  const handleSectionSelectAll = (sectionPermissions, checked) => {

    setUserAccess(prev => {
      const updated = { ...prev };
      sectionPermissions.forEach(permission => {
        updated[permission] = checked;
      });

      return updated;
    });
  };

  // Check if all permissions in a section are selected
  const isSectionAllSelected = (sectionPermissions) => {
    return sectionPermissions.every(permission => userAccess[permission]);
  };

  // Check if some permissions in a section are selected (for indeterminate state)
  const isSectionPartiallySelected = (sectionPermissions) => {
    const selectedCount = sectionPermissions.filter(permission => userAccess[permission]).length;
    return selectedCount > 0 && selectedCount < sectionPermissions.length;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Enable validation error display on submit attempt
    setShowValidationErrors(true);

    const token = localStorage.getItem("authToken");
    if (!token) {
      setMessage("❌ Access token not found. Please log in.");
      return;
    }


    // Validate user limit for new employee additions with branch allocation
    if (!editingId && subscriptionPlan) {
      // Access the nested plan object
      const plan = subscriptionPlan.plan || subscriptionPlan;
      const userLimit = plan.userLimit;
      const planTitle = plan.planName || plan.title || 'Current Plan';

      console.log('Subscription Plan Check:', {
        plan,
        userLimit,
        planTitle,
        employeeCount,
        branchCount,
        allocationDetails
      });

      // Check if subscription plan data is valid
      if (!userLimit) {
        console.error('Invalid subscription plan data - missing userLimit:', subscriptionPlan);
        setMessage('Error: Subscription plan does not have a user limit. Please contact support.');
        setShowAlert(true);
        return;
      }

      // Check if remaining allocation is available
      if (allocationDetails.remaining <= 0) {
        setMessage(
          `❌ Cannot add employee. User limit exhausted!\n\n` +
          `📊 Subscription Plan: ${planTitle}\n` +
          `📈 Total User Limit: ${allocationDetails.totalLimit}\n` +
          `Branches: ${allocationDetails.branchesUsed}\n` +
          `👥 Employees: ${allocationDetails.employeesUsed}\n` +
          `⚠️ Remaining: ${allocationDetails.remaining}\n\n` +
          `Please upgrade your plan to add more users.`
        );
        setShowAlert(true);
        return;
      }

      // Also check simple employee count (backward compatibility)
      if (employeeCount >= userLimit) {
        setMessage(
          `Cannot add employee. Your subscription plan "${planTitle}" allows only ${userLimit} employees. ` +
          `You currently have ${employeeCount} employees. Please upgrade your plan.`
        );
        setShowAlert(true);
        return;
      }
    }

    // Check individual module limits for new allocations
    try {
      const requestedModules = new Set();
      Object.entries(userAccess).forEach(([key, value]) => {
        if (value && permissionModuleMapping[key]) {
          requestedModules.add(permissionModuleMapping[key]);
        }
      });

      for (const module of requestedModules) {
        let isNewModuleAccess = true;

        if (editingId) {
          const currentUser = employees.find(e => e._id === editingId);
          if (currentUser) {
            // Check if current user already has this module
            const currentPermissions = Array.isArray(currentUser.accessPermissions) ? currentUser.accessPermissions : [];
            const currentModules = new Set();
            currentPermissions.forEach(p => {
              const m = permissionModuleMapping[p];
              if (m) currentModules.add(m);
            });

            if (currentModules.has(module)) {
              isNewModuleAccess = false;
            }
          }
        }

        if (isNewModuleAccess) {
          const limitInfo = checkMenuLimit(module);

          // Skip validation for unlimited modules (hasLimit = false means unlimited)
          if (!limitInfo.hasLimit) {
            console.log(`✅ Module ${module} has no specific limit (unlimited access)`);
            continue;
          }

          // Only check limits for modules with specific numeric limits
          if (limitInfo.isExceeded) {
            setMessage(`Cannot ${editingId ? 'update' : 'add'} employee. User limit exceeded for module: ${module} (${limitInfo.used}/${limitInfo.total})`);
            setShowAlert(true);
            return;
          }
        }
      }
    } catch (err) {
      console.error("Error validating module limits:", err);
      // Don't block submission on validation code error, but log it
    }

    // Enhanced validation with proper company check
    // Check company first (using selectedCompanyId or formData.company)
    const currentCompanyId = selectedCompanyId || formData.company;
    if (!currentCompanyId) {
      setMessage("❌ Please select a company");
      setShowAlert(true);
      // Scroll to top where company selection is
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    // Check if at least one department is selected
    // Only show validation errors when trying to add a new employee, not during editing
    const isCurrentlyEditing = !!editingId;
    if (!isCurrentlyEditing) {
      const validDepartments = formData.departments ? formData.departments.filter(id => id && id.trim() !== '') : [];
      if (validDepartments.length === 0) {
        setMessage("❌ Please select at least one department");
        setShowAlert(true);
        // Scroll to department field
        document.querySelector('[name="departments"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (!formData.designation || formData.designation.length === 0) {
        setMessage("❌ Please select at least one designation");
        setShowAlert(true);
        document.querySelector('[name="designation"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // Check other required fields
      const requiredFields = {
        teamMemberName: "Employee Name",
        mobileNumber: "Mobile Number",
        email: "Email"
      };

      const missingFields = Object.entries(requiredFields)
        .filter(([field]) => !formData[field])
        .map(([_, label]) => label);

      if (missingFields.length > 0) {
        setMessage(`❌ Please fill in all required fields: ${missingFields.join(', ')}`);
        setShowAlert(true);
        // Scroll to first missing field
        const firstMissingField = Object.keys(requiredFields).find(field => !formData[field]);
        if (firstMissingField) {
          document.querySelector(`[name="${firstMissingField}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      // Validate role selection
      if (!formData.role || formData.role.trim() === '') {
        setMessage("❌ Please select a role for the employee");
        setShowAlert(true);
        document.querySelector(`[name="role"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }

    // Validate email format and lowercase
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setMessage("❌ Please enter a valid email address");
      setShowAlert(true);
      document.querySelector(`[name="email"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Validate email is in lowercase
    if (formData.email !== formData.email.toLowerCase()) {
      setMessage("❌ Email address must be in lowercase. Please use lowercase letters only (e.g., user@example.com)");
      setShowAlert(true);
      document.querySelector(`[name="email"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Check if email is in lowercase
    if (formData.email !== formData.email.toLowerCase()) {
      setMessage("❌ Email address must be in lowercase. Please use lowercase letters only.");
      setShowAlert(true);
      document.querySelector(`[name="email"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Check for validation errors
    const hasValidationErrors = Object.values(validationErrors).some(error => error !== '');
    if (hasValidationErrors) {
      setMessage("❌ Please fix the validation errors before submitting");
      setShowAlert(true);
      return;
    }

    // Final validation for required fields with scroll
    if (formData.mobileNumber && formData.mobileNumber.length !== 10) {
      setMessage("❌ Mobile number must be exactly 10 digits");
      setShowAlert(true);
      document.querySelector(`[name="mobileNumber"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (formData.emergencyMobileNumber && formData.emergencyMobileNumber.length !== 10) {
      setMessage("❌ Emergency mobile number must be exactly 10 digits");
      setShowAlert(true);
      document.querySelector(`[name="emergencyMobileNumber"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (formData.aadharNumber && formData.aadharNumber.length !== 12) {
      setMessage("❌ Aadhar number must be exactly 12 digits");
      setShowAlert(true);
      document.querySelector(`[name="aadharNumber"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (formData.panNumber && formData.panNumber.length !== 10) {
      setMessage("❌ PAN number must be exactly 10 characters");
      setShowAlert(true);
      document.querySelector(`[name="panNumber"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    try {
      const formDataToSend = new FormData();

      // Ensure company is set from selectedCompanyId if not in formData
      const finalCompanyId = formData.company || selectedCompanyId;
      if (finalCompanyId) {
        formDataToSend.append('company', finalCompanyId);
      }

      // Append all form data (skip documents/images for now - handled separately)
      Object.keys(formData).forEach((key) => {
        // Skip company as we've already handled it above
        if (key === "company") {
          return;
        } else if (key === "weeklyHoliday") {
          // Send as JSON string - backend expects this format
          const holidays = formData[key] || [];
          formDataToSend.append('weeklyHoliday', JSON.stringify(holidays));
        } else if (key === "departments") {
          const validDepts = [...new Set(formData.departments.filter(id => id && id.trim() !== ''))];
          if (validDepts.length === 0) {
            throw new Error('At least one department is required');
          }

          // Log department names for clarity
          const departmentNames = validDepts.map(deptId => {
            const dept = departments.find(d => d._id === deptId);
            return dept ? { id: deptId, name: dept.name } : { id: deptId, name: 'Unknown' };
          });

          // Only append as array format - backend should handle this
          validDepts.forEach(deptId => {
            formDataToSend.append('departments', deptId);
          });
        } else if (key === "designation") {
          const validDesigs = [...new Set(formData.designation.filter(id => id && id.trim() !== ''))];
          if (validDesigs.length === 0) {
            throw new Error('No valid designations to save');
          }

          const designationNames = validDesigs.map(desigId => {
            const desig = designations.find(d => d._id === desigId);
            return desig ? { id: desigId, name: desig.name } : { id: desigId, name: 'Unknown' };
          });
          validDesigs.forEach((desigId, index) => {
            formDataToSend.append('designation', desigId);  // Use 'designation' as per API spec
          });
        } else if (key === "paidLeaves") {
          // Handle paid leaves array (unchanged)
          formData.paidLeaves.forEach((leave, index) => {
            formDataToSend.append(`paidLeaves[${index}][type]`, leave.type);
            formDataToSend.append(`paidLeaves[${index}][count]`, leave.count);
          });
        } else if (key === "documents") {
          // FIXED: Skip nested appending here - handled non-nested below
        } else if (key === "branchAccess") {
        } else if (key === "dateOfJoining" && formData[key]) {
          formDataToSend.append(key, new Date(formData[key]).toISOString());
        } else if (key === "pfEnabled" || key === "esicEnabled" || key === "isActive" || key === "locationTracking" || key === "isFieldWork") {
          const booleanValue = formData[key] === true || formData[key] === 'true';
          formDataToSend.append(key, booleanValue.toString());
        }
        else if (key === "pfPercentage" || key === "esicPercentage") {
          // Handle percentage values for PF and ESIC
          formDataToSend.append(key, formData[key].toString());
        } else if (key === "profileImage" || key === "profileImagePreview" ||
          key === "panImage" || key === "panImagePreview" ||
          key === "adharImage" || key === "adharImagePreview") {
          // FIXED: Skip previews/URLs - handle files separately below
        } else if (formData[key] !== null && formData[key] !== undefined && formData[key] !== '') {
          formDataToSend.append(key, formData[key]);
        }
      });

      // Convert userAccess to array of selected permission keys
      let selectedPermissions = Object.entries(userAccess)
        .filter(([_, value]) => value)
        .map(([key]) => key);

      // Filter permissions based on company's module access
      const permissionModuleMapping = {
        // HRMS Module
        'create_teammember': 'hrms',
        'update_teammember': 'hrms',
        'delete_teammember': 'hrms',
        'list_teammember': 'hrms',
        'employee_report': 'hrms',
        'daily_attendace': 'hrms',
        'attendance_report': 'hrms',
        'settings_shift': 'hrms',
        'leave_request': 'hrms',
        'leave_approval': 'hrms',
        'leave_type': 'hrms',
        'leave_report': 'hrms',
        'salary_generation': 'hrms',
        'create_department': 'hrms',
        'update_department': 'hrms',
        'update_leave': 'hrms',

        // Support Module
        'customer_support': 'support',
        'com_tickets': 'support',
        'sup_tickets': 'support',
        'employee_performance': 'support',

        // Task Management Module
        'list_task': 'taskManagement',
        'create_task': 'taskManagement',
        'update_task': 'taskManagement',
        'delete_task': 'taskManagement',
        'shifted_task_history': 'taskManagement',
        'shift_task': 'taskManagement',
        'credit_points': 'taskManagement',
        'create_credit_points': 'taskManagement',
        'task_performance': 'taskManagement',

        // Lead Management Module
        'lead_management': 'leadManagement',
        'add_leads': 'leadManagement',
        'link_generator': 'leadManagement',
        'edit_lead': 'leadManagement',
        'assign_lead': 'leadManagement',

        // Project Management Module
        'project_dashboard': 'projectManagement',
        'projects': 'projectManagement',
        'project_employee_lists': 'projectManagement',
        'project_tracker': 'projectManagement',
        'project_tasks': 'projectManagement',
        'project_reports': 'projectManagement'
      };

      // Filter out permissions for disabled modules ONLY when CREATING NEW employees
      // When UPDATING existing employees, allow all permissions they check (no filtering)
      // Company and superadmin can assign any permissions regardless of subscription
      const isCreatingEmployee = formData.role === 'Employee' || formData.role === 'Manager' || !formData.role;
      const isEditingEmployee = !!editingId;

      // Only filter permissions when creating NEW employees (not when updating)
      if (isCreatingEmployee && !isEditingEmployee) {
        console.log('Filtering permissions for NEW employee creation based on company subscription');
        selectedPermissions = selectedPermissions.filter(permission => {
          const requiredModule = permissionModuleMapping[permission];

          // If permission doesn't require a specific module (like dashboard), allow it
          if (!requiredModule) return true;

          // Check if company has access to the required module
          const hasModuleAccess = companyAccessPermissions[requiredModule] === true;

          if (!hasModuleAccess) {
            console.log('š Filtering out permission:', permission, '(module:', requiredModule, 'not enabled)');
          }

          return hasModuleAccess;
        });
      } else if (isEditingEmployee) {
        console.log('✅ï UPDATING existing employee - keeping all checked permissions (no filtering)');
      } else {
        console.log('⚠️ Skipping permission filtering - creating company/admin user');
      }

      console.log('✅ Final permissions to be saved:', selectedPermissions);

      // First remove any existing accessPermissions
      if (formDataToSend.has('accessPermissions')) {
        formDataToSend.delete('accessPermissions');
      }

      // Append each permission individually
      selectedPermissions.forEach(permission => {
        formDataToSend.append('accessPermissions[]', permission);
      });

      // BRANCH ACCESS PROCESSING (unchanged)
      if (selectedBranches.length > 0) {
        selectedBranches.forEach(branchId => {
          formDataToSend.append('branchAccess[]', branchId);
        });

        // Log branch names for clarity
        const branchNames = selectedBranches.map(branchId => {
          const branch = branches.find(b => b._id === branchId);
          return branch ? { id: branchId, name: branch.businessName } : { id: branchId, name: 'Unknown' };
        });
      }
      // Image validation and compression function (unchanged)
      const processImageForDatabase = (imageFile, imageType) => {
        if (!imageFile) return null;

        const maxSize = 5 * 1024 * 1024; // 5MB max size
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

        // Validate file type
        if (!allowedTypes.includes(imageFile.type)) {
          console.warn(`⚠️ ${imageType} has invalid type:`, imageFile.type);
          return null;
        }

        // Validate file size
        if (imageFile.size > maxSize) {
          console.warn(`⚠️ ${imageType} is too large:`, imageFile.size, 'bytes');
          return null;
        }

        return imageFile;
      };

      // FIXED: Profile Image - Only append file if present (no preview/URL)
      const validatedProfileImage = processImageForDatabase(formData.profileImage, 'Profile Image');
      if (validatedProfileImage) {
        formDataToSend.append('profileImage', validatedProfileImage);
      } else {
        console.log('ℹ️ No profile image file to append');
      }

      // FIXED: PAN Image - Only append file if present
      const validatedPanImage = processImageForDatabase(formData.panImage, 'PAN Image');
      if (validatedPanImage) {
        formDataToSend.append('panImage', validatedPanImage);
      } else {
        console.log('ℹ️ No PAN image file to append');
      }

      // FIXED: Aadhar Image - Only append file if present
      const validatedAadharImage = processImageForDatabase(formData.adharImage, 'Aadhar Image');
      if (validatedAadharImage) {
        formDataToSend.append('adharImage', validatedAadharImage);
      } else {
        console.log('ℹ️ No Aadhar image file to append');
      }


      // FIXED: NEW/UPDATED: Handle dynamic documents properly (non-nested)
      if (formData.documents && formData.documents.length > 0) {
        const validDocs = formData.documents.filter(doc => doc.type && doc.file);  // Only new docs with type + file
        if (validDocs.length > 0) {
          // Append types as multiple 'documentTypes' (for create) or 'newDocumentTypes' (for edit)
          const typeFieldName = editingId ? 'newDocumentTypes' : 'documentTypes';
          validDocs.forEach(doc => {
            formDataToSend.append(typeFieldName, doc.type);  // Multiple appends †array in req.body
            formDataToSend.append('documents', doc.file);    // Multiple files with same name †array in req.files.documents
          });

          // For edit: Send types to remove (if any)
          if (editingId && documentsToRemove.length > 0) {
            documentsToRemove.forEach(type => {
              formDataToSend.append('removeDocuments', type);  // Multiple appends †array in req.body
            });
          }

          // Optional: Send uploadedAt for each (backend will override if needed)
          validDocs.forEach(doc => {
            formDataToSend.append('documentsUploadedAt', doc.uploadedAt);
          });
        } else {
        }
      } else {
      }

      // Log complete FormData after all entries are added (enhanced for files)
      const formDataEntries = {};
      formDataToSend.forEach((value, key) => {
        if (formDataEntries[key]) {
          if (Array.isArray(formDataEntries[key])) {
            formDataEntries[key].push(value);
          } else {
            formDataEntries[key] = [formDataEntries[key], value];
          }
        } else {
          formDataEntries[key] = value;
        }
      });

      const booleanFields = ['pfEnabled', 'esicEnabled', 'isActive'];
      booleanFields.forEach(field => {
        if (formDataEntries[field] !== undefined) {
        } else {
        }
      });

      const departmentEntries = Object.entries(formDataEntries).filter(([key]) =>
        key.toLowerCase().includes('department')
      );
      departmentEntries.forEach(([key, value]) => {
      });

      const imageEntries = Object.entries(formDataEntries).filter(([key]) =>
        key.toLowerCase().includes('image')
      );

      // Show all entries for debugging
      Object.entries(formDataEntries).forEach(([key, value]) => {
        const displayValue = value instanceof File ? `[FILE: ${value.name}]` : value;
      });

      // ADD: Specific logging for PF and ESI fields
      console.log('💰 PF/ESI Fields being sent to API:', {
        pfEnabled: formDataEntries.pfEnabled,
        pfPercentage: formDataEntries.pfPercentage,
        esicEnabled: formDataEntries.esicEnabled,
        esicPercentage: formDataEntries.esicPercentage,
        fromFormData: {
          pfEnabled: formData.pfEnabled,
          pfPercentage: formData.pfPercentage,
          esicEnabled: formData.esicEnabled,
          esicPercentage: formData.esicPercentage
        }
      });

      const isEditing = !!editingId;
      const url = isEditing
        ? `https://slateblue-mallard-430836.hostingersite.com/api/employees/${editingId}`
        : "https://slateblue-mallard-430836.hostingersite.com/api/employees";
      const method = isEditing ? "PUT" : "POST";

      let response;
      let shouldTryJson = false;

      try {
        response = await axios({
          method,
          url,
          data: formDataToSend,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          },
          validateStatus: function (status) {
            return status >= 200 && status < 500; // Allow 4xx responses to be handled
          }
        });

        if (response.status >= 400 && response.data?.message?.includes('department')) {
          console.warn('⚠️ FormData got department error, trying JSON approach...');
          shouldTryJson = true;
        }

      } catch (formDataError) {
        // FIXED: Enhanced MulterError detection
        const errorData = formDataError.response?.data;
        const errorDataString = typeof errorData === 'string' ? errorData : JSON.stringify(errorData || '');

        if (formDataError.message.includes('MulterError') || errorDataString.includes('Unexpected field')) {
          console.error('❌ MULTER ERROR: Unexpected field detected. Check backend Multer config for fields: profileImage, panImage, adharImage, documents');
          const unexpectedField = errorDataString.match(/field '([^']+)'/)?.[1] || 'unknown';
          setMessage(`❌ Multer Error: Unexpected field "${unexpectedField}". Images/docs not uploaded. Check backend config.`);
          return;
        }
        console.warn('⚠️ FormData submission failed, trying JSON approach...', formDataError.message);
        shouldTryJson = true;
      }

      if (shouldTryJson) {

        // Create a new FormData with proper structure
        const correctedFormData = new FormData();

        // Add all basic fields (same as main, but skip documents/images for now)
        Object.keys(formData).forEach((key) => {
          if (key === "weeklyHoliday") {
            // Send as JSON string - backend expects this format
            correctedFormData.append('weeklyHoliday', JSON.stringify(formData[key] || []));
          } else if (key === "departments") {
            // Try different department field structures (unchanged)
            const validDepts = [...new Set(formData.departments.filter(id => id && id.trim() !== ''))];

            // Add as array elements
            validDepts.forEach((deptId) => {
              correctedFormData.append('departments[]', deptId);
            });

            // Also add individual entries
            validDepts.forEach((deptId) => {
              correctedFormData.append('department[]', deptId);
            });

            // Add as single field if only one department
            if (validDepts.length === 1) {
              correctedFormData.append('department', validDepts[0]);
            }
          } else if (key === "designation") {
            const validDesigs = [...new Set(formData.designation.filter(id => id && id.trim() !== ''))];
            validDesigs.forEach((desigId) => {
              correctedFormData.append('designation[]', desigId);
              correctedFormData.append('designation', desigId);
            });
          } else if (key === "paidLeaves") {
            formData.paidLeaves.forEach((leave, index) => {
              correctedFormData.append(`paidLeaves[${index}][type]`, leave.type);
              correctedFormData.append(`paidLeaves[${index}][count]`, leave.count);
            });
          } else if (key === "documents") {
            // FIXED: Skip nested - handled below
          } else if (key === "dateOfJoining" && formData[key]) {
            correctedFormData.append(key, new Date(formData[key]).toISOString());
          } else if (key === "pfEnabled" || key === "esicEnabled") {
            const booleanValue = formData[key] === true || formData[key] === 'true';
            correctedFormData.append(key, booleanValue.toString());
          } else if (key === "pfPercentage" || key === "esicPercentage") {
            correctedFormData.append(key, formData[key].toString());
          } else if (key === "profileImage" || key === "profileImagePreview" ||
            key === "panImage" || key === "panImagePreview" ||
            key === "adharImage" || key === "adharImagePreview") {
            // FIXED: Skip previews/URLs - handle files separately below
          } else if (formData[key] !== null && formData[key] !== undefined && formData[key] !== '') {
            correctedFormData.append(key, formData[key]);
          }
        });

        // Add access permissions with same filtering logic as main path
        let selectedPermissions = Object.entries(userAccess)
          .filter(([_, value]) => value)
          .map(([key]) => key);

        // Apply same permission filtering as main path
        const permissionModuleMapping = {
          'create_teammember': 'hrms', 'update_teammember': 'hrms', 'delete_teammember': 'hrms',
          'list_teammember': 'hrms', 'employee_report': 'hrms', 'daily_attendace': 'hrms',
          'attendance_report': 'hrms', 'settings_shift': 'hrms', 'leave_request': 'hrms',
          'leave_approval': 'hrms', 'leave_type': 'hrms', 'leave_report': 'hrms',
          'salary_generation': 'hrms', 'create_department': 'hrms', 'update_department': 'hrms',
          'update_leave': 'hrms', 'customer_support': 'support', 'com_tickets': 'support',
          'sup_tickets': 'support', 'employee_performance': 'support', 'list_task': 'taskManagement',
          'create_task': 'taskManagement', 'update_task': 'taskManagement', 'delete_task': 'taskManagement',
          'shifted_task_history': 'taskManagement', 'shift_task': 'taskManagement',
          'credit_points': 'taskManagement', 'create_credit_points': 'taskManagement',
          'task_performance': 'taskManagement', 'lead_management': 'leadManagement',
          'add_leads': 'leadManagement', 'link_generator': 'leadManagement', 'edit_lead': 'leadManagement',
          'assign_lead': 'leadManagement', 'project_dashboard': 'projectManagement',
          'projects': 'projectManagement', 'project_employee_lists': 'projectManagement',
          'project_tracker': 'projectManagement', 'project_tasks': 'projectManagement',
          'project_reports': 'projectManagement'
        };

        const isCreatingEmployee = formData.role === 'Employee' || formData.role === 'Manager' || !formData.role;
        const isEditingEmployee = !!editingId;

        // Only filter for NEW employee creation, not updates
        if (isCreatingEmployee && !isEditingEmployee) {
          console.log('[Fallback] Filtering permissions for NEW employee');
          selectedPermissions = selectedPermissions.filter(permission => {
            const requiredModule = permissionModuleMapping[permission];
            if (!requiredModule) return true;
            const hasModuleAccess = companyAccessPermissions[requiredModule] === true;
            if (!hasModuleAccess) {
              console.log('š [Fallback] Filtering out:', permission);
            }
            return hasModuleAccess;
          });
        } else if (isEditingEmployee) {
          console.log('✅ï [Fallback] UPDATING - keeping all checked permissions');
        }

        console.log('✅ [Fallback] Final permissions:', selectedPermissions);

        selectedPermissions.forEach(permission => {
          correctedFormData.append('accessPermissions[]', permission);
        });

        // FIXED: Append images to correctedFormData (same as main)
        const correctedProfileImage = processImageForDatabase(formData.profileImage, 'Profile Image (Corrected)');
        if (correctedProfileImage) {
          correctedFormData.append('profileImage', correctedProfileImage);
        }

        const correctedPanImage = processImageForDatabase(formData.panImage, 'PAN Image (Corrected)');
        if (correctedPanImage) {
          correctedFormData.append('panImage', correctedPanImage);
        }

        const correctedAadharImage = processImageForDatabase(formData.adharImage, 'Aadhar Image (Corrected)');
        if (correctedAadharImage) {
          correctedFormData.append('adharImage', correctedAadharImage);
        }

        // FIXED: Handle dynamic documents in fallback (non-nested, append to correctedFormData)
        if (formData.documents && formData.documents.length > 0) {
          const validDocs = formData.documents.filter(doc => doc.type && doc.file);  // Only new docs with type + file
          if (validDocs.length > 0) {
            const typeFieldName = editingId ? 'newDocumentTypes' : 'documentTypes';
            validDocs.forEach(doc => {
              correctedFormData.append(typeFieldName, doc.type);  // Multiple appends †array in req.body
              correctedFormData.append('documents', doc.file);    // Multiple files with same name †array in req.files.documents
            });

            // For edit: Send types to remove (if any)
            if (editingId && documentsToRemove.length > 0) {
              documentsToRemove.forEach(type => {
                correctedFormData.append('removeDocuments', type);  // Multiple appends †array in req.body
              });
            }

            // Optional: Send uploadedAt for each
            validDocs.forEach(doc => {
              correctedFormData.append('documentsUploadedAt', doc.uploadedAt);
            });
          } else {
            console.log('⚠️ No valid dynamic documents to send in fallback');
          }
        } else {
          console.log('ℹ️ No dynamic documents in fallback');
        }

        // Log corrected FormData (similar to main)
        const correctedEntries = {};
        correctedFormData.forEach((value, key) => {
          if (correctedEntries[key]) {
            if (Array.isArray(correctedEntries[key])) {
              correctedEntries[key].push(value);
            } else {
              correctedEntries[key] = [correctedEntries[key], value];
            }
          } else {
            correctedEntries[key] = value;
          }
        });

        const correctedFileEntries = Object.entries(correctedEntries).filter(([key]) =>
          key.includes('Image') || key === 'documents' || key.includes('documentTypes')
        );
        correctedFileEntries.forEach(([key, value]) => {
          const displayValue = value instanceof File ? `[FILE: ${value.name}]` : value;
        });

        response = await axios({
          method,
          url,
          data: correctedFormData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          },
          validateStatus: function (status) {
            return status >= 200 && status < 500;
          }
        });
      }
      if (response.data.isActive !== undefined) {
      } else {
        console.warn('⚠️ isActive field not found in database response');
        console.warn('✅This may indicate the field was not saved properly');
      }

      if (response.status >= 400) {
        console.error('❌ API ERROR RESPONSE:', {
          status: response.status,
          data: response.data,
          message: response.data?.message,
          errors: response.data?.errors,
          details: response.data?.details
        });

        let errorMessage = response.data?.message || `Server responded with status ${response.status}`;
        if (response.data?.errors) {
          const errorDetails = Object.entries(response.data.errors)
            .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
            .join('; ');
          errorMessage += ` - ${errorDetails}`;
        }

        throw new Error(errorMessage);
      }

      // Log the departments/designations that were actually saved (unchanged)
      if (response.data.departments) {
        const savedDeptNames = response.data.departments.map(deptId => {
          const dept = departments.find(d => d._id === deptId);
          return dept ? dept.name : `Unknown (${deptId})`;
        });
      }

      if (response.data.designation) {
        const savedDesigNames = response.data.designation.map(desigId => {
          const desig = designations.find(d => d._id === desigId);
          return desig ? desig.name : `Unknown (${desigId})`;
        });
      }

      // Enhanced success message with status information
      const statusText = response.data.isActive ? 'Active' : 'Inactive';
      const actionText = isEditing ? "updated" : "added";
      setMessage(`✅ Employee ${actionText} successfully!`);
      setShowAlert(true);

      setFormData(prev => ({ ...prev, documents: [] }));  // Clear local docs
      setDocumentsToRemove([]);  // Clear removal list
      setNewDocument({ type: '', file: null });
      setShowValidationErrors(false);  // Reset validation flag on success

      // Update employee count immediately
      if (!isEditing) {
        const newEmployeeCount = employees.length + 1;
        setEmployeeCount(newEmployeeCount);
        setSkipEmployeeCountUpdate(true);  // Skip next fetchEmployees update

        // Update allocation details immediately
        if (subscriptionPlan?.plan) {
          calculateAllocation(subscriptionPlan.plan.userLimit, branchCount, newEmployeeCount, subscriptionPlan.plan.branchLimit, totalBranchUserLimit);
        }
      }

      // Refresh employee list 
      fetchEmployees();

      // Reset form (unchanged)
      setFormData(emptyFormData);
      setValidationErrors({
        mobileNumber: '',
        emergencyMobileNumber: '',
        aadharNumber: '',
        panNumber: '',
        userUpi: '',
        salary: '',
        teamMemberName: ''
      });
      setEditingId(null);
      setShowForm(false);

    } catch (err) {
      // Enhanced error logging (unchanged, but added Multer check above)
      console.error('Full error object:', err);
      console.error('Error response data:', err.response?.data);
      console.error('Error response status:', err.response?.status);
      console.error('Error response headers:', err.response?.headers);

      console.error('Error details:', {
        message: err.message,
        response: {
          data: err.response?.data,
          status: err.response?.status,
          headers: err.response?.headers,
          request: {
            method: err.config?.method,
            url: err.config?.url,
            headers: err.config?.headers ? {
              ...err.config.headers,
              'Authorization': '[REDACTED]' // Hide token for security
            } : undefined,
            data: err.config?.data ? 'Form data sent (see below)' : undefined
          }
        }
      });

      // Log the complete form data that was sent (if available)
      try {
        const formDataEntries = {};
        if (err.config?.data instanceof FormData) {
          for (let [key, value] of err.config.data.entries()) {
            formDataEntries[key] = value;
          }
        }
      } catch (formDataError) {
        console.error('Could not log form data:', formDataError);
      }

      let errorMessage = "An unknown error occurred";

      if (err.code === "ERR_NETWORK") {
        errorMessage = "Unable to connect to the server. Please check your internet connection.";
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
        if (err.response.data.errors) {
          // Handle validation errors
          const errorMessages = [];
          for (const [field, errors] of Object.entries(err.response.data.errors)) {
            if (Array.isArray(errors)) {
              errorMessages.push(`${field}: ${errors.join(', ')}`);
            } else {
              errorMessages.push(`${field}: ${errors}`);
            }
          }
          errorMessage += ": " + errorMessages.join('; ');
        }
      } else if (err.message) {
        errorMessage = err.message;
      }

      // FIXED: Specific MulterError handling (moved from catch to try block, but fallback here)
      const errData = err.response?.data;
      const errDataString = typeof errData === 'string' ? errData : JSON.stringify(errData || '');

      if (err.message.includes('MulterError') || errDataString.includes('Unexpected field')) {
        setMessage('❌ Image upload error: Server received unexpected field. Check backend Multer config for: profileImage, panImage, adharImage, documents. Dynamic docs not saved.');
      } else {
        // Show more detailed error message
        const detailedError = err.response?.status
          ? `${errorMessage} (Status: ${err.response.status})`
          : errorMessage;
        setMessage(`❌ Failed to ${editingId ? "update" : "add"} employee: ${detailedError}`);
        console.error('📋 Full error for debugging:', {
          message: errorMessage,
          status: err.response?.status,
          data: err.response?.data,
          errorDetails: err.response?.data?.errors,
          fullResponse: err.response
        });

        // Log what was sent to help debug
        console.error(' Data sent to server:');
        if (err.config?.data instanceof FormData) {
          console.error('FormData entries:');
          for (let [key, value] of err.config.data.entries()) {
            if (value instanceof File) {
              console.error(`  ${key}: [FILE: ${value.name}]`);
            } else {
              console.error(`  ${key}:`, value);
            }
          }
        }
      }
      setShowAlert(true);
    }
  };


  const handleEdit = (employee) => {
    console.log('🔧 Editing employee:', employee.teamMemberName);
    console.log('Raw employee departments:', employee.departments);

    setEditingId(employee._id);

    // Fix department processing - ensure it's always an array of clean IDs
    let processedDepartments = [];

    if (Array.isArray(employee.departments) && employee.departments.length > 0) {
      // Flatten and split any comma-separated strings
      processedDepartments = employee.departments
        .flatMap(item => {
          if (typeof item === 'string' && item.includes(',')) {
            // Split comma-separated string into individual IDs
            return item.split(',').map(id => id.trim());
          }
          return item;
        })
        .flat() // Flatten again after splitting
        .map(id => {
          // Convert to string and extract ID if it's an object
          if (typeof id === 'object' && id?._id) {
            return String(id._id).trim();
          }
          return String(id).trim();
        })
        .filter(id => id && id !== ''); // Remove empty values
    } else if (employee.department) {
      // Handle legacy single value
      if (typeof employee.department === 'string' && employee.department.includes(',')) {
        processedDepartments = employee.department.split(',').map(id => id.trim());
      } else if (Array.isArray(employee.department)) {
        processedDepartments = employee.department.map(id =>
          typeof id === 'object' && id?._id ? String(id._id).trim() : String(id).trim()
        );
      } else {
        const deptId = typeof employee.department === 'object' && employee.department?._id
          ? String(employee.department._id).trim()
          : String(employee.department).trim();
        if (deptId) processedDepartments = [deptId];
      }
    }

    // Remove duplicates
    processedDepartments = [...new Set(processedDepartments)];

    console.log('✅ Processed departments for edit:', processedDepartments);

    // Process designation similarly
    let processedDesignations = [];
    if (Array.isArray(employee.designation)) {
      processedDesignations = employee.designation
        .flatMap(item => {
          if (typeof item === 'string' && item.includes(',')) {
            return item.split(',').map(id => id.trim());
          }
          return item;
        })
        .map(id => {
          if (typeof id === 'object' && id?._id) {
            return String(id._id).trim();
          }
          return String(id).trim();
        })
        .filter(id => id && id !== '');
      processedDesignations = [...new Set(processedDesignations)];
    }

    // Set formData with cleaned arrays
    setFormData({
      company: employee.company?._id || employee.company || '',
      teamMemberName: employee.teamMemberName || '',
      mobileNumber: employee.mobileNumber || '',
      emergencyMobileNumber: employee.emergencyMobileNumber || '',
      email: employee.email || '',
      password: '', // Don't populate password for security
      salary: employee.salary || '',
      // FIX: Enable checkboxes if percentages > 0 (even if pfEnabled/esicEnabled are undefined)
      pfEnabled: employee.pfEnabled === true || employee.pfEnabled === 'true' || (employee.pfPercentage && parseFloat(employee.pfPercentage) > 0),
      pfPercentage: employee.pfPercentage !== null && employee.pfPercentage !== undefined ? parseFloat(employee.pfPercentage) : 12,
      esicEnabled: employee.esicEnabled === true || employee.esicEnabled === 'true' || (employee.esicPercentage && parseFloat(employee.esicPercentage) > 0),
      esicPercentage: employee.esicPercentage !== null && employee.esicPercentage !== undefined ? parseFloat(employee.esicPercentage) : 3.25,
      dateOfJoining: employee.dateOfJoining ? employee.dateOfJoining.split('T')[0] : '',
      shift: employee.shift?._id || employee.shift || '',
      departments: processedDepartments, // Always clean array of strings
      designation: processedDesignations,
      role: employee.role || '',
      aadharNumber: employee.aadharNumber || '',
      panNumber: employee.panNumber || '',
      userUpi: employee.userUpi || '',
      weeklyHoliday: (() => {
        console.log(`—ï Processing weeklyHoliday for ${employee.teamMemberName}:`, employee.weeklyHoliday);
        if (Array.isArray(employee.weeklyHoliday)) {
          console.log('✅ Already array:', employee.weeklyHoliday);
          return employee.weeklyHoliday;
        } else if (typeof employee.weeklyHoliday === 'string') {
          try {
            const parsed = JSON.parse(employee.weeklyHoliday);
            console.log('✅ Parsed from string:', parsed);
            return Array.isArray(parsed) ? parsed : [];
          } catch (e) {
            console.log('❌ Parse failed:', e);
            return [];
          }
        }
        console.log('⚠️ Defaulting to empty array');
        return [];
      })(),
      address: employee.address || '',
      isActive: employee.isActive !== undefined ? employee.isActive : true,
      locationTracking: employee.locationTracking || false,
      isFieldWork: employee.isFieldWork !== undefined ? employee.isFieldWork : false,
      paidLeaves: Array.isArray(employee.paidLeaves) ? employee.paidLeaves : [],
      documents: Array.isArray(employee.documents) ? employee.documents : [],
      profileImagePreview: employee.profileImage || null,
      panImagePreview: employee.panImage || null,
      adharImagePreview: employee.adharImage || null,
      profileImage: null,
      panImage: null,
      adharImage: null,
    });

    // ADD: Debug logging to verify data
    console.log('RAW Employee data from API:', {
      pfEnabled: employee.pfEnabled,
      pfEnabledType: typeof employee.pfEnabled,
      pfPercentage: employee.pfPercentage,
      pfPercentageType: typeof employee.pfPercentage,
      esicEnabled: employee.esicEnabled,
      esicEnabledType: typeof employee.esicEnabled,
      esicPercentage: employee.esicPercentage,
      esicPercentageType: typeof employee.esicPercentage,
      salary: employee.salary
    });

    console.log(' CALCULATED Form values:', {
      pfEnabled: employee.pfEnabled === true || employee.pfEnabled === 'true' || (employee.pfPercentage && parseFloat(employee.pfPercentage) > 0),
      pfPercentage: employee.pfPercentage !== null && employee.pfPercentage !== undefined ? parseFloat(employee.pfPercentage) : 12,
      esicEnabled: employee.esicEnabled === true || employee.esicEnabled === 'true' || (employee.esicPercentage && parseFloat(employee.esicPercentage) > 0),
      esicPercentage: employee.esicPercentage !== null && employee.esicPercentage !== undefined ? parseFloat(employee.esicPercentage) : 3.25
    });

    // ... rest of handleEdit ...



    // Set user access permissions
    if (Array.isArray(employee.accessPermissions)) {
      const updatedAccess = { ...userAccess };
      Object.keys(updatedAccess).forEach(key => {
        updatedAccess[key] = false;
      });
      employee.accessPermissions.forEach(permission => {
        const permissionKey = permission.toLowerCase();
        if (updatedAccess.hasOwnProperty(permissionKey)) {
          updatedAccess[permissionKey] = true;
        }
      });
      setUserAccess(updatedAccess);
    }

    // Set branch access
    if (Array.isArray(employee.branchAccess)) {
      setSelectedBranches(employee.branchAccess.map(branch =>
        typeof branch === 'object' && branch._id ? branch._id : branch
      ));
    } else {
      setSelectedBranches([]);
    }

    setShowForm(true);
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };


  const handleDelete = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setMessage("❌ Access token not found. Please log in.");
      setShowDeleteModal(false);
      return;
    }

    try {
      await axios.delete(`https://slateblue-mallard-430836.hostingersite.com/api/employees/${employeeToDelete}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMessage("✅ Employee deleted successfully!");

      // Update employee count immediately
      const newEmployeeCount = Math.max(0, employees.length - 1);
      setEmployeeCount(newEmployeeCount);
      setSkipEmployeeCountUpdate(true);  // Skip next fetchEmployees update

      // Update allocation details immediately
      if (subscriptionPlan?.plan) {
        calculateAllocation(subscriptionPlan.plan.userLimit, branchCount, newEmployeeCount, subscriptionPlan.plan.branchLimit, totalBranchUserLimit);
      }

      fetchEmployees();

      setShowDeleteModal(false);
      setEmployeeToDelete(null);
    } catch (error) {
      const errorMessage =
        error.code === "ERR_NETWORK"
          ? "Unable to connect to the server. This may be due to a CORS issue or the server being down."
          : error.response?.data?.message || error.message || "Unknown error";
      console.error("Error deleting employee:", {
        message: errorMessage,
        status: error.response?.status,
        data: error.response?.data,
      });

      setMessage(`❌ Error deleting employee: ${errorMessage}`);
      setShowDeleteModal(false);
      setEmployeeToDelete(null);
    }
  };

  const openDeleteModal = (id) => {
    setEmployeeToDelete(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setEmployeeToDelete(null);
  };

  const toggleForm = () => {
    const resetForm = () => {
      setFormData(emptyFormData);
      setDocumentsToRemove([]);  // NEW: Reset removal list
      setNewDocument({ type: '', file: null });
      setValidationErrors({
        mobileNumber: '',
        emergencyMobileNumber: '',
        aadharNumber: '',
        panNumber: '',
        userUpi: '',
        salary: '',
        teamMemberName: ''
      });
      setShowValidationErrors(false);
      setEditingId(null);
      setShowForm(false);
      setMessage("");
      setSelectedBranches([]);
    };
    if (showForm) {
      resetForm();
    }
    setShowForm(!showForm);
  };

  const resetForm = () => {
    setFormData(emptyFormData);
    setDocumentsToRemove([]);  // Clear removal list
    setNewDocument({ type: '', file: null });
    setValidationErrors({
      mobileNumber: '',
      emergencyMobileNumber: '',
      aadharNumber: '',
      panNumber: '',
      userUpi: '',
      salary: '',
      teamMemberName: ''
    });
    setShowValidationErrors(false);
    setEditingId(null);
    setSelectedBranches([]);

    // Reset permissions to default (all false)
    setUserAccess({
      dashboard: false,
      lead_management: false,
      add_leads: false,
      link_generator: false,
      edit_lead: false,
      assign_lead: false,
      list_task: false,
      create_task: false,
      update_task: false,
      delete_task: false,
      shifted_task_history: false,
      shift_task: false,
      create_credit_points: false,
      task_performance: false,
      credit_points: false,
      settings: false,
      settings_category: false,
      settings_shift: false,
      settings_customer_group: false,
      settings_leave_type: false,
      reports: false,
      followup_report: false,
      task_report: false,
      leads_report: false,
      attendance_report: false,
      leave_report: false,
      payment_report: false,
      accounts: false,
      list_customer: false,
      create_customer: false,
      update_customer: false,
      delete_customer: false,
      list_teammember: false,
      create_teammember: false,
      update_teammember: false,
      delete_teammember: false,
      employee_report: false,
      daily_attendace: false,
      list_leave: false,
      create_leave: false,
      update_leave: false,
      delete_leave: false,
      leave_request: false,
      leave_approval: false,
      leave_type: false,
      list_franchise: false,
      create_franchise: false,
      update_franchise: false,
      delete_franchise: false,
      list_business: false,
      create_business: false,
      update_business: false,
      delete_business: false,
      chat: false,
      departments: false,
      create_department: false,
      update_department: false,
      delete_department: false,
      salary_generation: false,
      todo_list: false,
      user_profile: false,
      business_profile: false,
      project_dashboard: false,
      projects: false,
      project_employee_lists: false,
      project_tracker: false,
      project_tasks: false,
      project_reports: false,
      customer_support: false,
      com_tickets: false,
      sup_tickets: false,
      employee_performance: false
    });

    // Clear file previews and revoke URLs to prevent memory leaks
    if (formData.profileImagePreview) {
      URL.revokeObjectURL(formData.profileImagePreview);
    }
    if (formData.panImagePreview) {
      URL.revokeObjectURL(formData.panImagePreview);
    }
    if (formData.adharImagePreview) {
      URL.revokeObjectURL(formData.adharImagePreview);
    }

    // Reset file input refs if needed
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };


  // Render summary cards for employee management
  const renderSummaryCards = () => {
    if (!subscriptionPlan) return null;

    const modules = [
      { key: 'taskManagement', label: 'Tasks', icon: '📋', color: 'blue' },
      { key: 'leadManagement', label: 'Leads', icon: '🎯', color: 'pink' },
      { key: 'hrms', label: 'HRMS', icon: '👥', color: 'purple' },
      { key: 'support', label: 'Support', icon: '💬', color: 'yellow' },
      { key: 'projectManagement', label: 'Projects', icon: '📊', color: 'indigo' }
    ];

    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
        {modules.map(module => {
          const limitInfo = checkMenuLimit(module.key);
          if (!limitInfo.enabled) return null;

          return (
            <div key={module.key} className={`bg-white p-4 rounded-xl shadow-sm border-l-4 border-${module.color}-500 flex flex-col justify-between`}>
              <div>
                <div className="flex justify-between items-start mb-2">
                  <span className="text-sm font-medium text-gray-500">{module.label}</span>
                  <span className="text-xl">{module.icon}</span>
                </div>
                <div className="flex items-baseline space-x-1">
                  <span className={`text-2xl font-bold text-${module.color}-600`}>
                    {limitInfo.used}
                  </span>
                  <span className="text-gray-400 text-sm">/ {limitInfo.total || '∞'}</span>
                </div>
              </div>

              <div className="mt-3 pt-2 border-t border-gray-50 space-y-1">
                <div className="flex justify-between text-[10px] text-gray-400">
                  <span>Subscription Total:</span>
                  <span className="font-medium">{limitInfo.masterTotal || '∞'}</span>
                </div>
                <div className="flex justify-between text-[10px] text-gray-400">
                  <span>Branch Allocated:</span>
                  <span className="font-medium text-orange-400">{limitInfo.branchAllocated}</span>
                </div>
                <div className="flex justify-between text-[10px] font-semibold border-t border-dotted mt-1 pt-1">
                  <span className="text-gray-500 uppercase tracking-tighter">Available for Main:</span>
                  <span className="text-indigo-600">{limitInfo.remaining}</span>
                </div>
                <p className={`text-[10px] mt-1 text-right ${limitInfo.remaining <= 0 ? 'text-red-500 font-bold' : 'text-green-500 font-medium'}`}>
                  {limitInfo.masterTotal ? (limitInfo.remaining > 0 ? `${limitInfo.remaining} Available` : 'Limit reached') : 'Unlimited'}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderDepartmentSelection = () => (
    <div className="mb-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">
        Departments * <span className="text-sm font-normal text-gray-500">(Select multiple)</span>
      </label>
      <div className="border rounded p-3 max-h-48 overflow-y-auto bg-white">
        {!selectedCompanyId ? (
          <p className="text-gray-500 text-sm">Please select a company first</p>
        ) : departments.length === 0 ? (
          <p className="text-gray-500 text-sm">No departments available</p>
        ) : (
          <div className="space-y-2">
            {departments.map((dept) => (
              <label key={dept._id} className="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 p-2 rounded">
                <input
                  type="checkbox"
                  value={dept._id}
                  checked={formData.departments.includes(dept._id)}
                  onChange={handleDepartmentChange}
                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <span className="text-gray-700 text-sm">{dept.name}</span>
              </label>
            ))}
          </div>
        )}
      </div>
      {formData.departments.length > 0 && (
        <div className="mt-2">
          <p className="text-sm text-gray-600">Selected: {formData.departments.length} department(s)</p>
          <div className="flex flex-wrap gap-1 mt-1">
            {formData.departments.map((deptId) => {
              const dept = departments.find(d => d._id === deptId);
              return dept ? (
                <span key={deptId} className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                  {dept.name}
                  <button
                    type="button"
                    onClick={() => handleDepartmentChange({ target: { value: deptId, checked: false } })}
                    className="ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full text-indigo-400 hover:bg-indigo-200 hover:text-indigo-600 focus:outline-none"
                  >
                    ×
                  </button>
                </span>
              ) : null;
            })}
          </div>
        </div>
      )}
    </div>
  );

  const renderDesignationDropdown = () => (
    <div className="mb-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">
        Designations * <span className="text-sm font-normal text-gray-500">(Select multiple)</span>
      </label>
      <div className="border rounded p-3 max-h-48 overflow-y-auto bg-white">
        {!selectedCompanyId ? (
          <p className="text-gray-500 text-sm">Please select a company first</p>
        ) : formData.departments.length === 0 ? (
          <p className="text-gray-500 text-sm">Please select at least one department first</p>
        ) : designations.length === 0 ? (
          <p className="text-gray-500 text-sm">No designations available for selected departments</p>
        ) : (
          <div className="space-y-2">
            {designations.map((desig) => (
              <label key={desig._id} className="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 p-2 rounded">
                <input
                  type="checkbox"
                  value={desig._id}
                  checked={formData.designation.includes(desig._id)}
                  onChange={handleDesignationChange}
                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <span className="text-gray-700 text-sm">{desig.name}</span>
              </label>
            ))}
          </div>
        )}
      </div>
      {formData.designation.length > 0 && (
        <div className="mt-2">
          <p className="text-sm text-gray-600">Selected: {formData.designation.length} designation(s)</p>
          <div className="flex flex-wrap gap-1 mt-1">
            {formData.designation.map((desigId) => {
              const desig = designations.find(d => d._id === desigId);
              return desig ? (
                <span key={desigId} className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                  {desig.name}
                  <button
                    type="button"
                    onClick={() => handleDesignationChange({ target: { value: desigId, checked: false } })}
                    className="ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full text-indigo-400 hover:bg-indigo-200 hover:text-indigo-600 focus:outline-none"
                  >
                    ×
                  </button>
                </span>
              ) : null;
            })}
          </div>
        </div>
      )}
    </div>
  );

  const filteredEmployees = employees.filter(employee => {
    const matchesSearch =
      employee.teamMemberName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.mobileNumber?.includes(searchTerm) ||
      employee.role?.toLowerCase().includes(searchTerm.toLowerCase());

    // FIXED: Handle department filter for multiple departments
    let matchesDepartment = !departmentFilter || departmentFilter === '';

    if (departmentFilter && departmentFilter !== '') {
      // Get all department IDs for this employee
      let employeeDepts = [];

      if (Array.isArray(employee.departments) && employee.departments.length > 0) {
        // Flatten any nested arrays and split comma-separated strings
        employeeDepts = employee.departments
          .flatMap(item => {
            if (typeof item === 'string' && item.includes(',')) {
              // Split comma-separated string into individual IDs
              return item.split(',').map(id => id.trim());
            }
            return item;
          })
          .flat()
          .map(id => {
            // Extract ID if it's an object
            if (typeof id === 'object' && id?._id) {
              return String(id._id).trim();
            }
            return String(id).trim();
          })
          .filter(id => id && id !== ''); // Remove empty values
      } else if (employee.department) {
        // Handle legacy single department field
        if (typeof employee.department === 'string' && employee.department.includes(',')) {
          employeeDepts = employee.department.split(',').map(id => id.trim());
        } else if (Array.isArray(employee.department)) {
          employeeDepts = employee.department.map(id =>
            typeof id === 'object' && id?._id ? String(id._id).trim() : String(id).trim()
          );
        } else {
          const deptId = typeof employee.department === 'object' && employee.department?._id
            ? String(employee.department._id).trim()
            : String(employee.department).trim();
          if (deptId) employeeDepts = [deptId];
        }
      }

      // Remove duplicates
      employeeDepts = [...new Set(employeeDepts)];

      // Check if ANY of the employee's departments match the filter
      matchesDepartment = employeeDepts.includes(String(departmentFilter).trim());

      // Debug logging (can be removed in production)
      if (departmentFilter) {
        console.log('Filtering:', employee.teamMemberName);
        console.log('  Employee departments:', employeeDepts);
        console.log('  Filter:', departmentFilter);
        console.log('  Matches:', matchesDepartment);
      }
    }

    return matchesSearch && matchesDepartment;
  });



  const handleView = (employee) => {
    setViewingEmployee(employee);
    setIsViewModalOpen(true);
  };

  const closeViewModal = () => {
    setIsViewModalOpen(false);
    setViewingEmployee(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading employees...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
          <div className="text-red-500 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 mx-auto mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p className="text-lg font-medium">{error}</p>
          </div>
        </div>
      </div>
    );
  }


  // ------------------------------------------------------------------------------------------------------?
  const toggleEmployeeStatus = async (employeeId) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setShowAlert("Authentication required. Please log in.");
      return;
    }

    const currentEmployee = employees.find(emp => emp._id === employeeId);
    if (!currentEmployee) {
      console.error("Employee not found");
      setShowAlert("Employee not found");
      return;
    }

    const currentBooleanStatus = Boolean(currentEmployee.isActive);
    const newStatus = !currentBooleanStatus;

    // If toggling to INACTIVE, check for recurring tasks
    if (currentBooleanStatus && !newStatus) {
      setUpdatingEmployeeStatus(employeeId);

      // Check for incomplete tasks
      const incompleteTasks = await fetchEmployeeIncompleteTasks(employeeId);

      // Check for recurring tasks
      const recurringTasks = await fetchEmployeeRecurringTasks(employeeId);

      if (recurringTasks.length > 0) {
        const confirmMessage = `⚠️ This employee has ${recurringTasks.length} recurring task(s).\n\n` +
          `Deactivating will STOP creating new instances of these tasks:\n` +
          recurringTasks.map(t => `• ${t.title}`).join('\n') +
          `\n\nDo you want to continue?`;

        if (!window.confirm(confirmMessage)) {
          setUpdatingEmployeeStatus(null);
          return;
        }
      }

      if (incompleteTasks.length > 0) {

        // Show modal with tasks (existing code)
        setEmployeeToToggle({ ...currentEmployee, newStatus });
        setInactiveTasks(incompleteTasks);
        setSelectedTasks([]);
        setShowInactiveModal(true);
        setUpdatingEmployeeStatus(null);
        return;
      }
    }

    // Proceed with status toggle
    await performStatusToggle(employeeId, newStatus, currentEmployee);
  };

  // Perform the actual status toggle
  const performStatusToggle = async (employeeId, newStatus, currentEmployee) => {
    const token = localStorage.getItem("authToken");

    setUpdatingEmployeeStatus(employeeId);

    try {
      const booleanValue = newStatus === true || newStatus === 'true';

      // Get department IDs
      let departmentIds = [];
      if (currentEmployee.departments && Array.isArray(currentEmployee.departments) && currentEmployee.departments.length > 0) {
        departmentIds = currentEmployee.departments;
      } else if (currentEmployee.department) {
        departmentIds = Array.isArray(currentEmployee.department) ? currentEmployee.department : [currentEmployee.department];
      }

      departmentIds = departmentIds.filter(id => id && id.toString().trim() !== '');

      if (departmentIds.length === 0 && departments && departments.length > 0) {
        departmentIds = [departments[0]._id];
      }

      // Create update payload
      const updatePayload = {
        isActive: booleanValue,
        teamMemberName: currentEmployee.teamMemberName,
        email: currentEmployee.email,
        mobileNumber: currentEmployee.mobileNumber,
        departments: departmentIds,
        designation: currentEmployee.designation || [],
        role: currentEmployee.role || 'Employee',
        company: currentEmployee.company
      };


      const response = await axios.put(
        `https://slateblue-mallard-430836.hostingersite.com/api/employees/${employeeId}`,
        updatePayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      // Update local state
      setEmployees(prevEmployees =>
        prevEmployees.map(emp =>
          emp._id === employeeId ? { ...emp, isActive: newStatus } : emp
        )
      );

      if (editingId === employeeId) {
        setFormData(prev => ({ ...prev, isActive: newStatus }));
      }

      if (viewingEmployee && viewingEmployee._id === employeeId) {
        setViewingEmployee(prev => ({ ...prev, isActive: newStatus }));
      }

      // Refresh employee list
      await fetchEmployees();

      if (newStatus) {
        handleEdit({ ...currentEmployee, isActive: true });
      }

      const statusText = newStatus ? 'activated' : 'deactivated';
      setMessage(`Employee ${statusText} successfully!`);

    } catch (err) {
      console.error('❌ Error updating employee status:', err);
      const errorMessage = err.response?.data?.message || err.message || 'Unknown error';
      setShowAlert(`Failed to update employee status: ${errorMessage}`);
      setMessage(`Failed to update employee status: ${errorMessage}`);
    } finally {
      setUpdatingEmployeeStatus(null);
    }
  };


  // Handle task selection (single)
  const handleTaskSelection = (taskId) => {
    setSelectedTasks(prev => {
      if (prev.includes(taskId)) {
        return prev.filter(id => id !== taskId);
      } else {
        return [...prev, taskId];
      }
    });
  };

  // Handle select all tasks
  const handleSelectAllTasks = () => {
    if (selectedTasks.length === inactiveTasks.length) {
      setSelectedTasks([]);
    } else {
      setSelectedTasks(inactiveTasks.map(task => task._id));
    }
  };

  // Handle shift tasks button click
  const handleShiftTasksClick = () => {
    if (selectedTasks.length === 0) {
      setShowAlert('Please select at least one task to shift');
      return;
    }

    const tasksToShift = inactiveTasks.filter(task => selectedTasks.includes(task._id));


    // Close inactive modal and open shift task modal
    setShowInactiveModal(false);
    setShowShiftTaskModal(true);
  };

  // Handle successful shift
  const handleShiftSuccess = async () => {

    // Close shift modal
    setShowShiftTaskModal(false);

    // Proceed with employee deactivation
    if (employeeToToggle) {
      await performStatusToggle(
        employeeToToggle._id,
        employeeToToggle.newStatus,
        employeeToToggle
      );
    }

    // Clean up
    setEmployeeToToggle(null);
    setInactiveTasks([]);
    setSelectedTasks([]);
  };

  // Handle cancel shift
  const handleCancelShift = () => {
    setShowShiftTaskModal(false);
    setShowInactiveModal(true); // Go back to task selection
  };


  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-2">
      <div className="max-w-full mx-auto">
        {/* Header */}
        <div className="mb-4">


          {userRole === 'superadmin' && allCompanies.length > 0 && (
            <div className="mb-6 p-4 bg-white rounded-lg shadow-md">
              {!selectedCompanyId ? (
                <>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Select Company</label>
                  <select
                    onChange={(e) => {
                      const companyId = e.target.value;
                      setSelectedCompanyId(companyId);
                      setFormData(prev => ({ ...prev, company: companyId }));
                      fetchDepartments(companyId);
                      fetchBranches(companyId);
                      fetchLeaveTypes(companyId);
                      fetchEmployees();
                    }}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  >
                    <option value="">Select a company</option>
                    {allCompanies.map(company => (
                      <option key={company._id} value={company._id}>
                        {company.businessName}
                      </option>
                    ))}
                  </select>
                </>
              ) : (
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-700">Selected Company</p>
                    <p className="text-lg font-semibold text-gray-900">
                      {allCompanies.find(c => c._id === selectedCompanyId)?.businessName}
                    </p>
                  </div>
                  <button
                    onClick={() => {
                      setSelectedCompanyId('');
                      setFormData(prev => ({ ...prev, company: '' }));
                      setDepartments([]);
                      setBranches([]);
                      setLeaveTypes([]);
                      setEmployees([]);
                    }}
                    className="px-4 py-2 text-sm text-red-600 hover:text-red-800 border border-red-300 rounded-md hover:bg-red-50"
                  >
                    Change Company
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Employee Management Card - Show when user has employee management access */}
          {(userAccess.list_teammember || userAccess.create_teammember || subscriptionPlan) && (
            <div className="mb-3 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl shadow-md w-full max-w-full">
              <div className="flex justify-between items-center mb-3">
                <div>
                  <h3 className="text-lg font-bold text-blue-900">
                    📋 Employee Management
                  </h3>
                </div>
                {/* Add Employee button - always visible */}
                <button
                  onClick={toggleForm}
                  disabled={subscriptionPlan && allocationDetails.totalLimit > 0 && (allocationDetails.remaining <= 0 || employeeCount >= (subscriptionPlan.plan?.userLimit || subscriptionPlan.userLimit))}
                  className={`px-5 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center whitespace-nowrap shadow-md ${subscriptionPlan && allocationDetails.totalLimit > 0 && (allocationDetails.remaining <= 0 || employeeCount >= (subscriptionPlan.plan?.userLimit || subscriptionPlan.userLimit)) ? 'opacity-50 cursor-not-allowed' : ''}`}
                  title={subscriptionPlan && allocationDetails.totalLimit > 0 && allocationDetails.remaining <= 0 ? 'User limit exhausted. Cannot add more employees or branches.' : ''}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                  </svg>
                  <span>{showForm ? "Cancel" : "Add Employee"}</span>
                </button>
              </div>

              {/* Module Limit Cards */}
              <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                {/* Task Management Module */}
                {(() => {
                  const limit = checkMenuLimit('taskManagement');
                  if (!limit.enabled) return null;
                  return (
                    <div className="bg-white p-3 rounded-lg border border-blue-200 shadow-sm">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-xs font-medium text-gray-600">Tasks</span>
                        <span className="text-xl">📋</span>
                      </div>
                      <p className={`text-2xl font-bold ${limit.isExceeded ? 'text-red-600' : 'text-blue-700'}`}>
                        {limit.hasLimit ? `${limit.used}/${limit.total}` : `${limit.used}/∞`}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {limit.hasLimit ? (limit.isExceeded ? 'Limit reached' : `${limit.remaining} available`) : 'Unlimited'}
                      </p>
                    </div>
                  );
                })()}

                {/* Lead Management Module */}
                {(() => {
                  const limit = checkMenuLimit('leadManagement');
                  if (!limit.enabled) return null;
                  return (
                    <div className="bg-white p-3 rounded-lg border border-green-200 shadow-sm">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-xs font-medium text-gray-600">Leads</span>
                        <span className="text-xl">🎯</span>
                      </div>
                      <p className={`text-2xl font-bold ${limit.isExceeded ? 'text-red-600' : 'text-green-700'}`}>
                        {limit.hasLimit ? `${limit.used}/${limit.total}` : `${limit.used}/∞`}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {limit.hasLimit ? (limit.isExceeded ? 'Limit reached' : `${limit.remaining} available`) : 'Unlimited'}
                      </p>
                    </div>
                  );
                })()}

                {/* HRMS Module */}
                {(() => {
                  const limit = checkMenuLimit('hrms');
                  if (!limit.enabled) return null;
                  return (
                    <div className="bg-white p-3 rounded-lg border border-purple-200 shadow-sm">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-xs font-medium text-gray-600">HRMS</span>
                        <span className="text-xl">👥</span>
                      </div>
                      <p className={`text-2xl font-bold ${limit.isExceeded ? 'text-red-600' : 'text-purple-700'}`}>
                        {limit.hasLimit ? `${limit.used}/${limit.total}` : `${limit.used}/∞`}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {limit.hasLimit ? (limit.isExceeded ? 'Limit reached' : `${limit.remaining} available`) : 'Unlimited'}
                      </p>
                    </div>
                  );
                })()}

                {/* Support Module */}
                {(() => {
                  const limit = checkMenuLimit('support');
                  if (!limit.enabled) return null;
                  return (
                    <div className="bg-white p-3 rounded-lg border border-orange-200 shadow-sm">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-xs font-medium text-gray-600">Support</span>
                        <span className="text-xl">💬</span>
                      </div>
                      <p className={`text-2xl font-bold ${limit.isExceeded ? 'text-red-600' : 'text-orange-700'}`}>
                        {limit.hasLimit ? `${limit.used}/${limit.total}` : `${limit.used}/∞`}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {limit.hasLimit ? (limit.isExceeded ? 'Limit reached' : `${limit.remaining} available`) : 'Unlimited'}
                      </p>
                    </div>
                  );
                })()}

                {/* Project Management Module */}
                {(() => {
                  const limit = checkMenuLimit('projectManagement');
                  if (!limit.enabled) return null;
                  return (
                    <div className="bg-white p-3 rounded-lg border border-indigo-200 shadow-sm">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-xs font-medium text-gray-600">Projects</span>
                        <span className="text-xl">📊</span>
                      </div>
                      <p className={`text-2xl font-bold ${limit.isExceeded ? 'text-red-600' : 'text-indigo-700'}`}>
                        {limit.hasLimit ? `${limit.used}/${limit.total}` : `${limit.used}/∞`}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {limit.hasLimit ? (limit.isExceeded ? 'Limit reached' : `${limit.remaining} available`) : 'Unlimited'}
                      </p>
                    </div>
                  );
                })()}
              </div>

              {/* Progress Bar - Removed since we're showing individual modules now */}

              {/* Warning message if any module is close to limit */}
              {subscriptionPlan && Object.values(['taskManagement', 'leadManagement', 'hrms', 'support', 'projectManagement']).some(module => {
                const limit = checkMenuLimit(module);
                return limit.hasLimit && limit.remaining <= 5 && limit.remaining > 0;
              }) && (
                  <div className="mt-3 p-3 bg-orange-100 border border-orange-300 rounded-lg">
                    <p className="text-sm text-orange-800 font-medium">
                      ⚠️ Warning: Some modules are approaching their user limits. Consider upgrading your plan.
                    </p>
                  </div>
                )}
            </div>
          )}

        </div>


        {/* Alert Message Modal - Centered */}
        {
          message && showAlert && !message.includes("lowercase") && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
              <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 animate-in fade-in zoom-in duration-300">
                <div
                  className={`p-6 rounded-xl border-l-4 ${message.includes("✅")
                    ? "bg-green-50 border-green-500"
                    : "bg-red-50 border-red-500"
                    }`}
                >
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      {message.includes("✅") ? (
                        <svg className="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      ) : (
                        <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      )}
                    </div>
                    <div className="ml-4 flex-1">
                      <h3 className={`text-lg font-semibold ${message.includes("✅") ? "text-green-800" : "text-red-800"
                        }`}>
                        {message.includes("✅") ? "Success" : "Error"}
                      </h3>
                      <p className={`mt-2 text-sm ${message.includes("✅") ? "text-green-700" : "text-red-700"
                        }`}>
                        {message}
                      </p>
                    </div>
                    <button
                      onClick={() => {
                        setMessage("");
                        setShowAlert(false);
                      }}
                      className="ml-4 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="mt-4 flex justify-end">
                    <button
                      onClick={() => {
                        setMessage("");
                        setShowAlert(false);
                      }}
                      className={`px-6 py-2 rounded-lg font-medium transition-colors ${message.includes("✅")
                        ? "bg-green-600 hover:bg-green-700 text-white"
                        : "bg-red-600 hover:bg-red-700 text-white"
                        }`}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        {/* Delete Confirmation Modal */}
        {
          showDeleteModal && (
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Confirm Deletion</h3>
                <p className="text-gray-600 mb-6">Are you sure you want to delete this employee?</p>
                <div className="flex justify-end space-x-4">
                  <button
                    onClick={closeDeleteModal}
                    className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDelete}
                    className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          )
        }

        {/* View Employee Modal */}
        {
          isViewModalOpen && viewingEmployee && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4" style={{ zIndex: '9999' }}>
              <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                  <div className="flex justify-between items-center mb-6">
                    <h3 className="text-2xl font-bold text-gray-800">Employee Details</h3>
                    <button
                      onClick={closeViewModal}
                      className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Personal Information */}
                    <div className="space-y-4">
                      <div className="flex items-center space-x-4 mb-6">
                        <div className="h-24 w-24 rounded-full bg-indigo-100 flex items-center justify-center overflow-hidden">
                          {viewingEmployee.profileImage ? (
                            <img
                              src={`${viewingEmployee.profileImage}?${new Date().getTime()}`}
                              alt={viewingEmployee.teamMemberName || 'Profile'}
                              className="h-full w-full object-cover"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'flex';
                              }}
                            />
                          ) : null}
                          <span className={`text-3xl text-indigo-600 font-semibold ${viewingEmployee.profileImage ? 'hidden' : 'flex'}`}>
                            {viewingEmployee.teamMemberName?.charAt(0).toUpperCase() || 'U'}
                          </span>
                        </div>
                        <div>
                          <h4 className="text-xl font-semibold text-gray-800">{viewingEmployee.teamMemberName || 'N/A'}</h4>
                          <p className="text-gray-600">{viewingEmployee.role || 'N/A'}</p>
                          <div className="text-sm text-gray-500">
                            {Array.isArray(viewingEmployee.departments) && viewingEmployee.departments.length > 0 ? (
                              <div className="flex flex-wrap gap-1 mt-1">
                                {viewingEmployee.departments.map((deptId) => {
                                  const dept = departments.find(d => d._id === deptId);
                                  return dept ? (
                                    <span key={deptId} className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                      {dept.name}
                                    </span>
                                  ) : null;
                                })}
                              </div>
                            ) : (
                              departments.find(d => d._id === viewingEmployee.department)?.name || 'N/A'
                            )}
                          </div>
                          {viewingEmployee.designation && (
                            <p className="text-sm text-gray-500">
                              {typeof viewingEmployee.designation === 'object'
                                ? viewingEmployee.designation.name
                                : designations.find(d => d._id === viewingEmployee.designation)?.name || viewingEmployee.designation
                              }
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                        <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                          <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0z" />
                          </svg>
                          Personal Information
                        </h5>
                        <div className="space-y-2">
                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Full Name:</p>
                            <p className="text-sm font-medium text-gray-800 flex-1">{viewingEmployee.teamMemberName || 'N/A'}</p>
                          </div>
                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Email:</p>
                            <p className="text-sm text-blue-600 flex-1">{viewingEmployee.email || 'N/A'}</p>
                          </div>
                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Mobile:</p>
                            <p className="text-sm text-gray-800 flex-1">{viewingEmployee.mobileNumber || 'N/A'}</p>
                          </div>
                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Emergency Contact:</p>
                            <p className="text-sm text-gray-800 flex-1">{viewingEmployee.emergencyMobileNumber || 'N/A'}</p>
                          </div>
                          {viewingEmployee.address && (
                            <div className="flex">
                              <p className="text-sm text-gray-500 w-32">Address:</p>
                              <p className="text-sm text-gray-800 flex-1">{viewingEmployee.address}</p>
                            </div>
                          )}

                          {/* Employee Status & Location Tracking */}
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            {/* Employee Status Card */}
                            <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                              <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                                <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                Employee Status
                              </h5>
                              <div className="flex items-center space-x-3">
                                <div className={`w-3 h-3 rounded-full ${viewingEmployee.isActive === true ? 'bg-green-500' : 'bg-red-500'}`}></div>
                                <span className={`px-3 py-1 text-sm font-medium rounded-full ${viewingEmployee.isActive === true ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                  {viewingEmployee.isActive === true ? 'Active' : 'Inactive'}
                                </span>
                              </div>
                            </div>

                            {/* Location Tracking Card */}
                            <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                              <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                                <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Location Tracking
                              </h5>
                              <div className="flex items-center space-x-3">
                                <div className={`w-3 h-3 rounded-full ${viewingEmployee.locationTracking === true ? 'bg-blue-500' : 'bg-gray-400'}`}></div>
                                <span className={`px-3 py-1 text-sm font-medium rounded-full ${viewingEmployee.locationTracking === true ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`}>
                                  {viewingEmployee.locationTracking === true ? 'Enabled' : 'Disabled'}
                                </span>
                              </div>
                            </div>

                            {/* Punch In Setting Card */}
                            <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                              <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                                <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                Punch In Setting
                              </h5>
                              <div className="flex items-center space-x-3">
                                <div className={`w-3 h-3 rounded-full ${viewingEmployee.isFieldWork === true ? 'bg-green-500' : 'bg-orange-500'}`}></div>
                                <span className={`px-3 py-1 text-sm font-medium rounded-full ${viewingEmployee.isFieldWork === true ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'}`}>
                                  {viewingEmployee.isFieldWork === true ? 'From Anywhere' : 'Office Area Only'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    {/* Work Information */}
                    <div className="space-y-4">
                      <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                        <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                          <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                          </svg>
                          Work Information
                        </h5>
                        <div className="grid grid-cols-1 gap-2">
                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Employee ID:</p>
                            <p className="text-sm font-medium text-gray-800 flex-1">{viewingEmployee._id?.substring(0, 8) || 'N/A'}</p>
                          </div>
                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Date of Joining:</p>
                            <p className="text-sm text-gray-800 flex-1">
                              {viewingEmployee.dateOfJoining ? new Date(viewingEmployee.dateOfJoining).toLocaleDateString() : 'N/A'}
                            </p>
                          </div>
                          {/* Department Field - UPDATED */}
                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Departments</p>
                            <div className="text-sm text-gray-800 flex-1">
                              {(() => {
                                if (!viewingEmployee.departments && !viewingEmployee.department) {
                                  return 'NA';
                                }

                                let deptIds = [];

                                // Handle array format
                                if (Array.isArray(viewingEmployee.departments)) {
                                  deptIds = viewingEmployee.departments
                                    .flatMap(item => {
                                      if (typeof item === 'string' && item.includes(',')) {
                                        return item.split(',').map(id => id.trim());
                                      }
                                      return item;
                                    })
                                    .map(id => {
                                      if (typeof id === 'object' && id?._id) {
                                        return String(id._id);
                                      }
                                      return String(id);
                                    })
                                    .filter(id => id && id !== '');
                                } else if (viewingEmployee.department) {
                                  // Handle legacy single value
                                  if (typeof viewingEmployee.department === 'string' && viewingEmployee.department.includes(',')) {
                                    deptIds = viewingEmployee.department.split(',').map(id => id.trim());
                                  } else if (Array.isArray(viewingEmployee.department)) {
                                    deptIds = viewingEmployee.department.map(id =>
                                      typeof id === 'object' && id?._id ? String(id._id) : String(id)
                                    );
                                  } else {
                                    const id = typeof viewingEmployee.department === 'object' && viewingEmployee.department?._id
                                      ? String(viewingEmployee.department._id)
                                      : String(viewingEmployee.department);
                                    deptIds = [id];
                                  }
                                }

                                // Remove duplicates
                                deptIds = [...new Set(deptIds)];

                                if (deptIds.length === 0) {
                                  return 'NA';
                                }

                                // Map to department names
                                const deptNames = deptIds
                                  .map(deptId => {
                                    const dept = departments.find(d => d._id === deptId || d._id === String(deptId));
                                    return dept ? dept.name : null;
                                  })
                                  .filter(name => name);

                                if (deptNames.length === 0) {
                                  return 'NA';
                                }

                                return (
                                  <div className="flex flex-wrap gap-1">
                                    {deptNames.map((name, idx) => (
                                      <span
                                        key={idx}
                                        className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
                                      >
                                        {name}
                                      </span>
                                    ))}
                                  </div>
                                );
                              })()}
                            </div>
                          </div>

                          {/* Designation Field - FIXED */}
                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Designation</p>
                            <div className="text-sm text-gray-800 flex-1">
                              {(() => {
                                // Handle different designation formats
                                if (!viewingEmployee.designation) {
                                  return 'NA';
                                }

                                // If designation is an array
                                if (Array.isArray(viewingEmployee.designation)) {
                                  if (viewingEmployee.designation.length === 0) {
                                    return 'NA';
                                  }

                                  // Map designation IDs to names
                                  const designationNames = viewingEmployee.designation
                                    .map(desigId => {
                                      // Handle object with _id
                                      const id = typeof desigId === 'object' && desigId?._id ? desigId._id : desigId;

                                      // Find designation by ID
                                      const desig = designations.find(d => d._id === id || d._id === String(id));
                                      return desig ? desig.name : null;
                                    })
                                    .filter(name => name); // Remove nulls

                                  if (designationNames.length === 0) {
                                    return 'NA';
                                  }

                                  // Display as badges
                                  return (
                                    <div className="flex flex-wrap gap-1">
                                      {designationNames.map((name, idx) => (
                                        <span
                                          key={idx}
                                          className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800"
                                        >
                                          {name}
                                        </span>
                                      ))}
                                    </div>
                                  );
                                }

                                // If designation is a single value (string or object)
                                const id = typeof viewingEmployee.designation === 'object' && viewingEmployee.designation?._id
                                  ? viewingEmployee.designation._id
                                  : viewingEmployee.designation;

                                const desig = designations.find(d => d._id === id || d._id === String(id));
                                return desig ? desig.name : viewingEmployee.designation;
                              })()}
                            </div>
                          </div>

                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Role:</p>
                            <p className="text-sm text-gray-800 flex-1">
                              {viewingEmployee.role || 'N/A'}
                            </p>
                          </div>
                          <div className="flex">
                            <p className="text-sm text-gray-500 w-32">Shift:</p>
                            <p className="text-sm text-gray-800 flex-1">
                              {viewingEmployee.shift ? (
                                (() => {
                                  // First try to find by ID (new format)
                                  let shiftData = shifts.find(s => s._id === viewingEmployee.shift);
                                  // If not found, try to find by name (legacy format)
                                  if (!shiftData) {
                                    shiftData = shifts.find(s => s.name === viewingEmployee.shift);
                                  }
                                  return shiftData
                                    ? `${shiftData.name} (${convertTo12Hour(shiftData.startTime)} - ${convertTo12Hour(shiftData.endTime)})`
                                    : viewingEmployee.shift;
                                })()
                              ) : 'N/A'}
                            </p>
                          </div>


                        </div>
                      </div>

                      {/* Document Information */}
                      <div className="space-y-4">
                        <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                          <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                            <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            Document Information
                          </h5>
                          <div className="grid grid-cols-1 gap-2">
                            <div className="flex">
                              <p className="text-sm text-gray-500 w-32">PAN Number:</p>
                              <p className="text-sm text-gray-800 flex-1">{viewingEmployee.panNumber || 'N/A'}</p>
                            </div>
                            {viewingEmployee.aadharNumber && (
                              <div className="flex">
                                <p className="text-sm text-gray-500 w-32">Aadhar Number:</p>
                                <p className="text-sm text-gray-800 flex-1">{viewingEmployee.aadharNumber}</p>
                              </div>
                            )}
                            {viewingEmployee.userUpi && (
                              <div className="flex">
                                <p className="text-sm text-gray-500 w-32">UPI ID:</p>
                                <p className="text-sm text-gray-800 flex-1">{viewingEmployee.userUpi}</p>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Document Images */}
                        <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                          <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                            <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            Document Images
                          </h5>
                          <div className="flex flex-wrap gap-4">
                            {viewingEmployee.panImage && (
                              <div className="text-center">
                                <button
                                  onClick={() => setIsPanImageModalOpen(true)}
                                  className="w-24 h-24 bg-gray-100 rounded-lg overflow-hidden border border-gray-200 flex items-center justify-center hover:bg-gray-50 transition-colors"
                                >
                                  <img
                                    src={`${viewingEmployee.panImage}?${new Date().getTime()}`}
                                    alt="PAN Card"
                                    className="max-w-full max-h-full object-cover"
                                    onError={(e) => {
                                      e.target.src = 'https://via.placeholder.com/200x150?text=Image+Not+Available';
                                    }}
                                  />
                                </button>
                                <p className="text-xs text-gray-500 mt-1">PAN Card</p>
                              </div>
                            )}

                            {viewingEmployee.adharImage && (
                              <div className="text-center">
                                <button
                                  onClick={() => setIsAadharImageModalOpen(true)}
                                  className="w-24 h-24 bg-gray-100 rounded-lg overflow-hidden border border-gray-200 flex items-center justify-center hover:bg-gray-50 transition-colors"
                                >
                                  <img
                                    src={`${viewingEmployee.adharImage}?${new Date().getTime()}`}
                                    alt="Aadhar Card"
                                    className="max-w-full max-h-full object-cover"
                                    onError={(e) => {
                                      e.target.src = 'https://via.placeholder.com/200x150?text=Image+Not+Available';
                                    }}
                                  />
                                </button>
                                <p className="text-xs text-gray-500 mt-1">Aadhar Card</p>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Paid Leaves */}
                        {viewingEmployee.paidLeaves && viewingEmployee.paidLeaves.length > 0 && (
                          <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                            <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                              <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a2 2 0 012-2h4a2 2 0 012 2v4m-6 4h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                              Paid Leaves
                            </h5>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                              {viewingEmployee.paidLeaves.map((leave, index) => (
                                <div key={index} className="flex items-center justify-between bg-gray-50 p-2 rounded">
                                  <span className="text-sm font-medium text-gray-700">{leave.type}</span>
                                  <span className="text-sm text-gray-600">{leave.count} days</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Additional Documents Section */}
                        {/* Additional Documents Section */}





                        {/* Branch Access */}
                        {branches.length > 0 && (
                          <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                            <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                              <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-2m2-0h-2m0-3h.01M17 18h.01M14 18h.01" />
                              </svg>
                              Branch Access
                            </h5>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-32 overflow-y-auto p-2">
                              {(() => {
                                const employeeBranches = viewingEmployee.branchAccess || [];
                                return branches.map((branch) => (
                                  <div key={branch._id} className="flex items-center space-x-2 p-2 bg-gray-50 rounded">
                                    <span className={`h-2 w-2 rounded-full ${employeeBranches.includes(branch._id) ? 'bg-green-500' : 'bg-gray-300'
                                      }`}></span>
                                    <span className="text-sm text-gray-700">{branch.businessName}</span>
                                    {employeeBranches.includes(branch._id) && (
                                      <span className="text-xs text-green-600 font-medium">✅Access</span>
                                    )}
                                  </div>
                                ));
                              })()}
                            </div>
                          </div>
                        )}

                        {/* Access Permissions */}
                        <div className="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
                          <h5 className="text-sm font-medium text-gray-700 uppercase tracking-wider mb-3 pb-2 border-b border-gray-100">
                            <svg className="h-4 w-4 inline-block mr-2 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                            Access Permissions
                          </h5>
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-48 overflow-y-auto p-2">
                            {(() => {
                              // Get permissions from multiple possible sources
                              const permissions = viewingEmployee.userAccess ||
                                viewingEmployee.accessPermissions ||
                                viewingEmployee.permissions ||
                                viewingEmployee.access || {};

                              // Handle array format
                              let permissionsObj = permissions;
                              if (Array.isArray(permissions)) {
                                permissionsObj = {};
                                permissions.forEach(permission => {
                                  permissionsObj[permission] = true;
                                });
                              }

                              const activePermissions = Object.entries(permissionsObj).filter(([key, value]) => value);

                              if (activePermissions.length === 0) {
                                return (
                                  <p className="text-sm text-gray-500 italic col-span-2">No special permissions assigned</p>
                                );
                              }

                              return activePermissions.map(([key, value]) => (
                                <div key={key} className="flex items-center">
                                  <svg className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                  </svg>
                                  <span className="text-sm text-gray-700 capitalize">
                                    {key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                                  </span>
                                </div>
                              ));
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Address */}
                  {viewingEmployee.address && (
                    <div className="mt-6 pt-6 border-t border-gray-200">
                      <h5 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2">Address</h5>
                      <p className="text-gray-700">{viewingEmployee.address}</p>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div className="mt-6 pt-4 border-t border-gray-200 flex flex-wrap gap-3 justify-between">
                    <div className="space-x-3">
                      <button
                        onClick={closeViewModal}
                        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        Close
                      </button>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        {/* PAN Image Modal */}
        {
          isPanImageModalOpen && viewingEmployee?.panImage && (
            <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[60] p-4">
              <div className="bg-white rounded-xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold text-gray-800">PAN Card</h3>
                    <button
                      onClick={() => setIsPanImageModalOpen(false)}
                      className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="flex justify-center bg-gray-100 p-4 rounded-lg">
                    <img
                      src={`${viewingEmployee.panImage}?${new Date().getTime()}`}
                      alt="PAN Card"
                      className="max-w-full max-h-[70vh] object-contain"
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/500x300?text=Image+Not+Available';
                      }}
                    />
                  </div>
                  <div className="mt-6 flex justify-end">
                    <button
                      onClick={() => setIsPanImageModalOpen(false)}
                      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        {/* Aadhar Image Modal */}
        {
          isAadharImageModalOpen && viewingEmployee?.adharImage && (
            <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[60] p-4">
              <div className="bg-white rounded-xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-6">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold text-gray-800">Aadhar Card</h3>
                    <button
                      onClick={() => setIsAadharImageModalOpen(false)}
                      className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="flex justify-center bg-gray-100 p-4 rounded-lg">
                    <img
                      src={`${viewingEmployee.adharImage}?${new Date().getTime()}`}
                      alt="Aadhar Card"
                      className="max-w-full max-h-[70vh] object-contain"
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/500x300?text=Image+Not+Available';
                      }}
                    />
                  </div>
                  <div className="mt-6 flex justify-end">
                    <button
                      onClick={() => setIsAadharImageModalOpen(false)}
                      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )
        }

        {/* Add/Edit Employee Form */}
        {
          showForm && (
            <div ref={formRef} className="bg-white rounded-xl shadow-md p-3 mb-4">
              <h2 className="text-xl font-semibold text-gray-800 mb-6">
                {editingId ? "Edit Employee" : "Add New Employee"}
              </h2>

              <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6" encType="application/json">
                {/* Personal Information */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Team Member Name *</label>
                    <input
                      type="text"
                      name="teamMemberName"
                      value={formData.teamMemberName}
                      onChange={handleChange}
                      required
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${validationErrors.teamMemberName
                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        }`}
                      placeholder="Enter full name (letters only)"
                      maxLength="50"
                    />
                    {validationErrors.teamMemberName && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                        {validationErrors.teamMemberName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number *</label>
                    <input
                      type="text"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleChange}
                      required
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${validationErrors.mobileNumber
                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        }`}
                      placeholder="Enter 10-digit mobile number"
                      maxLength="10"
                    />
                    {validationErrors.mobileNumber && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                        {validationErrors.mobileNumber}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Emergency Mobile Number</label>
                    <input
                      type="text"
                      name="emergencyMobileNumber"
                      value={formData.emergencyMobileNumber}
                      onChange={handleChange}
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${validationErrors.emergencyMobileNumber
                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        }`}
                      placeholder="Enter 10-digit emergency mobile number"
                      maxLength="10"
                    />
                    {validationErrors.emergencyMobileNumber && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                        {validationErrors.emergencyMobileNumber}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${formData.email && formData.email !== formData.email.toLowerCase()
                        ? 'border-red-500 bg-red-50 focus:ring-red-500'
                        : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        }`}
                      placeholder="email@example.com"
                    />
                    {formData.email && formData.email !== formData.email.toLowerCase() ? (
                      <p className="text-xs text-red-600 mt-1 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        Email must be in lowercase letters only
                      </p>
                    ) : (
                      <p className="text-xs text-gray-500 mt-1">¡ Use lowercase letters only (e.g., user@example.com)</p>
                    )}
                  </div>






                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Password {editingId ? "(Not editable)" : "*"}
                    </label>

                    <input
                      type={showPassword ? "text" : "password"} // ˆ toggle password visibility
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required={!editingId}
                      disabled={!!editingId}
                      className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none ${editingId
                        ? "bg-gray-100 cursor-not-allowed"
                        : "focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                        }`}
                      placeholder={editingId ? "Password cannot be changed" : "Set a password"}
                    />

                    {!editingId && (
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute inset-y-0 right-3 top-[25px] flex items-center text-gray-500"
                      >
                        {showPassword ? <EyeOffIcon size={25} /> : <EyeIcon size={25} />}
                      </button>
                    )}
                  </div>

                  <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="profileImage">
                      Profile Image
                    </label>
                    <div className="flex items-center">
                      <div className="relative">
                        {formData.profileImagePreview ? (
                          <div className="relative">
                            <img
                              src={formData.profileImagePreview}
                              alt="Profile Preview"
                              className="h-20 w-20 rounded-full object-cover border-2 border-gray-300"
                            />
                            <label
                              htmlFor="profileImage"
                              className="absolute -bottom-1 -right-1 bg-blue-500 text-white rounded-full p-1 cursor-pointer hover:bg-blue-600 transition-colors"
                              title="Change photo"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                              </svg>
                            </label>
                          </div>
                        ) : (
                          <div className="h-20 w-20 rounded-full bg-gray-200 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M16 7a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                          </div>
                        )}
                        <input
                          type="file"
                          id="profileImage"
                          name="profileImage"
                          accept="image/*"
                          onChange={handleImageChange}
                          className="hidden"
                        />
                      </div>
                      <div className="ml-4">
                        <label
                          htmlFor="profileImage"
                          className="px-3 py-1.5 bg-white border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
                        >
                          {formData.profileImagePreview ? 'Change' : 'Upload'} Photo
                        </label>
                        {formData.profileImagePreview && (
                          <button
                            type="button"
                            onClick={() => setFormData(prev => ({ ...prev, profileImage: null, profileImagePreview: null }))}
                            className="ml-2 px-3 py-1.5 bg-red-50 border border-red-200 rounded-md shadow-sm text-sm leading-4 font-medium text-red-600 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                    <p className="mt-1 text-sm text-gray-500">
                      JPG, GIF or PNG. Max size 2MB
                    </p>
                  </div>
                  <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="panImage">
                      PAN Card Image
                    </label>
                    <div className="flex items-center">
                      <div className="relative">
                        {formData.panImagePreview ? (
                          <div className="relative">
                            <img
                              src={formData.panImagePreview}
                              alt="PAN Card Preview"
                              className="h-32 w-48 object-cover border-2 border-gray-300 rounded"
                            />
                            <label
                              htmlFor="panImage"
                              className="absolute -bottom-1 -right-1 bg-blue-500 text-white rounded-full p-1 cursor-pointer hover:bg-blue-600 transition-colors"
                              title="Change PAN image"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                              </svg>
                            </label>
                          </div>
                        ) : (
                          <div className="h-32 w-48 border-2 border-dashed border-gray-300 rounded flex items-center justify-center">
                            <div className="text-center">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-400 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                              <p className="text-xs text-gray-500 mt-1">Upload PAN Card</p>
                            </div>
                          </div>
                        )}
                        <input
                          type="file"
                          id="panImage"
                          name="panImage"
                          accept="image/*"
                          onChange={handlePanImageChange}
                          className="hidden"
                        />
                      </div>
                      <div className="ml-4">
                        <label
                          htmlFor="panImage"
                          className="px-3 py-1.5 bg-white border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
                        >
                          {formData.panImagePreview ? 'Change' : 'Upload'} PAN
                        </label>
                        {formData.panImagePreview && (
                          <button
                            type="button"
                            onClick={() => setFormData(prev => ({ ...prev, panImage: null, panImagePreview: null }))}
                            className="ml-2 px-3 py-1.5 bg-red-50 border border-red-200 rounded-md shadow-sm text-sm leading-4 font-medium text-red-600 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                    <p className="mt-1 text-sm text-gray-500">
                      JPG, GIF or PNG. Max size 2MB
                    </p>
                  </div>

                  <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="adharImage">
                      Aadhar Card Image
                    </label>
                    <div className="flex items-center">
                      <div className="relative">
                        {formData.adharImagePreview ? (
                          <div className="relative">
                            <img
                              src={formData.adharImagePreview}
                              alt="Aadhar Card Preview"
                              className="h-32 w-48 object-cover border-2 border-gray-300 rounded"
                            />
                            <label
                              htmlFor="adharImage"
                              className="absolute -bottom-1 -right-1 bg-blue-500 text-white rounded-full p-1 cursor-pointer hover:bg-blue-600 transition-colors"
                              title="Change Aadhar image"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                              </svg>
                            </label>
                          </div>
                        ) : (
                          <div className="h-32 w-48 border-2 border-dashed border-gray-300 rounded flex items-center justify-center">
                            <div className="text-center">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-400 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                              <p className="text-xs text-gray-500 mt-1">Upload Aadhar Card</p>
                            </div>
                          </div>
                        )}
                        <input
                          type="file"
                          id="adharImage"
                          name="adharImage"
                          accept="image/*"
                          onChange={handleAadharImageChange}
                          className="hidden"
                        />
                      </div>
                      <div className="ml-4">
                        <label
                          htmlFor="adharImage"
                          className="px-3 py-1.5 bg-white border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
                        >
                          {formData.adharImagePreview ? 'Change' : 'Upload'} Aadhar
                        </label>
                        {formData.adharImagePreview && (
                          <button
                            type="button"
                            onClick={() => setFormData(prev => ({ ...prev, adharImage: null, adharImagePreview: null }))}
                            className="ml-2 px-3 py-1.5 bg-red-50 border border-red-200 rounded-md shadow-sm text-sm leading-4 font-medium text-red-600 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                    <p className="mt-1 text-sm text-gray-500">
                      JPG, GIF or PNG. Max size 2MB
                    </p>
                  </div>

                </div>

                {/* Job & Work Information */}
                <div className="space-y-4">
                  {renderDepartmentSelection()}
                  {renderDesignationDropdown()}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Salary</label>
                    <input
                      type="text"
                      name="salary"
                      value={formData.salary}
                      onChange={handleChange}
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${validationErrors.salary
                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        }`}
                      placeholder="Enter salary amount (numbers only)"
                    />
                    {validationErrors.salary && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                        {validationErrors.salary}
                      </p>
                    )}
                  </div>

                  {/* PF and ESIC Options */}

                  {formData.salary && parseFloat(formData.salary) > 0 && (
                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                      <h4 className="text-sm font-medium text-blue-800 mb-3">
                        🔍 Deduction Options
                      </h4>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" style={{ fontSize: 0 }}>
                        {/* PF Option */}
                        <div className="bg-white p-3 rounded border" style={{ fontSize: '14px' }}>
                          <div className="flex items-center justify-between mb-2">
                            <label className="flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                checked={formData.pfEnabled}
                                onChange={(e) => {
                                  const isEnabled = e.target.checked;
                                  setFormData(prev => ({
                                    ...prev,
                                    pfEnabled: isEnabled,
                                    // FIX: Reset percentage to 0 when deselected
                                    pfPercentage: isEnabled ? prev.pfPercentage || 12 : 0
                                  }));
                                }}
                                className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              />
                              <span className="text-sm font-medium text-gray-700">
                                PF (Provident Fund)
                              </span>
                            </label>
                            {/* FIX: Disable input when unchecked */}
                            <input
                              type="number"
                              value={formData.pfPercentage}
                              onChange={(e) => setFormData(prev => ({ ...prev, pfPercentage: parseFloat(e.target.value) || 0 }))}
                              disabled={!formData.pfEnabled}  // Disable when unchecked
                              className="w-16 px-2 py-1 text-xs border border-gray-300 rounded disabled:bg-gray-100 disabled:cursor-not-allowed"
                              min="0"
                              max="100"
                              step="0.1"
                            />
                          </div>
                          {/* FIX: Only show calculations if enabled */}
                          {formData.pfEnabled && (
                            <div className="text-xs text-gray-600">
                              <div className="flex justify-between">
                                <span>Basic Salary:</span>
                                <span className="font-medium">₹{parseFloat(formData.salary || 0).toLocaleString('en-IN')}</span>
                              </div>
                              <div className="flex justify-between">
                                <span>PF Deduction ({formData.pfPercentage}%):</span>
                                <span className="font-medium text-red-600">
                                  -₹{((parseFloat(formData.salary || 0) * formData.pfPercentage) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                </span>
                              </div>
                              <div className="flex justify-between border-t pt-1 mt-1">
                                <span className="font-medium">Net Amount:</span>
                                <span className="font-medium text-green-600">
                                  ₹{(parseFloat(formData.salary || 0) - ((parseFloat(formData.salary || 0) * formData.pfPercentage) / 100)).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* ESIC Option - Apply same fixes */}
                        <div className="bg-white p-3 rounded border" style={{ fontSize: '14px' }}>
                          <div className="flex items-center justify-between mb-2">
                            <label className="flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                checked={formData.esicEnabled}
                                onChange={(e) => {
                                  const isEnabled = e.target.checked;
                                  setFormData(prev => ({
                                    ...prev,
                                    esicEnabled: isEnabled,
                                    esicPercentage: isEnabled ? prev.esicPercentage || 3.25 : 0
                                  }));
                                }}
                                className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                              />
                              <span className="text-sm font-medium text-gray-700">
                                ¥ ESIC (Medical Insurance)
                              </span>
                            </label>
                            <input
                              type="number"
                              value={formData.esicPercentage}
                              onChange={(e) => setFormData(prev => ({ ...prev, esicPercentage: parseFloat(e.target.value) || 0 }))}
                              disabled={!formData.esicEnabled}
                              className="w-16 px-2 py-1 text-xs border border-gray-300 rounded disabled:bg-gray-100 disabled:cursor-not-allowed"
                              min="0"
                              max="100"
                              step="0.01"
                            />
                          </div>
                          {formData.esicEnabled && (
                            <div className="text-xs text-gray-600">
                              {/* Same calculation structure as PF */}
                              <div className="flex justify-between">
                                <span>Basic Salary:</span>
                                <span className="font-medium">₹{parseFloat(formData.salary || 0).toLocaleString('en-IN')}</span>
                              </div>
                              <div className="flex justify-between">
                                <span>ESIC Deduction ({formData.esicPercentage}%):</span>
                                <span className="font-medium text-red-600">
                                  -₹{((parseFloat(formData.salary || 0) * formData.esicPercentage) / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                </span>
                              </div>
                              <div className="flex justify-between border-t pt-1 mt-1">
                                <span className="font-medium">Net Amount:</span>
                                <span className="font-medium text-green-600">
                                  ₹{(parseFloat(formData.salary || 0) - ((parseFloat(formData.salary || 0) * formData.esicPercentage) / 100)).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                    </div>
                  )}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Date of Joining</label>
                    <input
                      type="date"
                      name="dateOfJoining"
                      value={formData.dateOfJoining}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="shift">
                      Shift <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="shift"
                      name="shift"
                      value={formData.shift}
                      onChange={handleChange}
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      required
                    >
                      <option value="">Select Shift</option>
                      {shifts.map((shift) => (
                        <option key={shift._id} value={shift._id}>
                          {shift.name} ({convertTo12Hour(shift.startTime)} - {convertTo12Hour(shift.endTime)})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Role*
                      <span className="text-red-500 ml-1" title="Required field">●</span>
                    </label>
                    <select
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                      required
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${showValidationErrors && !formData.role
                        ? 'border-yellow-400 bg-yellow-50 focus:ring-yellow-500'
                        : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        }`}
                    >
                      <option value="">Select Role</option>
                      {roles.map((role) => (
                        <option key={role} value={role}>
                          {role}
                        </option>
                      ))}
                    </select>
                    {showValidationErrors && !formData.role && (
                      <p className="text-xs text-yellow-600 mt-1 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        Please select a role for this employee
                      </p>
                    )}
                  </div>

                  {/* Employee Status Section */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-3">Employee Status</label>
                      <div className="space-y-3">
                        <div className="flex items-center space-x-4">
                          <label className="flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="isActive"
                              value="true"
                              checked={formData.isActive === true}
                              onChange={(e) => {
                                setFormData(prev => ({ ...prev, isActive: true }));
                              }}
                              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300"
                            />
                            <div className="ml-3 flex items-center space-x-2">
                              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                              <span className="text-sm font-medium text-gray-700">Active</span>
                            </div>
                          </label>

                          <label className="flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="isActive"
                              value="false"
                              checked={formData.isActive === false}
                              onChange={(e) => {
                                setFormData(prev => ({ ...prev, isActive: false }));
                              }}
                              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300"
                            />
                            <div className="ml-3 flex items-center space-x-2">
                              <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                              <span className="text-sm font-medium text-gray-700">Inactive</span>
                            </div>
                          </label>
                        </div>
                        <p className="text-xs text-gray-500">
                          Active employees can access the system.
                        </p>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-3">Location Tracking</label>
                      <div className="space-y-3">
                        <div className="flex items-center space-x-4">
                          <label className="flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="locationTracking"
                              value="true"
                              checked={formData.locationTracking === true}
                              onChange={(e) => {
                                setFormData(prev => ({ ...prev, locationTracking: true }));
                              }}
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                            />
                            <div className="ml-3 flex items-center space-x-2">
                              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                              <span className="text-sm font-medium text-gray-700">Enabled</span>
                            </div>
                          </label>

                          <label className="flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="locationTracking"
                              value="false"
                              checked={formData.locationTracking === false}
                              onChange={(e) => {
                                setFormData(prev => ({ ...prev, locationTracking: false }));
                              }}
                              className="h-4 w-4 text-gray-400 focus:ring-gray-500 border-gray-300"
                            />
                            <div className="ml-3 flex items-center space-x-2">
                              <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                              <span className="text-sm font-medium text-gray-700">Disabled</span>
                            </div>
                          </label>
                        </div>
                        <p className="text-xs text-gray-500">
                          Enable real-time tracking for this employee.
                        </p>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-3">Punch In Setting</label>
                      <div className="space-y-3">
                        <div className="flex items-center space-x-4">
                          <label className="flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="isFieldWork"
                              value="false"
                              checked={formData.isFieldWork === false}
                              onChange={(e) => {
                                setFormData(prev => ({ ...prev, isFieldWork: false }));
                              }}
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                            />
                            <div className="ml-3 flex items-center space-x-2">
                              <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                              <span className="text-sm font-medium text-gray-700">Office Area Only</span>
                            </div>
                          </label>

                          <label className="flex items-center cursor-pointer">
                            <input
                              type="radio"
                              name="isFieldWork"
                              value="true"
                              checked={formData.isFieldWork === true}
                              onChange={(e) => {
                                setFormData(prev => ({ ...prev, isFieldWork: true }));
                              }}
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                            />
                            <div className="ml-3 flex items-center space-x-2">
                              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                              <span className="text-sm font-medium text-gray-700">From Anywhere</span>
                            </div>
                          </label>
                        </div>
                        <p className="text-xs text-gray-500">
                          Restrict employee punch-in locations.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Weekly Holiday</label>
                    <div className="flex flex-wrap gap-4">
                      {days.map((day) => (
                        <label key={day} className="flex items-center">
                          <input
                            type="checkbox"
                            name="weeklyHoliday"
                            value={day}
                            checked={formData.weeklyHoliday.includes(day)}
                            onChange={handleDayChange}
                            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                          />
                          <span className="ml-2 text-sm text-gray-700">{day}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Identity & Address */}
                <div className="space-y-4 md:col-span-2">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Aadhar Number</label>
                    <input
                      type="text"
                      name="aadharNumber"
                      value={formData.aadharNumber}
                      onChange={handleChange}
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${validationErrors.aadharNumber
                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        }`}
                      placeholder="Enter 12-digit Aadhar number"
                      maxLength="12"
                    />
                    {validationErrors.aadharNumber && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                        {validationErrors.aadharNumber}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">PAN Number</label>
                    <input
                      type="text"
                      name="panNumber"
                      value={formData.panNumber}
                      onChange={handleChange}
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${validationErrors.panNumber
                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        }`}
                      placeholder="Enter PAN number (e.g., ABCDE1234F)"
                      maxLength="10"
                      style={{ textTransform: 'uppercase' }}
                    />
                    {validationErrors.panNumber && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                        {validationErrors.panNumber}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">User UPI</label>
                    <input
                      type="text"
                      name="userUpi"
                      value={formData.userUpi}
                      onChange={handleChange}
                      className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 ${validationErrors.userUpi
                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
                        : 'border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        }`}
                      placeholder="Enter UPI ID (e.g., user@paytm)"
                    />
                    {validationErrors.userUpi && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                        {validationErrors.userUpi}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                    <textarea
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      rows={4}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      placeholder="Address"
                    ></textarea>
                  </div>

                  {/* Paid Leaves Section */}
                  {/* Paid Leaves Section */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Paid Leaves</label>
                    <div className="border rounded-lg p-4 bg-gray-50">
                      <div className="flex gap-3 mb-3">
                        <select
                          value={newPaidLeave.type}
                          onChange={(e) => {
                            console.log('Leave type selected:', e.target.value);
                            setNewPaidLeave(prev => ({ ...prev, type: e.target.value }));
                          }}
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                          <option value="">{loadingLeaveTypes ? 'Loading leave types...' : 'Select Leave Type'}</option>
                          {Array.isArray(leaveTypes) && leaveTypes.length > 0 ? (
                            leaveTypes.map((lt) => (
                              <option
                                key={lt._id || lt.id || lt.leaveType || lt.name}
                                value={(lt.leaveType || lt.name || '').toString()}
                              >
                                {(lt.leaveType || lt.name || '').toString()}
                              </option>
                            ))
                          ) : (
                            !loadingLeaveTypes && <option value="" disabled>No leave types available</option>
                          )}
                        </select>
                        <input
                          type="number"
                          min="0"
                          value={newPaidLeave.count}
                          onChange={(e) => {
                            const value = parseInt(e.target.value) || 0;
                            console.log('Leave count changed:', value);
                            setNewPaidLeave(prev => ({ ...prev, count: value }));
                          }}
                          placeholder="Days"
                          className="w-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            console.log('ž• Add button clicked');
                            addPaidLeave();
                          }}
                          disabled={!newPaidLeave.type.trim() || newPaidLeave.count <= 0}
                          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-gray-400 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-indigo-500 whitespace-nowrap"
                        >
                          Add Leave
                        </button>
                      </div>

                      {/* Rest of your paid leaves display code remains the same */}
                      {Array.isArray(formData.paidLeaves) && formData.paidLeaves.length > 0 && (
                        <div className="space-y-2">
                          {formData.paidLeaves.map((leave, index) => (
                            <div key={index} className="bg-white p-3 rounded border">
                              {editingPaidLeaveIndex === index ? (
                                // Edit mode
                                <div className="flex gap-2 items-center">
                                  <select
                                    value={editingPaidLeave.type}
                                    onChange={(e) => setEditingPaidLeave(prev => ({ ...prev, type: e.target.value }))}
                                    className="flex-1 px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                  >
                                    <option value="">Select Leave Type</option>
                                    {Array.isArray(leaveTypes) && leaveTypes.length > 0 ? (
                                      leaveTypes.map((lt) => (
                                        <option key={lt._id || lt.id || lt.leaveType || lt.name} value={(lt.leaveType || lt.name || '').toString()}>
                                          {(lt.leaveType || lt.name || '').toString()}
                                        </option>
                                      ))
                                    ) : (
                                      <option value="" disabled>No leave types available</option>
                                    )}
                                  </select>
                                  <input
                                    type="number"
                                    min="0"
                                    value={editingPaidLeave.count}
                                    onChange={(e) => setEditingPaidLeave(prev => ({ ...prev, count: parseInt(e.target.value) || 0 }))}
                                    className="w-20 px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                  />
                                  <button
                                    type="button"
                                    onClick={saveEditPaidLeave}
                                    className="px-3 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    title="Save changes"
                                  >
                                    ✅                                  </button>
                                  <button
                                    type="button"
                                    onClick={cancelEditPaidLeave}
                                    className="px-3 py-1 bg-gray-500 text-white rounded text-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500"
                                    title="Cancel editing"
                                  >
                                    ✅•
                                  </button>
                                </div>
                              ) : (
                                // View mode
                                <div className="flex items-center justify-between">
                                  <span className="text-sm font-medium">{leave.type}: {leave.count} days</span>
                                  <div className="flex gap-2">
                                    <button
                                      type="button"
                                      onClick={() => startEditPaidLeave(index)}
                                      className="text-blue-600 hover:text-blue-800 text-sm px-2 py-1 rounded hover:bg-blue-50"
                                      title="Edit leave"
                                    >
                                      ✅ï Edit
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => removePaidLeave(index)}
                                      className="text-red-600 hover:text-red-800 text-sm px-2 py-1 rounded hover:bg-red-50"
                                      title="Remove leave"
                                    >
                                      —ï Remove
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Additional Documents Section */}
                  <div className="md:col-span-2">  {/* Ensure full width */}
                    <label className="block text-sm font-medium text-gray-700 mb-2">Additional Documents</label>
                    <div className="border rounded-lg p-4 bg-gray-50">
                      {/* Add Form */}
                      <div className="flex gap-3 mb-3">
                        <input
                          type="text"
                          value={newDocument.type}
                          onChange={(e) => setNewDocument(prev => ({ ...prev, type: e.target.value }))}
                          placeholder="Document type (e.g., Driving License, Passport)"
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          maxLength="50"
                        />
                        <input
                          type="file"
                          ref={fileInputRef}  // ADD REF FOR RESET
                          onChange={(e) => {
                            const selectedFile = e.target.files[0];
                            if (selectedFile && !['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'application/pdf'].includes(selectedFile.type)) {
                              setShowAlert('Please select an image or PDF file only.');
                              e.target.value = '';  // Clear invalid
                              return;
                            }
                            setNewDocument(prev => ({ ...prev, file: selectedFile }));
                          }}
                          accept="image/*,application/pdf"
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        />
                        <button
                          type="button"
                          onClick={addDocument}
                          disabled={!newDocument.type.trim() || !newDocument.file}
                          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-gray-400 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-indigo-500 whitespace-nowrap"
                        >
                          Add Document
                        </button>
                      </div>

                      {/* Documents List */}
                      {Array.isArray(formData.documents) && formData.documents.length > 0 ? (
                        <div className="space-y-3">  {/* Increased spacing */}
                          {formData.documents.map((doc, index) => {
                            return (
                              <div key={index} className="flex items-start justify-between bg-white p-3 rounded-lg border shadow-sm">
                                <div className="flex items-start gap-3 flex-1 min-w-0">  {/* Flex for layout */}
                                  {/* Image/File Preview */}
                                  <div className="flex-shrink-0 relative w-12 h-12 rounded overflow-hidden bg-gray-100">  {/* Fixed size */}
                                    {doc.url ? (
                                      // Existing doc: Cloudinary thumbnail
                                      <>
                                        <img
                                          src={`${doc.url}?w=48&h=48&f=face&c_limit,q_auto`}  // Enhanced Cloudinary params (limit/crop/auto quality)
                                          alt={`${doc.type} preview`}
                                          className="w-full h-full object-cover"
                                          onLoad={() => console.log(`✅ Loaded existing image for ${doc.type}`)}  // Debug success
                                          onError={(e) => {
                                            console.warn(`⚠️ Failed to load image for ${doc.type}:`, e.target.src);  // Debug error
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                          }}
                                        />
                                        <div className="absolute inset-0 flex items-center justify-center bg-gray-200 text-gray-500 hidden">  {/* Fallback icon */}
                                          <span className="text-xs">📄</span>
                                        </div>
                                        <span className="absolute -top-1 -right-1 bg-green-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                                          ✅                                        </span>
                                      </>
                                    ) : doc.file ? (
                                      // New doc: Local preview
                                      <>
                                        <img
                                          src={URL.createObjectURL(doc.file)}
                                          alt={`${doc.type} preview`}
                                          className="w-full h-full object-cover"
                                          onLoad={() => console.log(`✅ Loaded new image preview for ${doc.type}: ${doc.file.name}`)}
                                          onError={(e) => {
                                            console.warn(`⚠️ Failed to load preview for ${doc.file.name}`);  // Debug
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                          }}
                                        />
                                        <div className="absolute inset-0 flex items-center justify-center bg-gray-200 text-gray-500 hidden">
                                          <span className="text-xs">📄</span>
                                        </div>
                                        <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                                          New
                                        </span>
                                      </>
                                    ) : (
                                      // No preview: Show placeholder
                                      <div className="w-full h-full flex items-center justify-center bg-gray-200">
                                        <span className="text-xs text-gray-500">📄</span>
                                      </div>
                                    )}
                                  </div>

                                  {/* Document Details */}
                                  <div className="min-w-0 flex-1 pt-1">  {/* pt-1 for alignment */}
                                    <span className="text-sm font-medium text-gray-900 block truncate" title={doc.type}>
                                      {doc.type}
                                    </span>
                                    {doc.file ? (
                                      <span className="text-xs text-gray-600 block truncate" title={doc.file.name}>
                                        New file: {doc.file.name} ({(doc.file.size / 1024).toFixed(1)} KB)
                                      </span>
                                    ) : doc.url ? (
                                      <span className="text-xs text-gray-600 block">Existing file uploaded</span>
                                    ) : (
                                      <span className="text-xs text-gray-500 block italic">No file attached</span>
                                    )}
                                    {doc.uploadedAt && (
                                      <span className="text-xs text-gray-500 block">Added: {doc.uploadedAt}</span>
                                    )}
                                  </div>
                                </div>

                                {/* Remove Button */}
                                <button
                                  type="button"
                                  onClick={() => removeDocument(index)}
                                  className="ml-3 flex-shrink-0 px-3 py-1.5 bg-red-50 border border-red-200 rounded-md text-red-700 hover:bg-red-100 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-red-500 transition-colors"
                                  title={`Remove ${doc.type}`}
                                >
                                  {editingId ? 'Remove' : 'Delete'}
                                </button>
                              </div>
                            );
                          })}
                          {editingId && documentsToRemove.length > 0 && (
                            <p className="text-xs text-yellow-600 mt-2 p-2 bg-yellow-50 rounded border border-yellow-200">
                              ⚠️ {documentsToRemove.length} document(s) marked for removal on save.
                            </p>
                          )}
                        </div>
                      ) : (
                        <p className="text-sm text-gray-500 italic py-2">No additional documents added yet. Add one above.</p>
                      )}
                    </div>
                  </div>


                </div>

                {/* Branch Access Control */}
                {branches.length > 0 && (
                  <div className="space-y-4 md:col-span-2">
                    <h5 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2">
                      Branch Access Control
                    </h5>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <div className="flex items-center justify-between border-b pb-2 mb-3">
                        <h4 className="font-medium text-gray-800">Available Branches</h4>
                        <button
                          type="button"
                          onClick={() => {
                            const allBranchIds = branches.map(branch => branch._id);
                            const allSelected = allBranchIds.every(id => selectedBranches.includes(id));
                            if (allSelected) {
                              setSelectedBranches([]);
                            } else {
                              setSelectedBranches(allBranchIds);
                            }
                          }}
                          className="text-xs px-2 py-1 bg-indigo-100 text-indigo-700 rounded hover:bg-indigo-200"
                        >
                          {branches.every(branch => selectedBranches.includes(branch._id)) ? 'Deselect All' : 'Select All'}
                        </button>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        {branches.map((branch) => (
                          <label key={branch._id} className="flex items-center space-x-3 p-2 bg-white rounded border hover:bg-gray-50 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={selectedBranches.includes(branch._id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedBranches(prev => [...prev, branch._id]);
                                } else {
                                  setSelectedBranches(prev => prev.filter(id => id !== branch._id));
                                }
                              }}
                              className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                            />
                            <div className="flex-1">
                              <span className="text-sm font-medium text-gray-700">{branch.businessName}</span>
                              <div className="text-xs text-gray-500">
                                {branch.businessEmail} • {branch.address || 'No address'}
                              </div>
                            </div>
                          </label>
                        ))}
                      </div>
                      {selectedBranches.length > 0 && (
                        <div className="mt-3 p-2 bg-green-50 border border-green-200 rounded">
                          <span className="text-sm text-green-700">
                            ✅{selectedBranches.length} branch{selectedBranches.length > 1 ? 'es' : ''} selected for access
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* User Access Control */}
                <div className="space-y-4 md:col-span-2">
                  <h5 className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-2">Access Permissions</h5>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {/* Dashboard */}
                    <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                      <div className="flex items-center justify-between border-b pb-2 mb-2">
                        <h4 className="font-medium text-gray-800">Dashboard</h4>
                        <label className="flex items-center space-x-2">
                          <input
                            type="checkbox"
                            checked={isSectionAllSelected(['dashboard'])}
                            ref={(el) => {
                              if (el) el.indeterminate = isSectionPartiallySelected(['dashboard']);
                            }}
                            onChange={(e) => handleSectionSelectAll(['dashboard'], e.target.checked)}
                            className="form-checkbox h-4 w-4 text-blue-600 rounded"
                            title="Select All Dashboard Permissions"
                          />
                          <span className="text-xs text-gray-500">All</span>
                        </label>
                      </div>
                      <label className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          name="dashboard"
                          checked={userAccess.dashboard}
                          onChange={handlePermissionChange}
                          className="form-checkbox h-4 w-4 text-indigo-600 rounded"
                        />
                        <span className="text-sm text-gray-700">Dashboard Access</span>
                      </label>
                    </div>

                    { /* Team Member */}
                    {(() => {
                      const limit = checkMenuLimit('hrms');
                      if (!limit.enabled) return null;
                      return (
                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                          <div className="flex items-center justify-between border-b pb-2 mb-2">
                            <div className="flex items-center">
                              <h4 className="font-medium text-gray-800">Team Member</h4>
                              {limit.hasLimit && (
                                <span className={`text-xs ml-2 ${limit.isExceeded ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                                  ({limit.used}/{limit.total})
                                </span>
                              )}
                            </div>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSectionAllSelected(['create_teammember', 'employee_report'])}
                                ref={(el) => {
                                  if (el) el.indeterminate = isSectionPartiallySelected(['create_teammember', 'employee_report']);
                                }}
                                onChange={(e) => handleSectionSelectAll(['create_teammember', 'employee_report'], e.target.checked)}
                                disabled={limit.isExceeded && !isSectionAllSelected(['create_teammember', 'employee_report'])}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !isSectionAllSelected(['create_teammember', 'employee_report']) ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
                                title={limit.isExceeded ? "Limit reached" : "Select All Team Member Permissions"}
                              />
                              <span className="text-xs text-gray-500">All</span>
                            </label>
                          </div>
                          {['create_teammember', 'employee_report'].map(permission => (
                            <label key={permission} className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                name={permission}
                                checked={userAccess[permission]}
                                onChange={handlePermissionChange}
                                disabled={limit.isExceeded && !userAccess[permission]}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !userAccess[permission] ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-indigo-600'}`}
                              />
                              <span className={`${limit.isExceeded && !userAccess[permission] ? 'text-gray-400' : 'text-gray-700'} text-sm`}>
                                {permission.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                              </span>
                            </label>
                          ))}
                        </div>
                      );
                    })()}

                    {/* Attendance Member */}
                    {(() => {
                      const limit = checkMenuLimit('hrms');
                      if (!limit.enabled) return null;
                      return (
                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                          <div className="flex items-center justify-between border-b pb-2 mb-2">
                            <div className="flex items-center">
                              <h4 className="font-medium text-gray-800">Attendance</h4>
                              {limit.hasLimit && (
                                <span className={`text-xs ml-2 ${limit.isExceeded ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                                  ({limit.used}/{limit.total})
                                </span>
                              )}
                            </div>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSectionAllSelected(['daily_attendace', 'attendance_report'])}
                                ref={(el) => {
                                  if (el) el.indeterminate = isSectionPartiallySelected(['daily_attendace', 'attendance_report']);
                                }}
                                onChange={(e) => handleSectionSelectAll(['daily_attendace', 'attendance_report'], e.target.checked)}
                                disabled={limit.isExceeded && !isSectionAllSelected(['daily_attendace', 'attendance_report'])}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !isSectionAllSelected(['daily_attendace', 'attendance_report']) ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
                                title={limit.isExceeded ? "Limit reached" : "Select All Attendance Permissions"}
                              />
                              <span className="text-xs text-gray-500">All</span>
                            </label>
                          </div>
                          {['daily_attendace', 'attendance_report'].map(permission => (
                            <label key={permission} className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                name={permission}
                                checked={userAccess[permission]}
                                onChange={handlePermissionChange}
                                disabled={limit.isExceeded && !userAccess[permission]}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !userAccess[permission] ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-indigo-600'}`}
                              />
                              <span className={`${limit.isExceeded && !userAccess[permission] ? 'text-gray-400' : 'text-gray-700'} text-sm`}>
                                {permission.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                              </span>
                            </label>
                          ))}
                        </div>
                      );
                    })()}

                    {/* Leave */}
                    {(() => {
                      const limit = checkMenuLimit('hrms');
                      if (!limit.enabled) return null;
                      return (
                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                          <div className="flex items-center justify-between border-b pb-2 mb-2">
                            <div className="flex items-center">
                              <h4 className="font-medium text-gray-800">Leave</h4>
                              {limit.hasLimit && (
                                <span className={`text-xs ml-2 ${limit.isExceeded ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                                  ({limit.used}/{limit.total})
                                </span>
                              )}
                            </div>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSectionAllSelected(['leave_request', 'leave_approval'])}
                                ref={(el) => {
                                  if (el) el.indeterminate = isSectionPartiallySelected(['leave_request', 'leave_approval']);
                                }}
                                onChange={(e) => handleSectionSelectAll(['leave_request', 'leave_approval'], e.target.checked)}
                                disabled={limit.isExceeded && !isSectionAllSelected(['leave_request', 'leave_approval'])}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !isSectionAllSelected(['leave_request', 'leave_approval']) ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
                                title={limit.isExceeded ? "Limit reached" : "Select All Leave Permissions"}
                              />
                              <span className="text-xs text-gray-500">All</span>
                            </label>
                          </div>
                          {['leave_request', 'leave_approval'].map(permission => (
                            <label key={permission} className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                name={permission}
                                checked={userAccess[permission]}
                                onChange={handlePermissionChange}
                                disabled={limit.isExceeded && !userAccess[permission]}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !userAccess[permission] ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-indigo-600'}`}
                              />
                              <span className={`${limit.isExceeded && !userAccess[permission] ? 'text-gray-400' : 'text-gray-700'} text-sm`}>
                                {permission.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                              </span>
                            </label>
                          ))}
                        </div>
                      );
                    })()}


                    {/* Payroll */}
                    {(() => {
                      const limit = checkMenuLimit('hrms');
                      if (!limit.enabled) return null;
                      return (
                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                          <div className="flex items-center justify-between border-b pb-2 mb-2">
                            <div className="flex items-center">
                              <h4 className="font-medium text-gray-800">Payroll</h4>
                              {limit.hasLimit && (
                                <span className={`text-xs ml-2 ${limit.isExceeded ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                                  ({limit.used}/{limit.total})
                                </span>
                              )}
                            </div>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSectionAllSelected(['salary_generation'])}
                                ref={(el) => {
                                  if (el) el.indeterminate = isSectionPartiallySelected(['salary_generation']);
                                }}
                                onChange={(e) => handleSectionSelectAll(['salary_generation'], e.target.checked)}
                                disabled={limit.isExceeded && !isSectionAllSelected(['salary_generation'])}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !isSectionAllSelected(['salary_generation']) ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
                                title={limit.isExceeded ? "Limit reached" : "Select All Payroll Permissions"}
                              />
                              <span className="text-xs text-gray-500">All</span>
                            </label>
                          </div>
                          {['salary_generation'].map(permission => (
                            <label key={permission} className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                name={permission}
                                checked={userAccess[permission]}
                                onChange={handlePermissionChange}
                                disabled={limit.isExceeded && !userAccess[permission]}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !userAccess[permission] ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-indigo-600'}`}
                              />
                              <span className={`${limit.isExceeded && !userAccess[permission] ? 'text-gray-400' : 'text-gray-700'} text-sm`}>
                                {permission.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                              </span>
                            </label>
                          ))}
                        </div>
                      );
                    })()}

                    {/* Customer Support */}
                    {(() => {
                      const limit = checkMenuLimit('support');
                      if (!limit.enabled) return null;
                      return (
                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                          <div className="flex items-center justify-between border-b pb-2 mb-2">
                            <div className="flex items-center">
                              <h4 className="font-medium text-gray-800">Customer Support</h4>
                              {limit.hasLimit && (
                                <span className={`text-xs ml-2 ${limit.isExceeded ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                                  ({limit.used}/{limit.total})
                                </span>
                              )}
                            </div>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSectionAllSelected(['customer_support', 'com_tickets', 'sup_tickets', 'employee_performance'])}
                                ref={(el) => {
                                  if (el) el.indeterminate = isSectionPartiallySelected(['customer_support', 'com_tickets', 'sup_tickets', 'employee_performance']);
                                }}
                                onChange={(e) => handleSectionSelectAll(['customer_support', 'com_tickets', 'sup_tickets', 'employee_performance'], e.target.checked)}
                                disabled={limit.isExceeded && !isSectionAllSelected(['customer_support', 'com_tickets', 'sup_tickets', 'employee_performance'])}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !isSectionAllSelected(['customer_support', 'com_tickets', 'sup_tickets', 'employee_performance']) ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
                                title={limit.isExceeded ? "Limit reached" : "Select All Customer Support Permissions"}
                              />
                              <span className="text-xs text-gray-500">All</span>
                            </label>
                          </div>
                          {[
                            { key: 'customer_support', label: 'Customer Support' },
                            { key: 'sup_tickets', label: 'Support Tickets' },
                            { key: 'com_tickets', label: 'Company Tickets' },
                            { key: 'employee_performance', label: 'Employee Performance' }
                          ].map(({ key, label }) => (
                            <label key={key} className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                name={key}
                                checked={userAccess[key]}
                                onChange={handlePermissionChange}
                                disabled={limit.isExceeded && !userAccess[key]}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !userAccess[key] ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-indigo-600'}`}
                              />
                              <span className={`${limit.isExceeded && !userAccess[key] ? 'text-gray-400' : 'text-gray-700'} text-sm`}>
                                {label}
                              </span>
                            </label>
                          ))}
                        </div>
                      );
                    })()}



                    {/* Tasks */}
                    {(() => {
                      const limit = checkMenuLimit('taskManagement');
                      if (!limit.enabled) return null;
                      return (
                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                          <div className="flex items-center justify-between border-b pb-2 mb-2">
                            <div className="flex items-center">
                              <h4 className="font-medium text-gray-800">Tasks</h4>
                              {limit.hasLimit && (
                                <span className={`text-xs ml-2 ${limit.isExceeded ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                                  ({limit.used}/{limit.total})
                                </span>
                              )}
                            </div>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSectionAllSelected(['list_task', 'create_task', 'update_task', 'delete_task', 'shifted_task_history', 'shift_task', 'credit_points', 'create_credit_points', 'task_performance'])}
                                ref={(el) => {
                                  if (el) el.indeterminate = isSectionPartiallySelected(['list_task', 'create_task', 'update_task', 'delete_task', 'shifted_task_history', 'shift_task', 'credit_points', 'create_credit_points', 'task_performance']);
                                }}
                                onChange={(e) => handleSectionSelectAll(['list_task', 'create_task', 'update_task', 'delete_task', 'shifted_task_history', 'shift_task', 'credit_points', 'create_credit_points', 'task_performance'], e.target.checked)}
                                disabled={limit.isExceeded && !isSectionAllSelected(['list_task', 'create_task', 'update_task', 'delete_task', 'shifted_task_history', 'shift_task', 'credit_points', 'create_credit_points', 'task_performance'])}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !isSectionAllSelected(['list_task', 'create_task', 'update_task', 'delete_task', 'shifted_task_history', 'shift_task', 'credit_points', 'create_credit_points', 'task_performance']) ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
                                title={limit.isExceeded ? "Limit reached" : "Select All Tasks Permissions"}
                              />
                              <span className="text-xs text-gray-500">All</span>
                            </label>
                          </div>
                          {[
                            { key: 'list_task', label: 'List Task' },
                            { key: 'create_task', label: 'Create Task' },
                            { key: 'update_task', label: 'Edit Task' },
                            { key: 'delete_task', label: 'Delete Task' },
                            { key: 'shifted_task_history', label: 'Shifted Task History' },
                            { key: 'shift_task', label: 'Shift Task' },
                            { key: 'credit_points', label: 'Credit Points' },
                            { key: 'create_credit_points', label: 'Create Credit Points' },
                            { key: 'task_performance', label: 'Task Performance' }
                          ].map(({ key, label }) => (
                            <label key={key} className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                name={key}
                                checked={userAccess[key]}
                                onChange={handlePermissionChange}
                                disabled={limit.isExceeded && !userAccess[key]}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !userAccess[key] ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-indigo-600'}`}
                              />
                              <span className={`${limit.isExceeded && !userAccess[key] ? 'text-gray-400' : 'text-gray-700'} text-sm`}>
                                {label}
                              </span>
                            </label>
                          ))}
                        </div>
                      );
                    })()}

                    {/* Leads */}
                    {(() => {
                      const limit = checkMenuLimit('leadManagement');
                      if (!limit.enabled) return null;
                      return (
                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                          <div className="flex items-center justify-between border-b pb-2 mb-2">
                            <div className="flex items-center">
                              <h4 className="font-medium text-gray-800">Leads</h4>
                              {limit.hasLimit && (
                                <span className={`text-xs ml-2 ${limit.isExceeded ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                                  ({limit.used}/{limit.total})
                                </span>
                              )}
                            </div>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSectionAllSelected(['lead_management', 'add_leads', 'link_generator', 'edit_lead', 'assign_lead'])}
                                ref={(el) => {
                                  if (el) el.indeterminate = isSectionPartiallySelected(['lead_management', 'add_leads', 'link_generator', 'edit_lead', 'assign_lead']);
                                }}
                                onChange={(e) => handleSectionSelectAll(['lead_management', 'add_leads', 'link_generator', 'edit_lead', 'assign_lead'], e.target.checked)}
                                disabled={limit.isExceeded && !isSectionAllSelected(['lead_management', 'add_leads', 'link_generator', 'edit_lead', 'assign_lead'])}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !isSectionAllSelected(['lead_management', 'add_leads', 'link_generator', 'edit_lead', 'assign_lead']) ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
                                title={limit.isExceeded ? "Limit reached" : "Select All Leads Permissions"}
                              />
                              <span className="text-xs text-gray-500">All</span>
                            </label>
                          </div>
                          {['lead_management', 'add_leads', 'link_generator', 'edit_lead', 'assign_lead'].map(permission => (
                            <label key={permission} className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                name={permission}
                                checked={userAccess[permission]}
                                onChange={handlePermissionChange}
                                disabled={limit.isExceeded && !userAccess[permission]}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !userAccess[permission] ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-indigo-600'}`}
                              />
                              <span className={`${limit.isExceeded && !userAccess[permission] ? 'text-gray-400' : 'text-gray-700'} text-sm`}>
                                {permission.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                              </span>
                            </label>
                          ))}
                        </div>
                      );
                    })()}


                    {/* Project Manager */}
                    {(() => {
                      const limit = checkMenuLimit('projectManagement');
                      if (!limit.enabled) return null;
                      return (
                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                          <div className="flex items-center justify-between border-b pb-2 mb-2">
                            <div className="flex items-center">
                              <h4 className="font-medium text-gray-800">Project Manager</h4>
                              {limit.hasLimit && (
                                <span className={`text-xs ml-2 ${limit.isExceeded ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                                  ({limit.used}/{limit.total})
                                </span>
                              )}
                            </div>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSectionAllSelected(['project_dashboard', 'projects', 'project_employee_lists', 'project_tracker', 'project_tasks', 'project_reports'])}
                                ref={(el) => {
                                  if (el) el.indeterminate = isSectionPartiallySelected(['project_dashboard', 'projects', 'project_employee_lists', 'project_tracker', 'project_tasks', 'project_reports']);
                                }}
                                onChange={(e) => handleSectionSelectAll(['project_dashboard', 'projects', 'project_employee_lists', 'project_tracker', 'project_tasks', 'project_reports'], e.target.checked)}
                                disabled={limit.isExceeded && !isSectionAllSelected(['project_dashboard', 'projects', 'project_employee_lists', 'project_tracker', 'project_tasks', 'project_reports'])}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !isSectionAllSelected(['project_dashboard', 'projects', 'project_employee_lists', 'project_tracker', 'project_tasks', 'project_reports']) ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
                                title={limit.isExceeded ? "Limit reached" : "Select All Project Manager Permissions"}
                              />
                              <span className="text-xs text-gray-500">All</span>
                            </label>
                          </div>


                          {['project_dashboard', 'projects', 'project_employee_lists', 'project_tracker', 'project_tasks', 'project_reports'].map(permission => (
                            <label key={permission} className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                name={permission}
                                checked={userAccess[permission]}
                                onChange={handlePermissionChange}
                                disabled={limit.isExceeded && !userAccess[permission]}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !userAccess[permission] ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-indigo-600'}`}
                              />
                              <span className={`${limit.isExceeded && !userAccess[permission] ? 'text-gray-400' : 'text-gray-700'} text-sm`}>
                                {permission.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                              </span>
                            </label>
                          ))}
                        </div>
                      );
                    })()}



                    {/* Department */}
                    {/* <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
  <div className="flex items-center justify-between border-b pb-2 mb-2">
    <h4 className="font-medium text-gray-800">Department</h4>
  </div>
  <label className="flex items-center space-x-2">
    <input
      type="checkbox"
      name="create_department"
      checked={userAccess.create_department}
      onChange={handlePermissionChange}
      className="form-checkbox h-4 w-4 text-indigo-600 rounded"
    />
    <span className="text-sm text-gray-700">Create Department</span>
  </label>
</div> */}




                    {/* Department */}
                    {(() => {
                      const limit = checkMenuLimit('hrms');
                      if (!limit.enabled) return null;
                      return (
                        <div className="space-y-2 p-4 bg-gray-50 rounded-lg">
                          <div className="flex items-center justify-between border-b pb-2 mb-2">
                            <div className="flex items-center">
                              <h4 className="font-medium text-gray-800">Department</h4>
                              {limit.hasLimit && (
                                <span className={`text-xs ml-2 ${limit.isExceeded ? 'text-red-600 font-bold' : 'text-gray-500'}`}>
                                  ({limit.used}/{limit.total})
                                </span>
                              )}
                            </div>
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSectionAllSelected(['create_department', 'update_department', 'leave_type', 'settings_shift', 'update_leave'])}
                                ref={(el) => {
                                  if (el)
                                    el.indeterminate = isSectionPartiallySelected(['create_department', 'update_department', 'leave_type', 'settings_shift', 'update_leave']);
                                }}
                                onChange={(e) =>
                                  handleSectionSelectAll(['create_department', 'update_department', 'leave_type', 'settings_shift', 'update_leave'], e.target.checked)
                                }
                                disabled={limit.isExceeded && !isSectionAllSelected(['create_department', 'update_department', 'leave_type', 'settings_shift', 'update_leave'])}
                                className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !isSectionAllSelected(['create_department', 'update_department', 'leave_type', 'settings_shift', 'update_leave']) ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-blue-600'}`}
                                title={limit.isExceeded ? "Limit reached" : "Select All Department Permissions"}
                              />
                              <span className="text-xs text-gray-500">All</span>
                            </label>
                          </div>

                          {/* Individual permissions */}
                          {['create_department', 'update_department', 'leave_type', 'settings_shift', 'update_leave'].map((permission) => {
                            // Custom display names
                            const displayNames = {
                              create_department: 'Create Department',
                              update_department: 'Create Designation',
                              leave_type: 'Leave Type',
                              settings_shift: 'Settings Shift',
                              update_leave: 'Holidays',
                            };

                            return (
                              <label key={permission} className="flex items-center space-x-2">
                                <input
                                  type="checkbox"
                                  name={permission}
                                  checked={userAccess[permission]}
                                  onChange={handlePermissionChange}
                                  disabled={limit.isExceeded && !userAccess[permission]}
                                  className={`form-checkbox h-4 w-4 rounded ${limit.isExceeded && !userAccess[permission] ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'text-indigo-600'}`}
                                />
                                <span className={`${limit.isExceeded && !userAccess[permission] ? 'text-gray-400' : 'text-gray-700'} text-sm`}>{displayNames[permission]}</span>
                              </label>
                            );
                          })}
                        </div>
                      );
                    })()}
                  </div>
                </div>

                {/* Form Actions */}
                <div className="md:col-span-2 pt-4">
                  <div className="flex flex-col space-y-2">
                    <button
                      type="submit"
                      disabled={!editingId && allocationDetails.remaining <= 0}
                      className={`w-full md:w-auto px-6 py-3 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors duration-200 ${!editingId && allocationDetails.remaining <= 0
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 focus:ring-green-500'
                        }`}
                    >
                      {editingId
                        ? "Update Employee"
                        : allocationDetails.remaining <= 0
                          ? "Limit Reached (Upgrade Plan)"
                          : "Create Employee"
                      }
                    </button>
                    {!editingId && allocationDetails.remaining <= 0 && (
                      <p className="text-xs text-red-500 font-medium">
                        Total limit reached (Company Employees + Branch Allocations). Please upgrade your plan.
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          )
        }

        {/* Employees List */}
        {
          (userAccess.list_teammember || userAccess.create_teammember) ? (
            <div className="bg-white rounded-xl shadow-md overflow-hidden">
              <div className="px-3 py-2 border-b border-gray-200">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <div>
                    <h2 className="text-xl font-semibold text-gray-800">Employee List</h2>
                    <p className="text-gray-600 text-sm">{filteredEmployees.length} employees found</p>
                  </div>
                  <div className="mt-4 md:mt-0 flex flex-col sm:flex-row gap-3">
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <input
                        type="text"
                        placeholder="Search employees by name/email..."
                        className="block w-[400px] pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />

                    </div>
                    <select
                      className="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm rounded-md"
                      value={departmentFilter}
                      onChange={(e) => setDepartmentFilter(e.target.value)}
                    >
                      <option value="">All Departments</option>
                      {departments.map((dept) => (
                        <option key={dept._id} value={dept._id}>
                          {dept.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {employees.length === 0 ? (
                  <div className="p-12 text-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-16 w-16 mx-auto text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-2m2-0h-2m0-3h.01M17 18h.01M14 18h.01M7 18h.01M7 21h.01M7 24h.01M11 21h.01M11 24h.01M15 21h.01M15 24h.01"
                      />
                    </svg>
                    <p className="mt-4 text-gray-600">No employees found. Add your first employee to get started.</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            ID
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Email
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Mobile
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Department
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Role
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Status
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {filteredEmployees.map((employee, index) => (
                          <tr key={employee._id} className="hover:bg-gray-50 transition-colors duration-150">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                              {index + 1}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {employee.teamMemberName}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{employee.email}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {employee.mobileNumber || "N/A"}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {(() => {
                                // Handle the comma-separated department string issue
                                let deptIds = [];

                                if (Array.isArray(employee.departments)) {
                                  deptIds = employee.departments.flatMap(item => {
                                    if (typeof item === 'string' && item.includes(',')) {
                                      return item.split(',').map(id => id.trim());
                                    }
                                    return item;
                                  });
                                } else if (employee.department) {
                                  if (typeof employee.department === 'string' && employee.department.includes(',')) {
                                    deptIds = employee.department.split(',').map(id => id.trim());
                                  } else {
                                    deptIds = [employee.department];
                                  }
                                }

                                if (deptIds.length === 0) return 'N/A';
                                if (departments.length === 0) return 'Loading...';

                                const deptNames = deptIds.map(id => {
                                  const dept = departments.find(d => String(d._id) === String(id));
                                  return dept ? dept.name : `Unknown (${id})`;
                                }).filter(name => name);

                                return (
                                  <div className="flex flex-wrap gap-1">
                                    {deptNames.map((name, idx) => (
                                      <span key={idx} className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-800">
                                        {name}
                                      </span>
                                    ))}
                                  </div>
                                );
                              })()}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              <span
                                className={`px-2 py-1 text-xs font-medium rounded-full ${employee.role ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-800"
                                  }`}>
                                {employee.role || "N/A"}
                              </span>
                            </td>


                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              <div className="flex items-center space-x-3">
                                {/* Status Badge */}
                                <div className="flex items-center space-x-2">
                                  <div className={`w-2 h-2 rounded-full ${employee.isActive === true ? 'bg-green-500' : 'bg-red-500'
                                    }`}></div>
                                  <span className={`px-2 py-1 text-xs font-medium rounded-full ${employee.isActive === true
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-red-100 text-red-800'
                                    }`}>
                                    {employee.isActive === true ? 'Active' : 'Inactive'}
                                  </span>
                                </div>



                                {/* Toggle Switch */}
                                <button
                                  onClick={() => {
                                    toggleEmployeeStatus(employee._id);
                                  }}
                                  disabled={updatingEmployeeStatus === employee._id}
                                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${employee.isActive === true ? 'bg-green-600' : 'bg-gray-200'
                                    } ${updatingEmployeeStatus === employee._id ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                  title={`Click to ${employee.isActive === true ? 'deactivate' : 'activate'} employee`}
                                >
                                  {updatingEmployeeStatus === employee._id ? (
                                    <div className="absolute inset-0 flex items-center justify-center">
                                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                    </div>
                                  ) : (
                                    <span
                                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${employee.isActive === true ? 'translate-x-6' : 'translate-x-1'
                                        }`}
                                    />
                                  )}
                                </button>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              {/* View button - always visible */}
                              <button
                                onClick={() => handleView(employee)}
                                className="text-indigo-600 hover:text-indigo-900 mr-3"
                                title="View Details"
                              >
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                              </button>
                              {/* Edit button - always visible */}
                              <button
                                onClick={() => handleEdit(employee)}
                                className="text-indigo-600 hover:text-indigo-900 mr-3"
                                title="Edit"
                              >
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                </svg>
                              </button>
                              {/* Delete button - always visible */}
                              <button
                                onClick={() => openDeleteModal(employee._id)}
                                className="text-red-600 hover:text-red-900"
                                title="Delete"
                              >
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-2-2V7a2 2 0 011.138-1.857l12.142.867a2 2 0 012 2z" />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              {/* Inactive Employee Tasks Modal */}
              {showInactiveModal && employeeToToggle && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
                  <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
                    {/* Header */}
                    <div className="bg-gradient-to-r from-orange-600 to-red-600 px-6 py-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-xl font-bold text-white">
                            Incomplete Tasks Found
                          </h2>
                          <p className="text-orange-100 text-sm">
                            {employeeToToggle.teamMemberName} has {inactiveTasks.length} incomplete task{inactiveTasks.length !== 1 ? 's' : ''}
                          </p>
                        </div>
                        <button
                          onClick={() => {
                            setShowInactiveModal(false);
                            setEmployeeToToggle(null);
                            setInactiveTasks([]);
                            setSelectedTasks([]);
                            setUpdatingEmployeeStatus(null);
                          }}
                          className="text-white hover:text-orange-200 transition-colors"
                        >
                          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div className="p-6 max-h-[calc(90vh-160px)] overflow-y-auto">
                      {/* Warning Message */}
                      <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                        <div className="flex items-start">
                          <svg className="w-5 h-5 text-yellow-600 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                          </svg>
                          <div>
                            <h4 className="text-sm font-medium text-yellow-800 mb-1">Action Required</h4>
                            <p className="text-sm text-yellow-700">
                              Please select tasks to shift to other employees before deactivating this employee.
                              You can select all or specific tasks.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Select All Checkbox */}
                      <div className="mb-4 flex items-center justify-between bg-gray-50 p-3 rounded-lg border border-gray-200">
                        <label className="flex items-center space-x-3 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedTasks.length === inactiveTasks.length && inactiveTasks.length > 0}
                            onChange={handleSelectAllTasks}
                            className="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                          />
                          <span className="text-sm font-medium text-gray-700">
                            Select All Tasks ({inactiveTasks.length})
                          </span>
                        </label>
                        <span className="text-sm text-gray-600">
                          {selectedTasks.length} selected
                        </span>
                      </div>

                      {/* Task List */}
                      {loadingTasks ? (
                        <div className="flex items-center justify-center py-12">
                          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                          <span className="ml-3 text-gray-600">Loading tasks...</span>
                        </div>
                      ) : inactiveTasks.length === 0 ? (
                        <div className="text-center py-12">
                          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                          <p className="mt-2 text-sm text-gray-500">No incomplete tasks found</p>
                        </div>
                      ) : (
                        <div className="space-y-3">
                          {inactiveTasks.map((task) => (
                            <div
                              key={task._id}
                              className={`p-4 rounded-lg border-2 transition-all cursor-pointer ${selectedTasks.includes(task._id)
                                ? 'border-indigo-500 bg-indigo-50'
                                : 'border-gray-200 bg-white hover:border-gray-300'
                                }`}
                              onClick={() => handleTaskSelection(task._id)}
                            >
                              <div className="flex items-start">
                                <input
                                  type="checkbox"
                                  checked={selectedTasks.includes(task._id)}
                                  onChange={() => handleTaskSelection(task._id)}
                                  className="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded mt-1 mr-3"
                                  onClick={(e) => e.stopPropagation()}
                                />
                                <div className="flex-1">
                                  <div className="flex items-start justify-between">
                                    <div>
                                      <h4 className="font-semibold text-gray-900">{task.title}</h4>
                                      {task.description && (
                                        <p className="text-sm text-gray-600 mt-1">{task.description}</p>
                                      )}
                                    </div>
                                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${task.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                                      task.status === 'in-progress' ? 'bg-blue-100 text-blue-800' :
                                        'bg-gray-100 text-gray-800'
                                      }`}>
                                      {task.status}
                                    </span>
                                  </div>
                                  <div className="mt-2 flex flex-wrap gap-2 text-xs text-gray-500">
                                    {task.startDate && (
                                      <span className="flex items-center">
                                        <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                        Start: {new Date(task.startDate).toLocaleDateString()}
                                      </span>
                                    )}
                                    {task.deadline && (
                                      <span className="flex items-center">
                                        <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        Due: {new Date(task.deadline).toLocaleDateString()}
                                      </span>
                                    )}
                                    {task.priority && (
                                      <span className={`px-2 py-0.5 rounded-full font-medium ${task.priority === 'high' ? 'bg-red-100 text-red-800' :
                                        task.priority === 'medium' ? 'bg-yellow-100 text-yellow-800' :
                                          'bg-green-100 text-green-800'
                                        }`}>
                                        {task.priority} priority
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Footer Actions */}
                    <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                      <div className="flex space-x-3">
                        <button
                          onClick={() => {
                            setShowInactiveModal(false);
                            setEmployeeToToggle(null);
                            setInactiveTasks([]);
                            setSelectedTasks([]);
                            setUpdatingEmployeeStatus(null);
                          }}
                          className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleShiftTasksClick}
                          disabled={selectedTasks.length === 0}
                          className="flex-1 px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg hover:from-purple-700 hover:to-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Shift {selectedTasks.length} Task{selectedTasks.length !== 1 ? 's' : ''} & Deactivate
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Shift Task Modal */}
              {showShiftTaskModal && selectedTasks.length > 0 && (
                <ShiftTaskModal
                  tasks={inactiveTasks.filter(task => selectedTasks.includes(task._id))}
                  onClose={handleCancelShift}
                  onShiftSuccess={handleShiftSuccess}
                />
              )}
            </div>
          ) : (
            <div className="bg-white rounded-xl shadow-md p-8 text-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16 mx-auto text-gray-400 mb-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>

            </div>
          )
        }
      </div>
    </div>
  );
};

export default AddEmployee;


